// AUTO-GENERATED from the legacy iConnect specservice.js - do not hand-edit.
// Each partner: { id, name, missing?, customMessage?, fullName?, imgFileName?, ediDocs? }
// ediDocs row = [transaction, ediDoc, dateUpdated, downloadType, file]  OR  [sectionHeader] (a divider row).
// downloadType is "PDF" or "Web Site". If `file` starts with http it is an external URL;
// otherwise it lives at https://www.iconnect-corp.com/specifications/vendors/<id>/<file>
// (linked to the live production site - the ~1.9 GB of spec PDFs are not bundled here).

export const PARTNER_SPECS = [
  {
    "id": "atkearney",
    "name": "A.T. Kearney",
    "ediDocs": [
      [
        "EDI Guide",
        "N/A",
        "08/02/2007",
        "PDF",
        "ATK_Supplier_EDI_Connectivity_Guide.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Abbott Laboratories",
    "missing": true
  },
  {
    "id": "missing",
    "name": "ABA of America",
    "missing": true
  },
  {
    "id": "abbottlabs",
    "name": "Abbott Laboratories",
    "missing": true
  },
  {
    "id": "abcgroup",
    "name": "ABC Group",
    "ediDocs": [
      [
        "Release",
        "830",
        "05/28/1998",
        "PDF",
        "AIAG_Generic_830.pdf"
      ],
      [
        "Shipping Notice",
        "856",
        "05/28/1998",
        "PDF",
        "AIAG_Generic_856.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Academy Sports",
    "missing": true
  },
  {
    "id": "accessbusinessgroup",
    "name": "Access Business Group",
    "ediDocs": [
      [
        "Procurement Guide",
        "All Transactions",
        "03/10/2008",
        "PDF",
        "Procurement_Implementation_Guide_03_10_08.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Accurcast Inc.",
    "missing": true
  },
  {
    "id": "acehardware",
    "name": "Ace Hardware",
    "ediDocs": [
      [
        "All Specs",
        "N/A",
        "N/A",
        "Web Site",
        "http://www.acehardware-vendors.com/locations/forms/edi/index.asp"
      ],
      [
        "Invoice",
        "810",
        "07/01/2010",
        "PDF",
        "http://www.acehardware-vendors.com/locations/forms/edi/pdfs/810map.pdf"
      ],
      [
        "Invoice Credit Memo",
        "810",
        "07/01/2010",
        "PDF",
        "810Credit.pdf"
      ],
      [
        "Remittance Advice",
        "820",
        "03/01/2007",
        "PDF",
        "http://www.acehardware-vendors.com/locations/forms/edi/pdfs/820DocMap.pdf"
      ],
      [
        "Shipping Notice",
        "856",
        "11/01/2011",
        "PDF",
        "856Map.pdf"
      ],
      [
        "Text Message",
        "864",
        "03/01/2010",
        "PDF",
        "http://www.acehardware-vendors.com/locations/forms/edi/pdfs/864Map.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "ACI Electronics",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Acme-Monaco Corporation",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Actown Amveco, Inc.",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Actuant - PowerPacker",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Acument Global Technologies",
    "missing": true
  },
  {
    "id": "adacautomotive",
    "name": "ADAC Automotive Inc.",
    "ediDocs": [
      [
        "Release",
        "830",
        "08/22/2013",
        "PDF",
        "830specs1.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "09/12/2006",
        "PDF",
        "http://www.adacautomotive.com/PDF/856specs.pdf"
      ],
      [
        "Shipping Schedule",
        "862",
        "08/22/2013",
        "PDF",
        "862specs1.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Adkev",
    "missing": true
  },
  {
    "id": "missing",
    "name": "ADM",
    "missing": true
  },
  {
    "id": "advanceautoparts",
    "name": "Advance Auto Parts",
    "ediDocs": [
      [
        "Load Tender",
        "204",
        "02/16/2016",
        "PDF",
        "EDI 204 Load Tender.pdf"
      ],
      [
        "Load Status",
        "214",
        "02/17/2016",
        "PDF",
        "EDI 214 Load Status.pdf"
      ],
      [
        "Invoice",
        "810",
        "04/30/2025",
        "PDF",
        "AAP_810_Inbound_4010_v2_9_3.pdf"
      ],
      [
        "Application Advice",
        "824",
        "04/30/2025",
        "PDF",
        "AAP_824_Outbound_4010_v1_2.pdf"
      ],
      [
        "Release",
        "830",
        "06/21/2023",
        "PDF",
        "AAP_830_Outbound_4010_v1.4"
      ],
      [
        "Inventory Inquiry Advice",
        "846",
        "04/30/2025",
        "PDF",
        "AAP_846_Inbound_4010_v1_2.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "04/30/2025",
        "PDF",
        "AAP_850_Outbound_4010_v2_5_Domestic.pdf"
      ],
      [
        "Product Activity Report",
        "852",
        "04/27/2011",
        "PDF",
        "AAP_Specs_852_Product_Activity_Report_v002.pdf"
      ],
      [
        "Purchase Order Request and Acceptance",
        "855",
        "04/30/2025",
        "PDF",
        "AAP_855_Inbound_4010_v1_9_1.pdf"
      ],
      [
        "Advance Ship Notice",
        "856",
        "04/30/2025",
        "PDF",
        "AAP_856_Inbound_4010_v4_4.pdf"
      ],
      [
        "Purchase Order Change",
        "860",
        "04/30/2025",
        "PDF",
        "AAP_860_Outbound_4010_v2_7_Domestic.pdf"
      ],
      [
        "Purchase Order Change Acceptance",
        "865",
        "02/02/2016",
        "PDF",
        "AAP_865_Companion.pdf"
      ],
      [
        "Load Tender Response",
        "990",
        "02/16/2016",
        "PDF",
        "EDI 990 Load Tender Response Specifications.pdf"
      ],
      [
        "Functional Acknowledgement",
        "997",
        "04/30/2025",
        "PDF",
        "AAP_997_Acknowledgement_4010_v2_3.pdf"
      ],
      [
        "EDI Contacts",
        "",
        "",
        "PDF",
        "EDI Contact Info_2017.pdf"
      ],
      [
        "Shipping Label",
        "",
        "11/22/2023",
        "PDF",
        "AAP and CQ EDI Barcode Shipping Label Guide_V4.1.pdf"
      ],
      [
        "FAQ",
        "",
        "04/30/2025",
        "PDF",
        "EDI_FAQ_V7.2_2025.04.30.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Advance Die Casting",
    "missing": true
  },
  {
    "id": "missing",
    "name": "AEL/Span",
    "missing": true
  },
  {
    "id": "aerostar",
    "name": "Aerostar Manufacturing",
    "customMessage": true,
    "ediDocs": [
      [
        "Release",
        "830",
        "08/08/2023",
        "PDF",
        "AerostarManufacturing_Supplier_830_v04010_20230808.pdf"
      ]
    ]
  },
  {
    "id": "aetna",
    "name": "Aetna",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "10/10/2005",
        "PDF",
        "810vdr4010specs.pdf"
      ],
      [
        "Remittance Advice",
        "824",
        "10/01/1998",
        "PDF",
        "824vdr4010specs.pdf"
      ],
      [
        "Functional Acknowledgment",
        "997",
        "06/11/2001",
        "PDF",
        "997vdr4010spec.pdf"
      ]
    ]
  },
  {
    "id": "agco",
    "name": "Agco Corporation",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "07/09/2008",
        "PDF",
        "Segment Map 810i.pdf"
      ],
      [
        "Release",
        "830",
        "04/07/2004",
        "PDF",
        "Segment Map 830o.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "02/23/2015",
        "PDF",
        "Segment Map 850o.pdf"
      ],
      [
        "Purchase Order Acknowledgment",
        "855",
        "10/10/2014",
        "PDF",
        "Segment Map 855i.pdf"
      ],
      [
        "Ship Notice/Manifest",
        "856",
        "07/09/2008",
        "PDF",
        "Segment Map 856i.pdf"
      ],
      [
        "Purchase Order Change Request",
        "860",
        "02/23/2015",
        "PDF",
        "Segment Map 860o.pdf"
      ],
      [
        "Shipping Label Guidelines",
        "",
        "May 2014",
        "PDF",
        "AGCO NA Bar Code label information.pdf"
      ]
    ]
  },
  {
    "id": "AGSimpson",
    "name": "AG Simpson",
    "ediDocs": [
      [
        "Release",
        "830",
        "07/08/2016",
        "PDF",
        "AGS 830 v4010 revised.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "02/04/2000",
        "PDF",
        "AGS 856 v4010.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "AIM",
    "missing": true
  },
  {
    "id": "missing",
    "name": "AINAK",
    "missing": true
  },
  {
    "id": "missing",
    "name": "AirSept Inc.",
    "missing": true
  },
  {
    "id": "awnc",
    "name": "Aisin World North America",
    "ediDocs": [
      [
        "Release",
        "830",
        "03/01/1999",
        "PDF",
        "AWNC EDI Specification - 830 (Firm Requirements).pdf"
      ],
      [
        "Shipping Notice",
        "856",
        "03/01/1999",
        "PDF",
        "AWNC EDI Specification - 856 (Advanced Shipment Notice).pdf"
      ],
      [
        "Functional Acknowledgment",
        "997",
        "03/01/1999",
        "PDF",
        "AWNC EDI Specification - 997.pdf"
      ]
    ]
  },
  {
    "id": "akebono",
    "name": "Akebono",
    "ediDocs": [
      [
        "Release",
        "830",
        "05/20/2010",
        "PDF",
        "Akebono 830 EDI Spec.pdf"
      ],
      [
        "Shipping Notice",
        "856",
        "05/21/2010",
        "PDF",
        "Akebono 856 EDI EE Spec.pdf"
      ]
    ]
  },
  {
    "id": "akwel",
    "name": "Akwel",
    "ediDocs": [
      [
        "Release",
        "830",
        "04/01/1996",
        "PDF",
        "Akwel_830x.pdf"
      ],
      [
        "Shipping Notice",
        "856",
        "05/01/2019",
        "PDF",
        "Akwel_856x.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Alameda Electric",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Alco Stores",
    "missing": true
  },
  {
    "id": "alcoa",
    "name": "Alcoa Fujikura Limited",
    "ediDocs": [
      [
        "Release",
        "830",
        "04/14/2004",
        "PDF",
        "Alcoa_AFL_830_3040.pdf"
      ],
      [
        "Shipping Notice",
        "856",
        "04/14/2004",
        "PDF",
        "Alcoa_AFL_856_3040.pdf"
      ],
      [
        "Shipping Schedule",
        "862",
        "04/14/2004",
        "PDF",
        "Aloca_AFL_862.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Alex Products Inc.",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Algoma Steel",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Algonquin Automotive",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Alice Manufacturing",
    "missing": true
  },
  {
    "id": "missing",
    "name": "All American Semiconductor",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Allegheny Powder Metallurgy",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Allied Services",
    "missing": true
  },
  {
    "id": "allisontransmission",
    "name": "Allison Transmission",
    "ediDocs": [
      [
        "Advance Ship Notice",
        "DESADV",
        "01/10/2008",
        "PDF",
        "Allison_Transmission_Desadv_Version_05.pdf"
      ],
      [
        "Delivery Schedule",
        "DELFOR",
        "01/18/2006",
        "PDF",
        "Allison_Transmission_Delfor_Version_05.pdf"
      ]
    ]
  },
  {
    "id": "alpsauto",
    "name": "Alps Automotive",
    "ediDocs": [
      [
        "All",
        "824, 830, 850, 856, 861, 862, 864, 997",
        "01/01/2007",
        "PDF",
        "AlpsAutoAll.pdf"
      ]
    ]
  },
  {
    "id": "altraindustrial",
    "name": "Altra Industrial Motion",
    "ediDocs": [
      [
        "Warner Electric"
      ],
      [
        "Invoice",
        "810",
        "03/31/2008",
        "PDF",
        "EDI_INVOICE_SPEC_WARNER_ELECTRIC.pdf"
      ]
    ]
  },
  {
    "id": "amgeneral",
    "name": "AM General",
    "ediDocs": [
      [
        "Release",
        "830",
        "03/01/2010",
        "PDF",
        "AMG830_I_G.pdf"
      ],
      [
        "Shipping Notice",
        "856",
        "07/15/2009",
        "PDF",
        "AMG856_I_G.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Amarr Garage Door",
    "missing": true
  },
  {
    "id": "amazon",
    "name": "Amazon",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "09/30/2013",
        "PDF",
        "AMZ_Procurement_810_MappingGuide.1.1.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "02/08/2013",
        "PDF",
        "AMZ_Procurement_850_MappingGuide.pdf"
      ],
      [
        "Purchase Order Acknowledgement",
        "855",
        "10/14/2014",
        "PDF",
        "AMZ_Procurement_855_MappingGuide.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "08/22/2013",
        "PDF",
        "AMZ_Procurement_856_MappingGuide_1.4.pdf"
      ],
      [
        "Invoice - FAQ",
        "810",
        "",
        "PDF",
        "AMZN_Procurement_810_FAQ.1.1.pdf"
      ],
      [
        "Purchase Order - FAQ",
        "850",
        "",
        "PDF",
        "AMZN_Procurement_850_FAQ.pdf"
      ],
      [
        "Ship Notice - FAQ",
        "856",
        "",
        "PDF",
        "AMZN_Procurement_856_FAQ_1.6.pdf"
      ],
      [
        "Ship Notice - Validation Rules",
        "856",
        "",
        "PDF",
        "ASN Validation Rules.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Amerada Hess Oil",
    "missing": true
  },
  {
    "id": "americanaxle",
    "name": "American Axle & Manufacturing",
    "ediDocs": [
      [
        "Advance Ship Notice",
        "DESADV",
        "06/18/2004",
        "PDF",
        "AAM_DESADV_97A.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "American Building Supply",
    "missing": true
  },
  {
    "id": "missing",
    "name": "American Efrid",
    "missing": true
  },
  {
    "id": "missing",
    "name": "American LaFrance",
    "missing": true
  },
  {
    "id": "missing",
    "name": "American Mitsuba",
    "missing": true
  },
  {
    "id": "apd",
    "name": "American Product Distributors",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "04/23/2008",
        "PDF",
        "APD810.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "11/11/2003",
        "PDF",
        "APD8504010.pdf"
      ]
    ]
  },
  {
    "id": "americanshowa",
    "name": "American Showa",
    "ediDocs": [
      [
        "Release",
        "830",
        "02/20/2007",
        "PDF",
        "X12_MaterialRelease_Spec.pdf"
      ],
      [
        "Advance Ship Notice",
        "856",
        "02/20/2007",
        "PDF",
        "X12_ASN_Spec.pdf"
      ],
      [
        "Ship Schedule",
        "862",
        "02/20/2007",
        "PDF",
        "X12_ShippingSchedule_Spec.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "American Sun",
    "missing": true
  },
  {
    "id": "missing",
    "name": "American Trim",
    "missing": true
  },
  {
    "id": "americold",
    "name": "Americold",
    "ediDocs": [
      [
        "All Specs",
        "N/A",
        "N/A",
        "Web Site",
        "http://www.americold.com/technology/edi.aspx"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Amerigas",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Amerigon Inc.",
    "missing": true
  },
  {
    "id": "missing",
    "name": "AMF Support Surfaces, Inc.",
    "missing": true
  },
  {
    "id": "amstedrail",
    "name": "Amsted Rail",
    "imgFileName": "amstedrail.bmp",
    "ediDocs": [
      [
        "Purchase Order (4010)",
        "850",
        "07/26/2011",
        "PDF",
        "AmstedPOSpecs.pdf"
      ],
      [
        "Purchase Order Acknowledgment (4010)",
        "855",
        "07/26/2011",
        "PDF",
        "Amsted855Specs.pdf"
      ]
    ]
  },
  {
    "id": "amtex",
    "name": "Amtex",
    "fullName": "Amtex Inc.",
    "ediDocs": [
      [
        "Applicvation Advise",
        "824",
        "09/17/2007",
        "PDF",
        "824.pdf"
      ],
      [
        "Release",
        "830",
        "09/17/2007",
        "PDF",
        "830.pdf"
      ],
      [
        "Release Addendum",
        "830",
        "10/10/2007",
        "PDF",
        "830-3060.pdf"
      ],
      [
        "Ship Notice Addendum",
        "856",
        "07/28/2008",
        "PDF",
        "856-3060.pdf"
      ],
      [
        "Shipping Schedule",
        "862",
        "09/17/2007",
        "PDF",
        "862.pdf"
      ],
      [
        "Shipping Schedule Addendum",
        "862",
        "10/10/2007",
        "PDF",
        "862-3060.pdf"
      ],
      [
        "Functional Acknowledgement",
        "997",
        "10/10/2007",
        "PDF",
        "997.pdf"
      ],
      [
        "Ship Notice Error Codes",
        "N/A",
        "09/15/2007",
        "PDF",
        "856 Error codes-msgs.pdf"
      ],
      [
        "Packaging Identification Standard",
        "N/A",
        "10/22/2008",
        "PDF",
        "B3STD_Labels.pdf"
      ],
      [
        "EDI Contact List",
        "N/A",
        "09/21/2007",
        "PDF",
        "EDINAMES.pdf"
      ],
      [
        "Implementation Guidelines",
        "N/A",
        "10/31/2007",
        "PDF",
        "GUIDELN.pdf"
      ],
      [
        "I.D. Code Assignments",
        "N/A",
        "10/12/2007",
        "PDF",
        "IDCODES.pdf"
      ],
      [
        "Interchange Area Table",
        "N/A",
        "09/17/2007",
        "PDF",
        "ISA.pdf"
      ],
      [
        "Supplier EDI Profile",
        "N/A",
        "10/10/2007",
        "DOC",
        "PROFILE.doc"
      ]
    ]
  },
  {
    "id": "ancillary_advantage",
    "name": "Ancillary Advantage",
    "fullName": "Ancillary Advantage Inc.",
    "ediDocs": [
      [
        "Purchase Order (4010)",
        "850",
        "05/31/2012",
        "PDF",
        "Ancillary_850.pdf"
      ]
    ]
  },
  {
    "id": "android",
    "name": "Android Industries",
    "ediDocs": [
      [
        "Shreveport Sending to General Motors"
      ],
      [
        "Delivery Schedule Message",
        "DELFOR",
        "07/31/2008",
        "PDF",
        "AIShreveport-DELFOR.pdf"
      ],
      [
        "Delivery Just In Time Message",
        "DELJIT",
        "07/31/2008",
        "PDF",
        "AIShreveport-DELJIT.pdf"
      ],
      [
        "Despatch Advise Message",
        "DESADV",
        "07/31/2008",
        "PDF",
        "AIShreveport-DESADV.pdf"
      ],
      [
        "Android Mexico Spec's"
      ],
      [
        "Delivery Schedule Message",
        "DELFOR",
        "",
        "PDF",
        "AIBrazil-DELFOR.pdf"
      ],
      [
        "Delivery Just In Time Message",
        "DELJIT",
        "",
        "PDF",
        "AIBrazil-DELJIT.pdf"
      ],
      [
        "Despatch Advise Message",
        "DESADV",
        "",
        "PDF",
        "AIBrazil-DESADV.pdf"
      ],
      [
        "EDI Information",
        "",
        "",
        "PDF",
        "EDI info.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Angers",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Anixter Inc.",
    "missing": true
  },
  {
    "id": "ap_plasman",
    "name": "A.P.Plasman",
    "ediDocs": [
      [
        "Planning Schedule",
        "830",
        "",
        "PDF",
        "AP Plasman EDI 830 Specifications.pdf"
      ],
      [
        "Ship Notice/manifest",
        "856",
        "",
        "PDF",
        "EDI 856 Specifications AP Plasman.pdf"
      ],
      [
        "All EDI Documents",
        "All",
        "02/01/2006",
        "PDF",
        "TRANS4M_EDI824.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Apex Spring & Stamping Corp.",
    "missing": true
  },
  {
    "id": "aptiv",
    "name": "Aptiv",
    "imgFileName": "aptiv.png",
    "ediDocs": [
      [
        "Delivery Forecast",
        "DELFOR",
        "04/26/2019",
        "PDF",
        "APTIV EDIFACT DELFOR 97A v3.1.pdf"
      ],
      [
        "Ship Schedule",
        "DELJIT",
        "04/26/2019",
        "PDF",
        "APTIV EDIFACT DELJIT 97A v2.0.pdf"
      ],
      [
        "Despatch Advice",
        "DESADV",
        "04/26/2019",
        "PDF",
        "APTIV EDIFACT DESADV D.97A v2.0.pdf"
      ],
      [
        "Invoice Message",
        "INVOIC",
        "04/26/2019",
        "PDF",
        "APTIV EDIFACT INVOIC D.97A v1.4.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "ArcelorMittal",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Ariens",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Armada Rubber Mfg",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Armada Tool Works Ltd",
    "missing": true
  },
  {
    "id": "aafes",
    "name": "Army and Air Force Exchange Service",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "01/18/2011",
        "PDF",
        "AAFES_5010_810_V1.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "01/29/2010",
        "PDF",
        "AAFES_5010_850_v1.pdf"
      ],
      [
        "Advance Ship Notice",
        "856",
        "12/16/2015",
        "PDF",
        "AAFES 5010_856_V1.pdf"
      ],
      [
        "Purchase Order Change Request - Buyer Initiated",
        "860",
        "02/10/2010",
        "PDF",
        "AAFES_5010_860_V1.pdf"
      ]
    ]
  },
  {
    "id": "arnecom",
    "name": "Arnecom",
    "customMessage": true,
    "imgFileName": "arnecom.gif",
    "ediDocs": [
      [
        "Purchase Order",
        "850",
        "11/03/2006",
        "PDF",
        "arnecom_850_004010.pdf"
      ],
      [
        "Advance Ship Notice",
        "856",
        "11/02/2007",
        "PDF",
        "arnecom_856_004010.pdf"
      ],
      [
        "Functional Acknowledgement",
        "997",
        "N/A",
        "N/A",
        null
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Artissimo Prints",
    "missing": true
  },
  {
    "id": "arvinmeritor",
    "name": "Arvin Meritor",
    "ediDocs": [
      [
        "Commercial Vehicle Systems (CVS) Division Americas"
      ],
      [
        "Invoice",
        "810",
        "09/23/2007",
        "PDF",
        "http://tradeexchange.arvinmeritor.com/SupplierDir/edi/ArvinMeritor%20CVS%20EDI810%20Ver%204010%20V2.pdf"
      ],
      [
        "Release",
        "830",
        "08/01/2005",
        "PDF",
        "http://tradeexchange.arvinmeritor.com/SupplierDir/edi/ArvinMeritor%20CVS%20EDI830%20Ver2002%20V3.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "05/12/2008",
        "PDF",
        "http://tradeexchange.arvinmeritor.com/SupplierDir/edi/ARM%20850.pdf"
      ],
      [
        "Ship Notice (3040)",
        "856",
        "09/23/2007",
        "PDF",
        "http://tradeexchange.arvinmeritor.com/SupplierDir/edi/ArvinMeritor%20CVS%20EDI856%20Ver3040%20v4.pdf"
      ],
      [
        "Ship Notice (4010)",
        "856",
        "09/23/2007",
        "PDF",
        "http://tradeexchange.arvinmeritor.com/SupplierDir/edi/ArvinMeritor%20CVS%20EDI856%20Ver3040%20v4.pdf"
      ],
      [
        "Light Vehicle Systems (LVS) Division"
      ],
      [
        "Release",
        "830",
        "03/19/2007",
        "PDF",
        "http://tradeexchange.arvinmeritor.com/SupplierDir/edi/830%20Planning%20Forecast_v4010.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "05/24/2007",
        "PDF",
        "http://tradeexchange.arvinmeritor.com/SupplierDir/edi/856%20Advanced%20Ship%20Notice_v4010.pdf"
      ],
      [
        "Shipping Schedule",
        "862",
        "03/19/2007",
        "PDF",
        "http://tradeexchange.arvinmeritor.com/SupplierDir/edi/862%20Shipping%20Schedule_v4010.pdf"
      ],
      [
        "Barcode Labels",
        "N/A",
        "01/15/2008",
        "PDF",
        "http://tradeexchange.arvinmeritor.com/SupplierDir/edi/B-10%20LVS%20NA-SA%20Label%20Spec_1-15-08%20.pdf"
      ],
      [
        "ArvinMeritor Corporate Supplier EDI"
      ],
      [
        "ArvinMeritor Enveloping Structures ",
        "N/A",
        "10/25/2003",
        "PDF",
        "http://tradeexchange.arvinmeritor.com/SupplierDir/edi/ENV_4010.pdf"
      ],
      [
        "Application Advise",
        "824",
        "01/14/2004",
        "PDF",
        "http://tradeexchange.arvinmeritor.com/SupplierDir/edi/ARM824_4010_011404.pdf"
      ],
      [
        "Release",
        "830",
        "02/10/2004",
        "PDF",
        "http://tradeexchange.arvinmeritor.com/SupplierDir/edi/ARM830_4010_021004.pdf"
      ],
      [
        "Price Sales Catalog",
        "832",
        "01/09/2004",
        "PDF",
        "http://tradeexchange.arvinmeritor.com/SupplierDir/edi/ARM832_4010.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "05/13/2004",
        "PDF",
        "http://tradeexchange.arvinmeritor.com/SupplierDir/edi/ARM856_4010_20040513.pdf"
      ],
      [
        "Receiving Advice",
        "861",
        "01/14/2004",
        "PDF",
        "http://tradeexchange.arvinmeritor.com/SupplierDir/edi/ARM861_4010_011404.pdf"
      ],
      [
        "Shipping Schedule (with Kanban)",
        "862",
        "11/19/2003",
        "PDF",
        "http://tradeexchange.arvinmeritor.com/SupplierDir/edi/ARM862_4010_111903.pdf"
      ],
      [
        "Functional Acknowledgement",
        "997",
        "09/09/2003",
        "PDF",
        "http://tradeexchange.arvinmeritor.com/SupplierDir/edi/ARM997_4010.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Asahi Kasei Plastics",
    "missing": true
  },
  {
    "id": "asc",
    "name": "ASC Inc.",
    "ediDocs": [
      [
        "Release",
        "830",
        "12/19/2003",
        "PDF",
        "Supplier_EDI_Guidebook_830.pdf"
      ],
      [
        "Release Interchange Structure",
        "830",
        "09/22/2003",
        "PDF",
        "IntChg_CtlStructure_830ANX.pdf"
      ],
      [
        "Release Looping Structure",
        "830",
        "08/31/1999",
        "PDF",
        "830_Looping_Structure.pdf"
      ],
      [
        "Release Field Values",
        "830",
        "04/23/2008",
        "PDF",
        "Supplier_EDI_Guidebook_830Element_Values.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "04/23/2008",
        "PDF",
        "Supplier_EDI_Guidebook_856.pdf"
      ],
      [
        "Ship Notice Interchange Structure",
        "856",
        "05/12/1999",
        "PDF",
        "IntChg_CtlStructure_856.pdf"
      ],
      [
        "Ship Notice Looping Structure",
        "856",
        "02/19/2004",
        "PDF",
        "856_Looping_Structure.pdf"
      ],
      [
        "Ship Notice Field Values",
        "856",
        "04/30/1999",
        "PDF",
        "Supplier_EDI_Guidebook_856Element_Values.pdf"
      ],
      [
        "Receiving Label",
        "Label",
        "04/23/2008",
        "PDF",
        "ASC Receiving Label Standard SSR Specific.pdf"
      ]
    ]
  },
  {
    "id": "associatedfood",
    "name": "Associated Food Stores",
    "ediDocs": [
      [
        "Grocery Products Purchase Order (4010)",
        "875",
        "02/06/2012",
        "PDF",
        "AFS_875_PO.pdf"
      ],
      [
        "Grocery Products Invoice (4010)",
        "880",
        "02/06/2012",
        "PDF",
        "AFS_880_Invoice.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Associated Spring",
    "missing": true
  },
  {
    "id": "aunde",
    "name": "Aunde",
    "fullName": "Aunde Mexico S.A. de C.V.",
    "customMessage": true,
    "ediDocs": [
      [
        "Delivery Schedule Message",
        "DELFOR",
        "08/11/2010",
        "PDF",
        "Aunde_DELFOR.pdf"
      ],
      [
        "Despatch Advice Message",
        "DESADV",
        "08/11/2010",
        "PDF",
        "Aunde_DESADV.pdf"
      ]
    ]
  },
  {
    "id": "autokabel",
    "name": "AutoKabel",
    "ediDocs": [
      [
        "EDI Specifications",
        "All Transcations",
        "07/06/2005",
        "PDF",
        "Auto Kabel 20050706 Supplier EDI Implementation Guide Revision 2.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "AutoAnything",
    "missing": true
  },
  {
    "id": "autoliv",
    "name": "Autoliv",
    "imgFileName": "autoliv.png",
    "ediDocs": [
      [
        "EDIFACT Versions"
      ],
      [
        "Self Billing Invoice",
        "INVOIC",
        "09/05/2005",
        "PDF",
        "AS242-4_INVOICE_version1.pdf"
      ],
      [
        "Despatch Advise Message",
        "DESADV",
        "09/05/2005",
        "PDF",
        "AS242-2_DESADV_version1.pdf"
      ],
      [
        "Delivery Schedule Message",
        "DELFOR",
        "09/05/2005",
        "PDF",
        "AS242-1_DELFOR_version1.pdf"
      ],
      [
        "Delivery Just In Time Message",
        "DELJIT",
        "09/05/2005",
        "PDF",
        "AS242-3_DELJIT_version1.pdf"
      ],
      [
        "4010 Versions"
      ],
      [
        "Remittance Advice",
        "820",
        "08/17/2001",
        "PDF",
        "Autoliv EDI 820 v4010.pdf"
      ],
      [
        "Application Advice",
        "824",
        "03/12/2009",
        "PDF",
        "Autoliv EDI 824 v4010.pdf"
      ],
      [
        "Planning Schedule",
        "830",
        "01/30/2008",
        "PDF",
        "Autoliv EDI 830 v4010.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "12/08/2008",
        "PDF",
        "Autoliv EDI 850 v4010.pdf"
      ],
      [
        "Purchase Order Acknowledgement",
        "855",
        "12/08/2008",
        "PDF",
        "Autoliv EDI 855 v4010.pdf"
      ],
      [
        "Advanced Ship Notice",
        "856",
        "01/21/2008",
        "PDF",
        "Autoliv EDI 856 v4010.pdf"
      ],
      [
        "Shipping Schedule",
        "862",
        "09/02/2009",
        "PDF",
        "Autoliv EDI 862 v4010.pdf"
      ],
      [
        "Functional Acknowledgement",
        "997",
        "03/29/2002",
        "PDF",
        "Autoliv EDI 997 v4010.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Automated Media, Inc (AMI)",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Automatic Precision, Inc.",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Automotive Component Holdings",
    "missing": true
  },
  {
    "id": "autozone",
    "name": "AutoZone",
    "customMessage": true
  },
  {
    "id": "missing",
    "name": "Autrans",
    "missing": true
  },
  {
    "id": "avaya",
    "name": "Avaya Communications",
    "ediDocs": [
      [
        "Purchase Order",
        "850",
        "07/29/2003",
        "PDF",
        "850_3020.pdf"
      ],
      [
        "Purchase Order Acknowledgement",
        "855",
        "07/29/2003",
        "PDF",
        "855_3020.pdf"
      ],
      [
        "Shipping Notice",
        "856",
        "07/29/2003",
        "PDF",
        "856_3020.pdf"
      ],
      [
        "Invoice",
        "810",
        "07/29/2003",
        "PDF",
        "810_3020.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Avdel",
    "missing": true
  },
  {
    "id": "missing",
    "name": "AVM Industries LLC",
    "missing": true
  },
  {
    "id": "avonauto",
    "name": "Avon Automotive",
    "imgFileName": "avonauto.png",
    "ediDocs": [
      [
        "Planning Schedule with Release Capability",
        "830",
        "April, 1996",
        "PDF",
        "830x.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "April, 1996",
        "PDF",
        "856x.pdf"
      ]
    ]
  },
  {
    "id": "awtec",
    "name": "AW Transmission Engineering (AwTecC)",
    "customMessage": true,
    "ediDocs": [
      [
        "Wayne Plant"
      ],
      [
        "Trading Partner Request Form",
        "N/A",
        "02/01/1998",
        "DOC",
        "EDI_Profile_AWTEC.doc"
      ],
      [
        "Release",
        "830",
        "02/01/1998",
        "PDF",
        "830.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "02/01/1998",
        "PDF",
        "856.pdf"
      ],
      [
        "Shipping Schedule",
        "862",
        "02/01/1998",
        "PDF",
        "862.pdf"
      ],
      [
        "Functional Acknowlegdement",
        "997",
        "02/01/1998",
        "PDF",
        "997.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Axle Tech",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Bank of America",
    "missing": true
  },
  {
    "id": "missing",
    "name": "BASF Canada",
    "missing": true
  },
  {
    "id": "missing",
    "name": "BASF Mexicana",
    "missing": true
  },
  {
    "id": "basspro",
    "name": "Bass Pro",
    "imgFileName": "basspro.png",
    "ediDocs": [
      [
        "810 Additional Notes",
        "810",
        "",
        "DOC",
        "810 Additional Notes.doc"
      ],
      [
        "Invoice",
        "810",
        "",
        "DOC",
        "810 IN Map.doc"
      ],
      [
        "Ship Notice",
        "856",
        "",
        "DOC",
        "856 SH Map.doc"
      ],
      [
        "EDI Testing Guidelines",
        "",
        "",
        "DOC",
        "EDI Testing Guidelines.doc"
      ],
      [
        "EDI Vendor Violations",
        "",
        "",
        "DOC",
        "EDI Vendor Violations.doc"
      ],
      [
        "General EDI Requirements",
        "",
        "",
        "DOC",
        "General EDI Requirements.doc"
      ],
      [
        "Sample 810 Invoice",
        "810",
        "",
        "DOC",
        "Sample 810 Invoice.doc"
      ],
      [
        "Sample 850 PO.doc",
        "850",
        "",
        "DOC",
        "Sample 850 PO.doc"
      ],
      [
        "Sample 856 ASN",
        "856",
        "",
        "DOC",
        "Sample 856 ASN.doc"
      ],
      [
        "Sample UCC128 Shipping Label",
        "",
        "",
        "DOC",
        "Sample UCC128 Shipping Label.doc"
      ],
      [
        "Standard Carrier Alpha Codes",
        "",
        "",
        "DOC",
        "Standard Carrier Alpha Codes.doc"
      ],
      [
        "Trading Partner Profile",
        "",
        "",
        "DOC",
        "Trading Partner Profile.doc"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Baumann Springs",
    "missing": true
  },
  {
    "id": "baxterhealthcare",
    "name": "Baxter Healthcare",
    "ediDocs": [
      [
        "Purchase Order",
        "850",
        "01/22/2024",
        "PDF",
        "Baxter EDI Guide X12 4010 850.pdf"
      ],
      [
        "Purchase Order Acknowledgment",
        "855",
        "02/16/2024",
        "PDF",
        "Baxter EDI Guide X12 4010 855.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "02/23/2024",
        "PDF",
        "Baxter EDI Guide X12 4010 856.pdf"
      ],
      [
        "Purchase Order Change Request",
        "860",
        "02/22/2024",
        "PDF",
        "Baxter EDI Guide X12 4010 860.pdf"
      ],
      [
        "Supplier EDI Guide",
        "N/A",
        "",
        "PDF",
        "Supplier EDI Companion Guide.pdf"
      ]
    ]
  },
  {
    "id": "BCS",
    "name": "BCS",
    "ediDocs": [
      [
        "Delivery Schedule Message",
        "DELFOR",
        "03/03/2020",
        "PDF",
        "BCS_DELFOR_D97A.pdf"
      ],
      [
        "Despatch Advice Message",
        "DESADV",
        "05/25/2020",
        "PDF",
        "BCS_DESADV_D97A.pdf"
      ]
    ]
  },
  {
    "id": "Bealls",
    "name": "Bealls",
    "ediDocs": [
      [
        "EDI Mapping Specifications",
        "All Transcations",
        "",
        "PDF",
        "Bealls EDI_Mapping_Specifications.pdf.pdf"
      ]
    ]
  },
  {
    "id": "bedbathbeyond",
    "name": "Bed Bath Beyond",
    "ediDocs": [
      [
        "All Transactions",
        "810, 816, 850, 856, 860, 864",
        "09/25/2008",
        "PDF",
        "http://vendor.bedbath.com/doc/ediMapping.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Beech-Nut Nutrition Corp.",
    "missing": true
  },
  {
    "id": "behr",
    "name": "Behr",
    "ediDocs": [
      [
        "Release",
        "830",
        "2/01/2011",
        "PDF",
        "GRIPS_830_V1-3.pdf"
      ],
      [
        "Advance Ship Notice",
        "856",
        "3/01/2010",
        "PDF",
        "GRIPS_856_V2-0.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Behrtec Supply Solution",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Bekaert Corp",
    "missing": true
  },
  {
    "id": "missing",
    "name": "BELK",
    "missing": true
  },
  {
    "id": "missing",
    "name": "BenchCraft",
    "missing": true
  },
  {
    "id": "bendix",
    "name": "Bendix",
    "ediDocs": [
      [
        "Release",
        "830",
        "",
        "PDF",
        "EDI 830 GENERATION SPEC w-Comments V4.pdf"
      ]
    ]
  },
  {
    "id": "bentelerauto",
    "name": "Benteler Automotive",
    "ediDocs": [
      [
        "Planning Schedule With Release Capability",
        "830",
        "03/19/2009",
        "PDF",
        "Benteler830.pdf"
      ],
      [
        "Ship Notice/Manifest",
        "856",
        "02/01/2003",
        "PDF",
        "Benteler856.pdf"
      ],
      [
        "Functional Acknowledgement",
        "997",
        "02/01/2003",
        "PDF",
        "Benteler997.pdf"
      ],
      [
        "Syntax And Service Report Message",
        "CONTRL",
        "01/30/2006",
        "PDF",
        "BentelerCONTRL.pdf"
      ],
      [
        "Functional Acknowledgement",
        "DELFOR",
        "03/19/2009",
        "PDF",
        "BentelerDELFOR.pdf"
      ],
      [
        "Delivery Just In Time Message",
        "DELJIT",
        "03/19/2009",
        "PDF",
        "BentelerDELJIT.pdf"
      ],
      [
        "Despatch Advice Message",
        "DESADV",
        "01/30/2006",
        "PDF",
        "BentelerDESADV.pdf"
      ],
      [
        "VDA Standards",
        "VDA4905",
        "01/30/2006",
        "PDF",
        "BentelerVDA4905.pdf"
      ],
      [
        "VDA Standards",
        "VDA4913",
        "01/30/2006",
        "PDF",
        "BentelerVDA4913.pdf"
      ]
    ]
  },
  {
    "id": "bestbuy",
    "name": "Best Buy",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "08/14/2015",
        "PDF",
        "BestBuy_810.pdf"
      ],
      [
        "Invoice SCAC Codes",
        "",
        "",
        "XLS",
        "BestBuy_810_SAC_Codes.xls"
      ],
      [
        "Purchase Order",
        "850",
        "11/13/2002",
        "PDF",
        "BestBuy_850.pdf"
      ],
      [
        "Product Activity Data",
        "852",
        "05/09/2005",
        "PDF",
        "BestBuy_852.pdf"
      ],
      [
        "Sales and Inventory Guide",
        "",
        "",
        "PDF",
        "BestBuy_852_SalesAndInventoryGuide.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "05/18/2010",
        "PDF",
        "BestBuy_856.pdf"
      ],
      [
        "Purchase Order Change",
        "860",
        "05/09/2005",
        "PDF",
        "BestBuy_860.pdf"
      ],
      [
        "Functional Acknowledgment",
        "997",
        "07/09/2003",
        "PDF",
        "BestBuy_997.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Bic Graphics",
    "missing": true
  },
  {
    "id": "missing",
    "name": "BIG5",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Bill Matrix",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Bing Group",
    "missing": true
  },
  {
    "id": "missing",
    "name": "BJ's Wholesale Club",
    "missing": true
  },
  {
    "id": "blackdecker",
    "name": "Black & Decker",
    "ediDocs": [
      [
        "Release",
        "830",
        "09/13/2007",
        "PDF",
        "BD830specs.pdf"
      ],
      [
        "Shipment and Billing Notice",
        "857",
        "09/13/2007",
        "PDF",
        "BD857specs.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Black River Companies",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Blaine Supply",
    "missing": true
  },
  {
    "id": "missing",
    "name": "BLD Products/Sloan Transportation",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Bloomberg L.P.",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Bloomingdales",
    "missing": true
  },
  {
    "id": "bluebird",
    "name": "Blue Bird Body Co.",
    "ediDocs": [
      [
        "Material Release Transaction Set",
        "830",
        "05/08/1996",
        "PDF",
        "EDI_Users_Manual_830.pdf"
      ],
      [
        "Advance Ship Notice/Manfest",
        "856",
        "07/07/2001",
        "PDF",
        "EDI_Users_Manual_856.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Blue Mountain Wallcoverings",
    "missing": true
  },
  {
    "id": "bluestem",
    "name": "Bluestem Brands, Inc.",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "09/28/2010",
        "PDF",
        "Bluestem_Brands_Invoice810_SPS.pdf.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "10/26/2010",
        "PDF",
        "Bluestem_Brands_PO850_SPS.pdf.pdf"
      ],
      [
        "Purchase Order Acknowledgement",
        "855",
        "04/11/2011",
        "PDF",
        "Bluestem_Brands_PO_Ack855_SPS.pdf.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "09/28/2010",
        "PDF",
        "Bluestem_Brands_ASN856_SPS.pdf.pdf"
      ],
      [
        "Purchase order Change Request",
        "860",
        "09/28/2010",
        "PDF",
        "Bluestem_Brands_PO_Change860_SPS.pdf.pdf"
      ],
      [
        "Purchase Order Change Acknowledgement",
        "865",
        "10/05/2010",
        "PDF",
        "Bluestem_Brands_PO_Change_Ack_SPS_865.pdf.pdf"
      ]
    ]
  },
  {
    "id": "bmw",
    "name": "BMW",
    "ediDocs": [
      [
        "STARD-EDI-Guidelines",
        "All",
        "10/13/2009",
        "PDF",
        "STARD-edi_guidelines.pdf"
      ],
      [
        "Production Sequence Standard",
        "866",
        "08/20/2010",
        "PDF",
        "866-Production_Sequence_BMW_specs.pdf"
      ],
      [
        "Release",
        "DELFOR",
        "07/16/2025",
        "PDF",
        "VDA4984_GlobalDELFOR_Call-Off_OUT_BMW_V2.1_en.pdf"
      ],
      [
        "Ship Notice",
        "DESADV",
        "07/04/2025",
        "PDF",
        "VDA4987_GlobalDESADV_Bulk_JIT_KANBAN_ASN_INB_BMW_V1.7_en.pdf"
      ],
      [
        "Packaging Examples",
        "DESADV",
        "12/01/2018",
        "PDF",
        "VDA4987_GlobalDESADV_Bulk_Packaging_Examples_BMW_V2.6_en.pdf"
      ],
      [
        "BMW Werk Steyr"
      ],
      [
        "Delivery note & Material tags 4902",
        "4913 & 4902",
        "03/14/2013",
        "PDF",
        "2013_VDA_INFO_engl_1403_tf_bb.pdf"
      ],
      [
        "Delivery Schedules",
        "4905",
        "",
        "PDF",
        "Supplier Implementation Guidelines - VDA4905.pdf"
      ],
      [
        "Self Billing Invoice",
        "4908",
        "",
        "PDF",
        "Supplier Implementation Guidelines - VDA4908.pdf"
      ],
      [
        "VFN"
      ],
      [
        "VFN Document",
        "",
        "08/01/2025",
        "PDF",
        "VFN_configuration_guide_08_2025.xlsx"
      ],
      [
        "Unloading Point"
      ],
      [
        "Unloading Point Document",
        "",
        "08/01/2025",
        "PDF",
        "Abladestellen_August_2025.xlsx"
      ],
      [
        "Samples"
      ],
      [
        "VDA 4905",
        "4905",
        "",
        "PDF",
        "Test-message_VDA4905.pdf"
      ],
      [
        "VDA 4913-1 Layer",
        "4913",
        "",
        "PDF",
        "Test-message_VDA4913_one_layer.pdf"
      ],
      [
        "VDA 4913-2 Layer",
        "4913",
        "",
        "PDF",
        "Test-message_VDA4913_two_layer.pdf"
      ],
      [
        "VDA 4984",
        "4984",
        "",
        "PDF",
        "Test-message_VDA4984.pdf"
      ],
      [
        "VDA 4987-1 Layer",
        "4987",
        "",
        "PDF",
        "Test-message_VDA4987_one_layer.pdf"
      ],
      [
        "VDA 4987-2 Layer",
        "4987",
        "",
        "PDF",
        "Test-message_VDA4987_two_layer.pdf"
      ],
      [
        "Production Sequence Standard",
        "866",
        "",
        "PDF",
        "ProductionSequenceStandardSample.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Bob Dale Gloves",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Bob Jones University",
    "missing": true
  },
  {
    "id": "bocargroup",
    "name": "BOCAR GROUP",
    "ediDocs": [
      [
        "Despatch Advice",
        "DELFOR",
        "02/17/2017",
        "PDF",
        "DELFOR-BOCAR V01A.pdf"
      ],
      [
        "DESADV EDIFACT ",
        "DESADV",
        "10/17/2016",
        "PDF",
        "DESADV-BOCAR V97A.pdf"
      ],
      [
        "ORDERS EDIFACT",
        "DESADV",
        "10/17/2016",
        "PDF",
        "ORDERS-BOCAR D01B.pdf"
      ]
    ]
  },
  {
    "id": "brp",
    "name": "Bombardier Recreational Products  (BRP)",
    "ediDocs": [
      [
        "SUPPLIER IMPLEMENTATION GUIDE ",
        "All",
        "07/03/2012",
        "PDF",
        "BRP_INC_SUPPLIER_EDI_GUIDELINES_V4010_version4.3_20120703.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "BONTON",
    "missing": true
  },
  {
    "id": "borgwarner",
    "name": "Borg Warner",
    "ediDocs": [
      [
        "Planning Schedule With Release Capability",
        "830",
        "02/06/2001",
        "PDF",
        "BorgWarner830.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "BOS Automotive Products",
    "missing": true
  },
  {
    "id": "bosch",
    "name": "Bosch",
    "ediDocs": [
      [
        "Release",
        "830",
        "01/12/2005",
        "PDF",
        "Bosch_830_4010.pdf"
      ],
      [
        "Shipping Notice",
        "856",
        "12/22/2004",
        "PDF",
        "Bosch_856_4010.pdf"
      ],
      [
        "Functional Acknowledgment",
        "997",
        "12/24/2004",
        "PDF",
        "Bosch_997_4010.pdf"
      ],
      [
        "Product Transfer and Resale Product",
        "867",
        "11/22/2010",
        "PDF",
        "BOSCH867.pdf"
      ],
      [
        "UBK Letter ",
        "",
        "01/27/2012",
        "PDF",
        "UBK Letter.pdf"
      ],
      [
        "Shipping Notice(Updated) ",
        "856",
        "09/02/2010",
        "PDF",
        "RBNA_UBK_856_4010.pdf"
      ],
      [
        "EDI Changes ",
        "",
        "09/02/2010",
        "Word",
        "RBNA_UBK_EDI_Changes.docx"
      ],
      [
        "Application Advice ",
        "824",
        "09/03/2010",
        "PDF",
        "RBNA_UBK_824_4010.pdf"
      ],
      [
        "Receiving Advice/Acceptance Certificate ",
        "861",
        "09/02/2010",
        "PDF",
        "RBNA_UBK_861_4010.pdf"
      ],
      [
        "Inventory Inquiry/Advice ",
        "846",
        "05/03/2004",
        "PDF",
        "BOSCH846.pdf"
      ],
      [
        "Planning Schedule with Release Capability ",
        "830",
        "09/02/2010",
        "PDF",
        "RBNA_UBK_830_4010.pdf"
      ],
      [
        "Functional Acknowledgment ",
        "997",
        "12/22/2004",
        "PDF",
        "RBNA_UBK_997_4010.pdf"
      ]
    ]
  },
  {
    "id": "boscov",
    "name": "BOSCOV",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "02/16/2011",
        "PDF",
        "BOSCOVS810mapguidedoc.pdf.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "May 2012",
        "PDF",
        "BOSCOVS850mapguidedoc.pdf.pdf"
      ],
      [
        "Purchase Order Acknowledgment",
        "855",
        "March 2011",
        "PDF",
        "BOSCOVS855mapguidedoc.pdf.pdf"
      ],
      [
        "Advance Ship Notice",
        "856",
        "March 2011",
        "PDF",
        "BOSCOVS856mapguidedoc.pdf.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Bose",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Bossard North America",
    "missing": true
  },
  {
    "id": "bostwick",
    "name": "Bostwick",
    "ediDocs": [
      [
        "Purchase Order",
        "850",
        "07/21/2011",
        "PDF",
        "BostwickBraum850.pdf"
      ],
      [
        "Purchase Order Acknowledgment",
        "855",
        "09/01/2011",
        "PDF",
        "BostwickBraum855.pdf"
      ]
    ]
  },
  {
    "id": "brain",
    "name": "Brain International",
    "ediDocs": [
      [
        "Advanced Ship Notice",
        "856",
        "01/05/2015",
        "PDF",
        "brain_desadv.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Brass Craft Co.",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Bridgestone/Firestone",
    "missing": true
  },
  {
    "id": "briggsstratton",
    "name": "Briggs & Stratton",
    "ediDocs": [
      [
        "Shipping Notice",
        "856",
        "03/01/2007",
        "PDF",
        "856_V4010.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Brighton Interior",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Brillcast",
    "missing": true
  },
  {
    "id": "brillion",
    "name": "Brillion Iron Works",
    "ediDocs": [
      [
        "Purchase Order",
        "850",
        "08/28/2002",
        "PDF",
        "Brillion_850_3060_v1.pdf"
      ],
      [
        "Purchase Order Acknowledgement",
        "855",
        "01/24/2003",
        "PDF",
        "Brillion_855_3060_v1.pdf"
      ],
      [
        "Shipping Notice",
        "856",
        "03/04/2003",
        "PDF",
        "Brillion_856_4010_v1.pdf"
      ],
      [
        "Release",
        "830",
        "01/24/2003",
        "PDF",
        "Brillion_830_4010_v1.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Brookshire",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Brose Canada Inc",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Brown Corporation",
    "missing": true
  },
  {
    "id": "brugola",
    "name": "Brugola",
    "ediDocs": [
      [
        "Delivery Forecast",
        "DELFOR",
        "01/09/2018",
        "PDF",
        "Brugola_DESADV.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Buckle",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Budd",
    "missing": true
  },
  {
    "id": "Bulten",
    "name": "Bulten",
    "ediDocs": [
      [
        "Delivery Schedule Message",
        "DELFOR",
        "",
        "PDF",
        "DELFOR Bultens Guidelines DELFOR V2.pdf"
      ],
      [
        "Despatch Advice Message",
        "DESADV",
        "",
        "PDF",
        "DESADV Bultens Guidelines DESADV V6.pdf"
      ]
    ]
  },
  {
    "id": "build",
    "name": "Build.com",
    "ediDocs": [
      [
        "All Transactions",
        "",
        "",
        "PDF",
        "Build.com EDI Spec. Book 3.0 (1) (1).pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Burlington Coat Facotory",
    "missing": true
  },
  {
    "id": "bnsf",
    "name": "Burlington Northern Santa Fe Corp",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "04/01/1998",
        "PDF",
        "Burlington_Northern_Santa_Fe_810_4010.pdf"
      ],
      [
        "Puchase Order",
        "850",
        "04/01/1998",
        "PDF",
        "Burlington_Northern_Santa_Fe_850_4010.pdf"
      ],
      [
        "Purchase Order Acknowledgement",
        "855",
        "04/01/1998",
        "PDF",
        "Burlington_Northern_Santa_Fe_855_4010.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "02/08/2011",
        "PDF",
        "856_4010.pdf"
      ],
      [
        "Functional Acknowledgment",
        "997",
        "04/01/1998",
        "PDF",
        "997_4010.pdf"
      ]
    ]
  },
  {
    "id": "bwigroup",
    "name": "BWI Group",
    "imgFileName": "bwigroup.bmp",
    "ediDocs": [
      [
        "Acknowledgement Message",
        "APERAK",
        "06/18/2003",
        "PDF",
        "BWI_Group_APERAK.pdf"
      ],
      [
        "Delivery Forecast",
        "DELFOR",
        "04/06/2010",
        "PDF",
        "BWI_Group_DELFOR.pdf"
      ],
      [
        "Ship Schedule",
        "DELJIT",
        "04/13/2010",
        "PDF",
        "BWI_Group_DELJIT.pdf"
      ],
      [
        "Despatch Advice",
        "DESADV",
        "03/21/2005",
        "PDF",
        "BWI_Group_DESADV.pdf"
      ],
      [
        "Remittance Advice Message",
        "REMADV",
        "06/23/2010",
        "PDF",
        "BWI_Group_REMADV.pdf"
      ]
    ]
  },
  {
    "id": "cswholesale",
    "name": "C&S Wholesale Grocers",
    "ediDocs": [
      [
        "Grocery Products Purchase Order",
        "875",
        "",
        "PDF",
        "C&S_875_PO_Mapping_Requirements_V4013.pdf"
      ],
      [
        "Grocery Products Invoice",
        "880",
        "",
        "PDF",
        "C&S_880_Invoice_Mapping_Requirements_V4010.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Cabela's",
    "missing": true
  },
  {
    "id": "cadenceinnovation",
    "name": "Cadence Innovation",
    "ediDocs": [
      [
        "Release",
        "830",
        "03/01/2006",
        "PDF",
        "http://www.cadenceinnovation.com/supplier/Cadence%20Innovation%20830%20_Release_041906a.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "03/14/2006",
        "PDF",
        "http://www.cadenceinnovation.com/supplier/Cadence%20Innovation%20856%20_ASN_%20041906.pdf"
      ],
      [
        "Shipping Schedule",
        "862",
        "03/01/2006",
        "PDF",
        "http://www.cadenceinnovation.com/supplier/Cadence%20Innovation%20862%20_JIT%20Schedule_%20041906.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Cadet Manufacturing",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Cadillac Rubber & Plastics DE",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Caldwell Industries",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Calsonic",
    "missing": true
  },
  {
    "id": "calsonickansei",
    "name": "Calsonic Kansei",
    "ediDocs": [
      [
        "Release",
        "830",
        "10/16/2002",
        "PDF",
        "NNA_830.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "10/20/1997",
        "PDF",
        "NNA_856.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Calstrip Steel Corp.",
    "missing": true
  },
  {
    "id": "camaco",
    "name": "Camaco LLC.",
    "ediDocs": [
      [
        "Planning Schedule With Release Capability",
        "830",
        "03/31/2008",
        "PDF",
        "830_Specs_Revise2.pdf"
      ],
      [
        "Ship Notice/Manifest",
        "856",
        "11/30/2007",
        "PDF",
        "CAMACO_856_Specs_Revise1.pdf"
      ],
      [
        "Report of Test Results",
        "863",
        "06/12/2008",
        "PDF",
        "CAMACO_863_Specs.pdf"
      ]
    ]
  },
  {
    "id": "camiautomotive",
    "name": "Cami Automotive",
    "ediDocs": [
      [
        "Production"
      ],
      [
        "Delivery Schedule",
        "DELFOR",
        "02/27/2006",
        "PDF",
        "Cami_Automotice_Production_Rev_1.5_EDIFACT_Specs.pdf"
      ],
      [
        "Delivery Just In Time",
        "DELJIT",
        "02/27/2006",
        "PDF",
        "Cami_Automotice_Production_Rev_1.5_EDIFACT_Specs.pdf"
      ],
      [
        "Despatch Advice",
        "DESADV",
        "02/27/2006",
        "PDF",
        "Cami_Automotice_Production_Rev_1.5_EDIFACT_Specs.pdf"
      ],
      [
        "Supplier Info Sheet",
        "",
        "04/20/2007",
        "PDF",
        "Cami_Automotive_Production_supplier_information_sheet.pdf"
      ],
      [
        "SPO"
      ],
      [
        "Delivery Schedule",
        "DELFOR",
        "12/06/2004",
        "PDF",
        "Cami_Automotive_SPO_Rev_4_EDIFACT_Specs.pdf"
      ],
      [
        "Despatch Advice",
        "DESADV",
        "12/06/2004",
        "PDF",
        "Cami_Automotive_SPO_Rev_4_EDIFACT_Specs.pdf"
      ],
      [
        "Supplier Info Sheet",
        "",
        "04/20/2007",
        "PDF",
        "Cami_Automotive_SPO_supplier_information_sheet.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Cami Service Parts",
    "missing": true
  },
  {
    "id": "camryn",
    "name": "Camryn Industries",
    "imgFileName": "camryn.bmp",
    "ediDocs": [
      [
        "Planning Schedule (4010)",
        "830",
        "05/25/2011",
        "PDF",
        "Camryn-830_PlanningForecast_v4010.pdf"
      ],
      [
        "Advance Ship Notice (4010)",
        "856",
        "05/25/2011",
        "PDF",
        "Camryn-856_Advanced_Ship_Notice_v4010.pdf"
      ],
      [
        "Functional Acknowledgment (4010)",
        "997",
        "05/25/2011",
        "PDF",
        "Camryn-997_4010.pdf"
      ],
      [
        "Enveloping Structures (4010)",
        "N/A",
        "05/25/2011",
        "PDF",
        "Camryn-ENV_4010.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Can-Save",
    "missing": true
  },
  {
    "id": "canadiantire",
    "name": "Canadian Tire",
    "imgFileName": "canadiantire.png",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "11/28/2007",
        "PDF",
        "3-10 INV.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "11/28/2007",
        "PDF",
        "3-5 PO.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "8/14/2013",
        "PDF",
        "3-6 ASN.pdf"
      ],
      [
        "Purchase Order Change",
        "860",
        "11/28/2007",
        "PDF",
        "3-7 POC.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Capital Packers",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Caplugs",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Carboloy",
    "missing": true
  },
  {
    "id": "missing",
    "name": "CardOne Industries",
    "missing": true
  },
  {
    "id": "carhartt",
    "name": "Carhartt",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "03/26/2015",
        "PDF",
        "810_Spec_Carhartt_Inc_v1.1.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "04/08/2015",
        "PDF",
        "850_Spec_Carhartt_Inc.pdf"
      ],
      [
        "Purchase Order Acknowledgement",
        "855",
        "02/12/2015",
        "PDF",
        "855_Spec_Carhartt_Inc.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "06/12/2010",
        "PDF",
        "856_Spec_Carhartt_Inc.pdf"
      ]
    ]
  },
  {
    "id": "carquest",
    "name": "CarQuest",
    "ediDocs": [
      [
        "Label Requirements",
        "N/A",
        "07/08/2008",
        "PDF",
        "CARQUEST_Supplier_Product_Labeling_Requirements_REV1.2.pdf"
      ],
      [
        "Invoice",
        "810",
        "02/26/2024",
        "PDF",
        "CQ_810_Inbound_4040_v3_3.pdf"
      ],
      [
        "Purchase Order & Functional Acknowledgement",
        "850 & 997",
        "02/01/2008",
        "XLS",
        "CARQUEST_EDI_Implementation_Guide.xls"
      ],
      [
        "Ship Notice",
        "856",
        "07/30/2010",
        "PDF",
        "GPI I856 IG  V1_4.pdf"
      ],
      [
        "Functional Acknowledgement",
        "997",
        "10/10/2008",
        "PDF",
        "CARQUEST_4040_997_ImplementationGuide.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Carters",
    "missing": true
  },
  {
    "id": "casenewholland",
    "name": "Case New Holland",
    "ediDocs": [
      [
        "Manufacturing"
      ],
      [
        "Invoice",
        "810",
        "08/12/2010",
        "PDF",
        "ManufacturingPlants/CNH_810v4010_Mfg.pdf"
      ],
      [
        "Planning Schedule With Release Capability",
        "830",
        "07/18/2007",
        "PDF",
        "ManufacturingPlants/CNH_830v4010.pdf"
      ],
      [
        "Ship Notice/Manifest",
        "856",
        "01/04/2012",
        "PDF",
        "ManufacturingPlants/CNH_856v4010_Mfg.pdf"
      ],
      [
        "Delivery Schedule Message",
        "DELFOR",
        "10/17/2007",
        "PDF",
        "ManufacturingPlants/CNH_DELFORvD97A.pdf"
      ],
      [
        "Despatch Advice Message",
        "DESADV",
        "10/17/2007",
        "PDF",
        "ManufacturingPlants/CNH_DESADVvD97A.pdf"
      ],
      [
        "Service Parts"
      ],
      [
        "Invoice",
        "810",
        "08/28/2008",
        "PDF",
        "ServiceParts/CNH_810v4010_ServiceParts.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "06/20/2007",
        "PDF",
        "ServiceParts/CNH_850v4010.pdf"
      ],
      [
        "Purchase Order Acknowledgement",
        "855",
        "05/21/2009",
        "PDF",
        "ServiceParts/CNH_855v4010.pdf"
      ],
      [
        "Ship Notice/Manifest",
        "856",
        "08/29/2008",
        "PDF",
        "ServiceParts/CNH_856v4010_SvcParts.pdf"
      ],
      [
        "Despatch Advice Message",
        "DESADV",
        "10/17/2007",
        "PDF",
        "ServiceParts/CNH_DESADVvD97A.pdf"
      ],
      [
        "Purchase Order Message",
        "ORDERS",
        "10/17/2007",
        "PDF",
        "ServiceParts/CNH_ORDERSvD97A.pdf"
      ],
      [
        "Purchase Order Response Message",
        "ORDRSP",
        "10/17/2007",
        "PDF",
        "ServiceParts/CNH_ORDRSPvD97A.pdf"
      ],
      [
        "Information"
      ],
      [
        "Supplier FAQ",
        "N/A",
        "06/03/2008",
        "PDF",
        "CNH_Supplier_FAQs.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Caseys General",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Cass",
    "missing": true
  },
  {
    "id": "caterpillar",
    "name": "Caterpillar Inc.",
    "customMessage": true
  },
  {
    "id": "missing",
    "name": "Caterpillar Paving",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Celadon Trucking",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Celanese Acetate",
    "missing": true
  },
  {
    "id": "celsius",
    "name": "Celsius",
    "ediDocs": [
      [
        "Warehouse Shipping Order",
        "940",
        "01/03/2025",
        "PDF",
        "Celsius_940_X12.pdf"
      ],
      [
        "Warehouse Shipping Advice",
        "945",
        "12/23/2015",
        "PDF",
        "Celsius_945_X12.pdf"
      ],
      [
        "Inventory Advice",
        "846",
        "12/23/2015",
        "PDF",
        "Celsius_846_X12.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Centoco Manufacturing Corp",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Certified Tool",
    "missing": true
  },
  {
    "id": "missing",
    "name": "CFGOMMA Group",
    "missing": true
  },
  {
    "id": "chahta",
    "name": "Chahta Enterprises",
    "ediDocs": [
      [
        "All",
        "EDI Specification",
        "2002",
        "PDF",
        "RPS_EDI_Specs.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Chardon Rubber Co.",
    "missing": true
  },
  {
    "id": "missing",
    "name": "CHARMING SHOPPES",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Charob",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Chase Bank",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Chemtech Plastics, Inc.",
    "missing": true
  },
  {
    "id": "chrysler",
    "name": "Chrysler",
    "vendorLink": "https://ps.nafta.extra.fcagroup.com/sites/itb-ebus/Pages/Home.aspx ",
    "ediDocs": [
      [
        "Production (Direct) Parts Supplier"
      ],
      [
        "810",
        "Invoice",
        "07/24/2018",
        "PDF",
        "PlantSupport/ProductionDirectPartsSupplier/810PentaSAPAccountsPayableInvoice.pdf"
      ],
      [
        "820",
        "Remittance Advice",
        "06/01/2016",
        "PDF",
        "PlantSupport/ProductionDirectPartsSupplier/820PentaSAPRemittanceAdvice.pdf"
      ],
      [
        "824",
        "Application Advice",
        "03/25/2015",
        "PDF",
        "PlantSupport/ProductionDirectPartsSupplier/824ApplicationAdvice.pdf"
      ],
      [
        "830",
        "Material Release",
        "12/01/2018",
        "PDF",
        "PlantSupport/ProductionDirectPartsSupplier/830MaterialRelease.pdf"
      ],
      [
        "850",
        "Purchase Order",
        "09/16/2016",
        "PDF",
        "PlantSupport/ProductionDirectPartsSupplier/850PentaSAPPurchaseOrder.pdf"
      ],
      [
        "853",
        "Routing And Carrier Instructions",
        "03/05/2015",
        "PDF",
        "PlantSupport/ProductionDirectPartsSupplier/853RoutingAndCarrierInstructions.pdf"
      ],
      [
        "856",
        "Advance Ship Notice",
        "03/24/2015",
        "PDF",
        "PlantSupport/ProductionDirectPartsSupplier/856AdvanceShipNotice.pdf"
      ],
      [
        "860",
        "Purchase Order Change",
        "09/16/2016",
        "PDF",
        "PlantSupport/ProductionDirectPartsSupplier/860PentaSAPPurchaseOrderChange.pdf"
      ],
      [
        "861",
        "Receiving Advice",
        "04/21/2015",
        "PDF",
        "PlantSupport/ProductionDirectPartsSupplier/861ReceivingAdvice.pdf"
      ],
      [
        "862",
        "Shipping Schedule",
        "01/14/2019",
        "PDF",
        "PlantSupport/ProductionDirectPartsSupplier/862ShippingSchedule.pdf"
      ],
      [
        "864",
        "Text Message",
        "04/21/2015",
        "PDF",
        "PlantSupport/ProductionDirectPartsSupplier/864TextMessage.pdf"
      ],
      [
        "997",
        "Functional Acknowledgment",
        "04/24/2015",
        "PDF",
        "PlantSupport/ProductionDirectPartsSupplier/997FunctionalAcknowledgment.pdf"
      ],
      [
        "Non Production (Direct) Parts Supplier"
      ],
      [
        "810",
        "Invoice",
        "07/24/2018",
        "PDF",
        "PlantSupport/NonProductionIndirectSupplier/810PentaSAPAccountsPayableInvoice.pdf"
      ],
      [
        "820",
        "Remittance Advice",
        "06/01/2016",
        "PDF",
        "PlantSupport/NonProductionIndirectSupplier/820PentaSAPRemittanceAdvice.pdf"
      ],
      [
        "824",
        "Application Advice",
        "03/25/2015",
        "PDF",
        "PlantSupport/NonProductionIndirectSupplier/824ApplicationAdvice.pdf"
      ],
      [
        "850",
        "Purchase Order",
        "09/16/2016",
        "PDF",
        "PlantSupport/NonProductionIndirectSupplier/850PentaSAPPurchaseOrder.pdf"
      ],
      [
        "860",
        "Purchase Order Change",
        "09/16/2016",
        "PDF",
        "PlantSupport/NonProductionIndirectSupplier/860PentaSAPPurchaseOrderChange.pdf"
      ],
      [
        "864",
        "Text Message",
        "04/21/2015",
        "PDF",
        "PlantSupport/NonProductionIndirectSupplier/864TextMessage.pdf"
      ],
      [
        "997",
        "Functional Acknowledgment",
        "04/24/2015",
        "PDF",
        "PlantSupport/NonProductionIndirectSupplier/997FunctionalAcknowledgment.pdf"
      ],
      [
        "Pay-As-Built (PAB)"
      ],
      [
        "820",
        "Remittance Advice",
        "06/01/2016",
        "PDF",
        "PlantSupport/PayAsBuiltPAB/820PentaSAPRemittanceAdvice.pdf"
      ],
      [
        "824",
        "Application Advice",
        "03/25/2015",
        "PDF",
        "PlantSupport/PayAsBuiltPAB/824ApplicationAdvice.pdf"
      ],
      [
        "830",
        "Material Release",
        "12/01/2018",
        "PDF",
        "PlantSupport/PayAsBuiltPAB/830MaterialRelease.pdf"
      ],
      [
        "846",
        "Inventory Advice",
        "02/23/2015",
        "PDF",
        "PlantSupport/PayAsBuiltPAB/846PayAsBuiltInventoryAdvice.pdf"
      ],
      [
        "850",
        "Purchase Order",
        "09/16/2016",
        "PDF",
        "PlantSupport/PayAsBuiltPAB/850PentaSAPPurchaseOrder.pdf"
      ],
      [
        "860",
        "Purchase Order Change",
        "09/16/2016",
        "PDF",
        "PlantSupport/PayAsBuiltPAB/860PentaSAPPurchaseOrderChange.pdf"
      ],
      [
        "861",
        "Receiving Advice",
        "04/21/2015",
        "PDF",
        "PlantSupport/PayAsBuiltPAB/861ReceivingAdvice.pdf"
      ],
      [
        "862",
        "Shipping Schedule",
        "01/14/2019",
        "PDF",
        "PlantSupport/PayAsBuiltPAB/862ShippingSchedule.pdf"
      ],
      [
        "864",
        "Text Message",
        "04/21/2015",
        "PDF",
        "PlantSupport/PayAsBuiltPAB/864TextMessage.pdf"
      ],
      [
        "997",
        "Functional Acknowledgment",
        "04/24/2015",
        "PDF",
        "PlantSupport/PayAsBuiltPAB/997FunctionalAcknowledgment.pdf"
      ],
      [
        "Mopar Applications"
      ],
      [
        "810",
        "Invoice",
        "07/24/2018",
        "PDF",
        "MoparApplications/MoparApplications/810PentaSAPAccountsPayableInvoice.pdf"
      ],
      [
        "820",
        "Remittance Advice",
        "06/01/2016",
        "PDF",
        "MoparApplications/MoparApplications/820PentaSAPRemittanceAdvice.pdf"
      ],
      [
        "824",
        "Application Advice",
        "03/25/2015",
        "PDF",
        "MoparApplications/MoparApplications/824ApplicationAdvice.pdf"
      ],
      [
        "830",
        "Material Release",
        "12/01/2018",
        "PDF",
        "MoparApplications/MoparApplications/830MaterialRelease.pdf"
      ],
      [
        "850",
        "Purchase Order",
        "09/16/2016",
        "PDF",
        "MoparApplications/MoparApplications/850PentaSAPPurchaseOrder.pdf"
      ],
      [
        "853",
        "Routing And Carrier Instructions",
        "03/05/2015",
        "PDF",
        "MoparApplications/MoparApplications/853RoutingAndCarrierInstructions.pdf"
      ],
      [
        "856",
        "Advance Ship Notice",
        "03/24/2015",
        "PDF",
        "MoparApplications/MoparApplications/856AdvanceShipNotice.pdf"
      ],
      [
        "860",
        "Purchase Order Change",
        "09/16/2016",
        "PDF",
        "MoparApplications/MoparApplications/860PentaSAPPurchaseOrderChange.pdf"
      ],
      [
        "861",
        "Receiving Advice",
        "04/21/2015",
        "PDF",
        "MoparApplications/MoparApplications/861ReceivingAdvice.pdf"
      ],
      [
        "862",
        "Shipping Schedule",
        "01/14/2019",
        "PDF",
        "MoparApplications/MoparApplications/862ShippingSchedule.pdf"
      ],
      [
        "864",
        "Text Message",
        "04/21/2015",
        "PDF",
        "MoparApplications/MoparApplications/864TextMessage.pdf"
      ],
      [
        "997",
        "Functional Acknowledgment",
        "04/24/2015",
        "PDF",
        "MoparApplications/MoparApplications/997FunctionalAcknowledgment.pdf"
      ],
      [
        "Supplier Ship Direct (SSD)"
      ],
      [
        "810",
        "Invoice",
        "07/24/2018",
        "PDF",
        "MoparApplications/SupplierShipDirectSSD/810SupplierShipDirectMiscChargeInvoice.pdf"
      ],
      [
        "820",
        "Remittance Advice",
        "06/01/2016",
        "PDF",
        "MoparApplications/SupplierShipDirectSSD/820PentaSAPRemittanceAdvice.pdf"
      ],
      [
        "824",
        "Application Advice",
        "03/25/2015",
        "PDF",
        "MoparApplications/SupplierShipDirectSSD/824ApplicationAdvice.pdf"
      ],
      [
        "830",
        "Material Release",
        "12/01/2018",
        "PDF",
        "MoparApplications/SupplierShipDirectSSD/830MaterialRelease.pdf"
      ],
      [
        "846",
        "Inventory Advice",
        "02/20/2015",
        "PDF",
        "MoparApplications/SupplierShipDirectSSD/846MoparConsignmentSSDSupplierMaterial.pdf"
      ],
      [
        "850",
        "Purchase Order",
        "09/16/2016",
        "PDF",
        "MoparApplications/SupplierShipDirectSSD/850PentaSAPPurchaseOrder.pdf"
      ],
      [
        "856",
        "Advance Ship Notice",
        "03/24/2015",
        "PDF",
        "MoparApplications/SupplierShipDirectSSD/856AdvanceShipNotice.pdf"
      ],
      [
        "860",
        "Purchase Order Change",
        "09/16/2016",
        "PDF",
        "MoparApplications/SupplierShipDirectSSD/860PentaSAPPurchaseOrderChange.pdf"
      ],
      [
        "864",
        "Text Message",
        "04/21/2015",
        "PDF",
        "MoparApplications/SupplierShipDirectSSD/864TextMessage.pdf"
      ],
      [
        "870",
        "Order Status Report",
        "07/23/2015",
        "PDF",
        "MoparApplications/SupplierShipDirectSSD/870MoparOrderStatusReportFromSupplier.pdf"
      ],
      [
        "870",
        "Order Status Report",
        "09/24/2010",
        "PDF",
        "MoparApplications/SupplierShipDirectSSD/870MoparOrderStatusReportToDealer.pdf"
      ],
      [
        "997",
        "Functional Acknowledgment",
        "04/24/2015",
        "PDF",
        "MoparApplications/SupplierShipDirectSSD/997FunctionalAcknowledgment.pdf"
      ],
      [
        "Mopar Tire Program"
      ],
      [
        "810",
        "Invoice",
        "01/20/2015",
        "PDF",
        "MoparApplications/MoparTireProgram/810MoparTireProgramInvoice.pdf"
      ],
      [
        "820",
        "Remittance Advice",
        "06/01/2016",
        "PDF",
        "MoparApplications/MoparTireProgram/820PentaSAPRemittanceAdvice.pdf"
      ],
      [
        "824",
        "Application Advice",
        "03/25/2015",
        "PDF",
        "MoparApplications/MoparTireProgram/824ApplicationAdvice.pdf"
      ],
      [
        "832",
        "Price Catalog",
        "02/18/2015",
        "PDF",
        "MoparApplications/MoparTireProgram/832MoparTireProgramPriceCatalog.pdf"
      ],
      [
        "838",
        "Trading Partner Profile",
        "02/18/2015",
        "PDF",
        "MoparApplications/MoparTireProgram/838MoparTireProgramTradingPartnerProfile.pdf"
      ],
      [
        "Mopar Parts Tracking - Odometer/Radio Replacement"
      ],
      [
        "824",
        "Application Advice",
        "03/25/2015",
        "PDF",
        "MoparApplications/MoparPartsTrackingOdometerRadioReplacement/824ApplicationAdvice.pdf"
      ],
      [
        "830",
        "Material Release",
        "12/01/2018",
        "PDF",
        "MoparApplications/MoparPartsTrackingOdometerRadioReplacement/830MaterialRelease.pdf"
      ],
      [
        "856",
        "Advance Ship Notice",
        "03/24/2015",
        "PDF",
        "MoparApplications/MoparPartsTrackingOdometerRadioReplacement/856AdvanceShipNotice.pdf"
      ],
      [
        "861",
        "Receiving Advice",
        "03/28/2018",
        "PDF",
        "MoparApplications/MoparPartsTrackingOdometerRadioReplacement/861MoparPartsTrackingReceivingAdvice.pdf"
      ],
      [
        "864",
        "Text Message",
        "04/21/2015",
        "PDF",
        "MoparApplications/MoparPartsTrackingOdometerRadioReplacement/864TextMessage.pdf"
      ],
      [
        "870",
        "Order Status Report",
        "09/24/2010",
        "PDF",
        "MoparApplications/MoparPartsTrackingOdometerRadioReplacement/870MoparOrderStatusReportToDealer.pdf"
      ],
      [
        "997",
        "Functional Acknowledgment",
        "04/24/2015",
        "PDF",
        "MoparApplications/MoparPartsTrackingOdometerRadioReplacement/997FunctionalAcknowledgment.pdf"
      ],
      [
        "Mopar Consignment Supplier Material Inventory Advice"
      ],
      [
        "846",
        "Inventory Advice",
        "02/20/2015",
        "PDF",
        "MoparApplications/SupplierShipDirectSSD/846MoparConsignmentSSDSupplierMaterial.pdf"
      ],
      [
        "Mopar Distributor Purchasing"
      ],
      [
        "850",
        "Purchase Order",
        "02/24/2015",
        "PDF",
        "MoparApplications/MoparDistributorPurchasing/850MoparDistributorPurchaseOrder.pdf"
      ],
      [
        "855",
        "Purchase Order Acknowledgment",
        "08/24/2018",
        "PDF",
        "MoparApplications/MoparDistributorPurchasing/855MoparDistributorPurchaseOrderAcknowledgment.pdf"
      ],
      [
        "Commodity Procurement"
      ],
      [
        "Commodity Procurement (Offload)"
      ],
      [
        "810",
        "Invoice",
        "01/23/2015",
        "PDF",
        "CommodityProcurement/CommodityProcurementOffload/810PentaSAPCommodityProcurementInvoice.pdf"
      ],
      [
        "820",
        "Remittance Advice",
        "06/01/2016",
        "PDF",
        "CommodityProcurement/CommodityProcurementOffload/820PentaSAPRemittanceAdvice.pdf"
      ],
      [
        "822",
        "Account Analysis",
        "02/03/2015",
        "PDF",
        "CommodityProcurement/CommodityProcurementOffload/822CommodityProcurementAccountAnalysis.pdf"
      ],
      [
        "824",
        "Application Advice",
        "03/25/2015",
        "PDF",
        "CommodityProcurement/CommodityProcurementOffload/824ApplicationAdvice.pdf"
      ],
      [
        "847",
        "Material Claim",
        "02/24/2015",
        "PDF",
        "CommodityProcurement/CommodityProcurementOffload/847CommodityProcurementMaterialClaim.pdf"
      ],
      [
        "850",
        "Purchase Order",
        "09/16/2016",
        "PDF",
        "CommodityProcurement/CommodityProcurementOffload/850PentaSAPPurchaseOrder.pdf"
      ],
      [
        "856",
        "Advance Ship Notice",
        "03/24/2015",
        "PDF",
        "CommodityProcurement/CommodityProcurementOffload/856AdvanceShipNotice.pdf"
      ],
      [
        "860",
        "Purchase Order Change",
        "09/16/2016",
        "PDF",
        "CommodityProcurement/CommodityProcurementOffload/860PentaSAPPurchaseOrderChange.pdf"
      ],
      [
        "864",
        "Text Message",
        "04/21/2015",
        "PDF",
        "CommodityProcurement/CommodityProcurementOffload/864TextMessage.pdf"
      ],
      [
        "870",
        "Order Status Report",
        "04/23/2015",
        "PDF",
        "CommodityProcurement/CommodityProcurementOffload/870RawSteelOrderStatusReport.pdf"
      ],
      [
        "997",
        "Functional Acknowledgment",
        "04/24/2015",
        "PDF",
        "CommodityProcurement/CommodityProcurementOffload/997FunctionalAcknowledgment.pdf"
      ],
      [
        "Parts Carrier Requirements"
      ],
      [
        "Parts Carrier - General Requirements"
      ],
      [
        "210",
        "Motor Carrier Freight Details and Invoice",
        "08/23/2017",
        "PDF",
        "PartsCarrierRequirements/PartsCarrierGeneralRequirements/210FreightPaymentInvoice.pdf"
      ],
      [
        "820",
        "Remittance Advice",
        "01/28/2015",
        "PDF",
        "PaPartsCarrierRequirements/PartsCarrierGeneralRequirementsrtsCarrierRequirements/PartsCarrierGeneralRequirements/820CarrierRemittanceAdvice.pdf"
      ],
      [
        "824",
        "Application Advice",
        "03/25/2015",
        "PDF",
        "PartsCarrierRequirements/PartsCarrierGeneralRequirements/824ApplicationAdvice.pdf"
      ],
      [
        "858",
        "Shipment Information",
        "04/15/2015",
        "PDF",
        "PartsCarrierRequirements/PartsCarrierGeneralRequirements/858CENTSShipmentInformation.pdf"
      ],
      [
        "862",
        "Shipping Schedule",
        "01/14/2019",
        "PDF",
        "PartsCarrierRequirements/PartsCarrierGeneralRequirements/862ShippingSchedule.pdf"
      ],
      [
        "864",
        "Text Message",
        "04/21/2015",
        "PDF",
        "PartsCarrierRequirements/PartsCarrierGeneralRequirements/864TextMessage.pdf"
      ],
      [
        "997",
        "Functional Acknowledgment",
        "04/24/2015",
        "PDF",
        "PartsCarrierRequirements/PartsCarrierGeneralRequirements/997FunctionalAcknowledgment.pdf"
      ],
      [
        "Freight Consolidation - Specific Requirements"
      ],
      [
        "214",
        "Transportation Carrier Shipment Status Message",
        "07/13/2017",
        "PDF",
        "PartsCarrierRequirements/FreightConsolidationSpecificRequirements/214STARSShipmentStatus.pdf"
      ],
      [
        "824",
        "Application Advice",
        "02/05/2015",
        "PDF",
        "PartsCarrierRequirements/FreightConsolidationSpecificRequirements/824FreightConsolidatorApplicationAdvice.pdf"
      ],
      [
        "824",
        "Application Advice",
        "02/06/2015",
        "PDF",
        "PartsCarrierRequirements/FreightConsolidationSpecificRequirements/824STARSApplicationAdvice.pdf"
      ],
      [
        "853",
        "Routing And Carrier Instructions",
        "03/05/2015",
        "PDF",
        "PartsCarrierRequirements/FreightConsolidationSpecificRequirements/853RoutingAndCarrierInstructions.pdf"
      ],
      [
        "856",
        "Advance Ship Notice",
        "04/07/2015",
        "PDF",
        "PartsCarrierRequirements/FreightConsolidationSpecificRequirements/856FreightConsolidatorAdvanceShipNotice.pdf"
      ],
      [
        "Rail Carrier - Specific Requirements"
      ],
      [
        "404",
        "Rail Carrier Shipment Information",
        "07/23/2015",
        "PDF",
        "PartsCarrierRequirements/RailCarrierSpecificRequirements/404RailCarrierShipmentInformation.pdf"
      ],
      [
        "410",
        "RailCarrier Freight Details And Invoice",
        "03/28/2017",
        "PDF",
        "PartsCarrierRequirements/RailCarrierSpecificRequirements/410RailCarrierFreightDetailsAndInvoice.pdf"
      ],
      [
        "STARS - Shipment Tracking Alarm Reporting System - Specific Requirements"
      ],
      [
        "214",
        "Transportation Carrier Shipment Status Message",
        "07/13/2017",
        "PDF",
        "PartsCarrierRequirements/StarsShipmentTrackingAlarmReportingSystemSpecificRequirements/214STARSShipmentStatus.pdf"
      ],
      [
        "824",
        "Application Advice",
        "02/06/2015",
        "PDF",
        "PartsCarrierRequirements/StarsShipmentTrackingAlarmReportingSystemSpecificRequirements/824STARSApplicationAdvice.pdf"
      ],
      [
        "Premium Transportation Management (PTM) - Specific Requirements"
      ],
      [
        "214",
        "Transportation Carrier Shipment Status Message",
        "07/13/2017",
        "PDF",
        "PartsCarrierRequirements/PremiumTransportationManagementPTMSpecificRequirements/214STARSShipmentStatus.pdf"
      ],
      [
        "824",
        "Application Advice",
        "02/06/2015",
        "PDF",
        "PartssCarrierRequirements/PremiumTransportationManagementPTMSpecificRequirements/824STARSApplicationAdvice.pdf"
      ],
      [
        "856",
        "Advance Ship Notice",
        "04/07/2015",
        "PDF",
        "PartsCarrierRequirements/PremiumTransportationManagementPTMSpecificRequirements/856FreightConsolidatorAdvanceShipNotice.pdf"
      ],
      [
        "858",
        "Shipment Information",
        "04/10/2015",
        "PDF",
        "PartsCarrierRequirements/PremiumTransportationManagementPTMSpecificRequirements/858AETCNotificationShipmentInformation.pdf"
      ],
      [
        "Additional General Information"
      ],
      [
        "210",
        "FREIGHT PAYMENT FAQ ",
        "07/23/2018",
        "PDF",
        "AdditionalGeneralInformation/AdditionalGeneralInformation/210FreightPaymentFAQ.pdf"
      ],
      [
        "824",
        "Error Messages",
        "05/17/2018",
        "PDF",
        "AdditionalGeneralInformation/AdditionalGeneralInformation/824ErrorMessages.pdf"
      ],
      [
        "Vehicle Logistics"
      ],
      [
        "838",
        " Trading Partner Profile",
        "02/15/2015",
        "PDF",
        "VehicleLogistics/VehicleLogistics/838VISTATradingPartnerProfile.pdf"
      ],
      [
        "853",
        "Routing And Carrier Instructions",
        "03/05/2015",
        "PDF",
        "VehicleLogistics/VehicleLogistics/853RoutingAndCarrierInstructionsVISTA.pdf"
      ],
      [
        "Market Center"
      ],
      [
        "810",
        "Invoice",
        "01/02/2018",
        "PDF",
        "MarketCenter/MarketCenter/810MarketCenterInvoice.pdf"
      ],
      [
        "824",
        "Application Advice",
        "03/25/2015",
        "PDF",
        "MarketCenter/MarketCenter/824ApplicationAdvice.pdf"
      ],
      [
        "997",
        "Functional Acknowledgment",
        "04/24/2015",
        "PDF",
        "MarketCenter/MarketCenter/997FunctionalAcknowledgment.pdf"
      ],
      [
        "Criss Cross (Customer EDI)"
      ],
      [
        "Criss Cross (Customer EDI)"
      ],
      [
        "830",
        "Material Release",
        "12/01/2018",
        "PDF",
        "CrissCrossCustomerEDI/CrissCrossCustomerEDI/830MaterialRelease.pdf"
      ],
      [
        "856",
        "Advance Ship Notice",
        "03/24/2015",
        "PDF",
        "CrissCrossCustomerEDI/CrissCrossCustomerEDI/856AdvanceShipNotice.pdf"
      ],
      [
        "Miscellaneous Guides"
      ],
      [
        "810",
        "Invoice",
        "01/16/2015",
        "PDF",
        "MiscellaneousGuides/MiscellaneousGuides/810CanadaFleetSalesInvoice.pdf"
      ],
      [
        "810",
        "Invoice",
        "01/23/2015",
        "PDF",
        "MiscellaneousGuides/MiscellaneousGuides/810PentaSAPSiriusSatelliteRadioInvoice.pdf"
      ],
      [
        "810",
        "Invoice",
        "01/26/2015",
        "PDF",
        "MiscellaneousGuides/MiscellaneousGuides/810ServiceNetAndSprinterInvoice.pdf"
      ],
      [
        "820",
        "Remittance Advice",
        "01/28/2015",
        "PDF",
        "MiscellaneousGuides/MiscellaneousGuides/820MajorDamageTracking.pdf"
      ],
      [
        "838",
        " Trading Partner Profile",
        "02/18/2015",
        "PDF",
        "MiscellaneousGuides/MiscellaneousGuides/838UPSMixingCenterTradingPartnerProfile.pdf"
      ],
      [
        "850",
        "Purchase Order",
        "02/25/2015",
        "PDF",
        "MiscellaneousGuides/MiscellaneousGuides/850MoparDistributorToDealerPurchaseOrder.pdf"
      ],
      [
        "855",
        "Purchase Order Acknowledgment",
        "05/11/2016",
        "PDF",
        "MiscellaneousGuides/MiscellaneousGuides/855MoparDistributorToDealerPurchaseOrderAcknowledgment.pdf"
      ],
      [
        "856",
        "Advance Ship Notice",
        "04/07/2015",
        "PDF",
        "MiscellaneousGuides/MiscellaneousGuides/856MoparDistributorToDealerAdvanceShipNotice.pdf"
      ],
      [
        "857",
        "Shipment and Billing Notice",
        "04/08/2015",
        "PDF",
        "MiscellaneousGuides/MiscellaneousGuides/857PentaSAPSSRShippingAndBillingNotice.pdf"
      ],
      [
        "858",
        "Shipment Information",
        "04/14/2015",
        "PDF",
        "MiscellaneousGuides/MiscellaneousGuides/858FastPartsShipmentInformation.pdf"
      ],
      [
        "858",
        "Shipment Information",
        "04/14/2015",
        "PDF",
        "MiscellaneousGuides/MiscellaneousGuides/858FastVehicleShipmentInformation.pdf"
      ],
      [
        "861",
        "Receiving Advice",
        "04/17/2015",
        "PDF",
        "MiscellaneousGuides/MiscellaneousGuides/861GlobalCoreReturnSystemReceivingAdvice.pdf"
      ],
      [
        "863",
        "Report of Test Results",
        "09/30/2015",
        "PDF",
        "MiscellaneousGuides/MiscellaneousGuides/863SteelSupplyProgramTestResults.pdf"
      ],
      [
        "996",
        "File Transfer",
        "04/23/2015",
        "PDF",
        "MiscellaneousGuides/MiscellaneousGuides/996FileTransfer.pdf"
      ]
    ]
  },
  {
    "id": "ChoctawKaul",
    "name": "Choctaw-Kaul",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "06/19/2024",
        "DOC",
        "Choctaw Kaul - 810.doc"
      ],
      [
        "Purchase Order",
        "850",
        "06/19/2024",
        "DOC",
        "Choctaw Kaul - 850.doc"
      ],
      [
        "Purchase Order Acknowledgment",
        "855",
        "06/19/2024",
        "DOC",
        "Choctaw Kaul - 855.doc"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Chrysler (Europe)",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Chrysler de Mexico",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Citizens of Humanity",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Clark Engineering",
    "missing": true
  },
  {
    "id": "missing",
    "name": "CMI International",
    "missing": true
  },
  {
    "id": "cnh",
    "name": "CNH",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "08/28/2008",
        "PDF",
        "CNH_810v4010_SP_082808.pdf"
      ],
      [
        "Planning Schedule with Release Capability",
        "830",
        "01/04/2012",
        "PDF",
        "CNH_830v4010_01042012.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "08/22/2008",
        "PDF",
        "CNH_850v4010_082208.pdf"
      ],
      [
        "Purchase Order Acknowledgment",
        "855",
        "05/21/2009",
        "PDF",
        "CNH_855v4010_052109.pdf"
      ],
      [
        "Ship Notice/Manifest MANUFACTURING PLANTS",
        "856",
        "01/04/2012",
        "PDF",
        "CNH_856v4010_Mfg_01042012.pdf"
      ],
      [
        "Ship Notice/Manifest SERVICE PARTS",
        "856",
        "08/29/2008",
        "PDF",
        "CNH_856v4010_SP_082908.pdf"
      ],
      [
        "EDIFACT"
      ],
      [
        "Delivery Schedule Message",
        "DELFOR",
        "04/04/2013",
        "PDF",
        "Delfor_D96a_Manual.pdf"
      ],
      [
        "Despatch Advice",
        "DESADV",
        "02/02/2021",
        "PDF",
        "DESADV_D96A_Manual.pdf"
      ],
      [
        "ODETTE"
      ],
      [
        "Delivery Instruction",
        "DELINS (v3)",
        "04/04/2013",
        "PDF",
        "DELINS_v3.pdf"
      ],
      [
        "Despatch Advice",
        "AVIEXP (v3)",
        "02/02/2021",
        "PDF",
        "Aviexp_ V3.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "CNI Inc.",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Colabor Canada Inc.",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Colgate-Palmolive",
    "missing": true
  },
  {
    "id": "collinsaikman",
    "name": "Collins & Aikman",
    "ediDocs": [
      [
        "Process Guide Lines",
        "Guide",
        "06/11/2007",
        "PDF",
        "Collins_and_Aikman_edi_guidelines.pdf"
      ],
      [
        "Release",
        "830",
        "07/30/2007",
        "PDF",
        "Collins_and_Aikman_830_V4010.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "07/30/2007",
        "PDF",
        "Collins_and_Aikman_856_V4010.pdf"
      ]
    ]
  },
  {
    "id": "collinsaikmanmexico",
    "name": "Collins & Aikman (Mexico)",
    "ediDocs": [
      [
        "Release",
        "830",
        "08/02/2007",
        "PDF",
        "830_document-revised.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "08/02/2007",
        "PDF",
        "856_document-revised.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Columbia Enginered Rubber",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Comcast",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Commonwealth Home Fashions",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Commonwealth of PA",
    "missing": true
  },
  {
    "id": "compaq",
    "name": "Compaq",
    "ediDocs": [
      [
        "Purchase Order Response",
        "ORDRSP",
        "07/17/2003",
        "PDF",
        "ordrsp.pdf"
      ]
    ]
  },
  {
    "id": "CompTIA",
    "name": "Computing Technology Industry Association",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "December 2002",
        "PDF",
        "ATG 810 Invoice Specifications.pdf.pdf"
      ],
      [
        "Purchase Order ",
        "850",
        "September 2002",
        "PDF",
        "ATG 850 Purchase Order Specifications.pdf"
      ],
      [
        "Purchase Order Acknowledgment",
        "855",
        "December 2002",
        "PDF",
        "ATG 855 PO Acknowledgement Specifications.pdf.pdf"
      ]
    ]
  },
  {
    "id": "conagra",
    "name": "ConAgra Foods",
    "ediDocs": [
      [
        "Inbound Invoice (5010)",
        "810",
        "11/16/2012",
        "PDF",
        "ConAgra_Inbound_810_5010_X12_20101116.pdf"
      ],
      [
        "Outbound Purchase Order (5010)",
        "850",
        "12/01/2011",
        "PDF",
        "ConAgra_Outbound_850_5010_X12_20111201_Final.pdf"
      ],
      [
        "Purchase Order Acknowledgment (5010)",
        "855",
        "11/10/2011",
        "PDF",
        "ConAgra_Inbound_855_5010_X12_DRAFT_20111110.pdf"
      ],
      [
        "Outbound Purchase Order Change (5010)",
        "860",
        "12/01/2011",
        "PDF",
        "ConAgra_Outbound_860_5010_X12_20111201_Final.pdf"
      ]
    ]
  },
  {
    "id": "consolidatedmetco",
    "name": "Consolidated Metco (ConMet)",
    "ediDocs": [
      [
        "Consolidated Metco EDI Introduction",
        "Doc",
        "9/30/2010",
        "PDF",
        "ConMet_EDI_Introduction.pdf"
      ],
      [
        "Planning Schedule w/ Release Capability (4010)",
        "830",
        "1/26/2011",
        "PDF",
        "ConMet_830_v4010.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Continental Midland",
    "missing": true
  },
  {
    "id": "continentalteves",
    "name": "Continental Teves",
    "ediDocs": [
      [
        "Release",
        "830",
        "05/21/2002",
        "PDF",
        "Continental_Teves_830_v.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "05/21/2002",
        "PDF",
        "Continental_Teves_856_v.pdf"
      ],
      [
        "Functional Acknowledgment",
        "997",
        "02/08/2002",
        "PDF",
        "Conti997_4010.pdf"
      ],
      [
        "EDIFACT"
      ],
      [
        "Delivery Schedule Message",
        "DELFOR",
        "01/03/2010",
        "PDF",
        "Continental_Global_DELFOR_04a.pdf"
      ],
      [
        "Despatch Advice",
        "DESADV",
        "10/03/2008",
        "PDF",
        "Conti_DESADV_11.10.2010.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Continental VDO",
    "missing": true
  },
  {
    "id": "cooperstandard",
    "name": "Cooper Standard",
    "ediDocs": [
      [
        "Planning Schedule",
        "830 (4010)",
        "04/08/2011",
        "PDF",
        "CSA_830_4010.pdf"
      ],
      [
        "Ship Notice",
        "856 (4010)",
        "04/27/2011",
        "PDF",
        "CSA_856_4010.pdf"
      ],
      [
        "Delivery Schedule",
        "DELFOR",
        "08/14/2015",
        "PDF",
        "CSA_DELFOR_D04A.PDF"
      ],
      [
        "Despatch advice",
        "DESADV",
        "08/14/2015",
        "PDF",
        "CSA_DESADV_D97A.PDF"
      ],
      [
        "Ship Notice Data Examples",
        "N/A",
        "04/27/2011",
        "PDF",
        "856_Data_Examples.pdf"
      ],
      [
        "Functional Acknowledgment",
        "997 (4010)",
        "03/01/1999",
        "PDF",
        "EDI-Functional_Acknowledgement_997_(4010)_Gentran.pdf"
      ],
      [
        "Labeling Requirements (Bar Code Standards)",
        "N/A",
        "02/01/2011",
        "PDF",
        "Appendix_16-AIAG_Labeling_Reference_Guide.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Coremark",
    "missing": true
  },
  {
    "id": "corning",
    "name": "Corning Inc.",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "04/18/2016",
        "PDF",
        "TS 810 ANSI X12 004010 Implementation Guide v2.0.pdf"
      ]
    ]
  },
  {
    "id": "Cornwell",
    "name": "Cornwell",
    "ediDocs": [
      [
        "Purchase Order, Invoice, Functional Acknowledgement",
        "850,810,997",
        "N/A",
        "XLS",
        "Cornwell EDI File Formats.xls"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Costco Wholesale",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Coupled Products",
    "missing": true
  },
  {
    "id": "cpkinteriors",
    "name": "CpK Interior Products",
    "imgFileName": "cpkinteriors.bmp",
    "ediDocs": [
      [
        "EDIFACT Version D Release 96A",
        "Multi Message",
        "April 2000",
        "PDF",
        "CpK_Interior_Products_EDI_specs.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Craft Co.",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Crane (CCC Parts)",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Creative Foam",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Creco Cast",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Crest Products",
    "missing": true
  },
  {
    "id": "crh",
    "name": "CRH",
    "imgFileName": "crh.bmp",
    "ediDocs": [
      [
        "Planning Schedule with Release (4010)",
        "830",
        "03/01/1999",
        "PDF",
        "830_Planning_Schedule_with_Release_Capability.pdf"
      ],
      [
        "Advance Shipment Notice (4010)",
        "856",
        "01/01/2008",
        "PDF",
        "856_Advanced_Shipment_Notice.pdf"
      ],
      [
        "Shipping Schedule (4010)",
        "862",
        "07/26/2011",
        "PDF",
        "862_Shipping_Schedule.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Cristal Laminado",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Crosby Molasses Co. Ltd.",
    "missing": true
  },
  {
    "id": "missing",
    "name": "CSK Auto",
    "missing": true
  },
  {
    "id": "missing",
    "name": "CSV - Cummins Scania Venture",
    "missing": true
  },
  {
    "id": "missing",
    "name": "CTI Industries",
    "missing": true
  },
  {
    "id": "cumminsengine",
    "name": "Cummins Engine Co., Inc",
    "vendorLink": "http://www.cummins.com/support/suppliers/electronic-commerce-supplier-edi/implementation-information",
    "ediDocs": [
      [
        "Application Error and Acknowledgement Message",
        "APERAK",
        "07/06/2010",
        "PDF",
        "APERAKD97A2010-07-07.pdf"
      ],
      [
        "Delivery Schedule Message",
        "DELFOR",
        "11/14/2008",
        "PDF",
        "DELFORD97A.pdf"
      ],
      [
        "Delivery just in time message",
        "DELJIT",
        "09/17/2007",
        "PDF",
        "DELJIT97A-17SEP2007.pdf"
      ],
      [
        "Despatch Advice Message",
        "DESADV",
        "06/17/2009",
        "PDF",
        "DESADVD98B2009-06-17.pdf"
      ],
      [
        "Invoice Message-Domestic",
        "INVOIC",
        "11/14/2008",
        "PDF",
        "INVOICD97B.pdf"
      ],
      [
        "Invoice Message-International",
        "INVOIC",
        "11/14/2008",
        "PDF",
        "INVOICD97A.pdf"
      ],
      [
        "Receiving Advice Message",
        "RECADV",
        "11/14/2008",
        "PDF",
        "RECADVD97A.pdf"
      ],
      [
        "EDI - Implementation Guides",
        "N/A",
        "N/A",
        "WebSite",
        "http://supplier.cummins.com/wps/portal/SupplierPortal/SupplierHome/SupplierPayments/InvoicingForDirectProducts/ElectronicCommerce/EDIImplementationInformation"
      ],
      [
        "EDI FAQs and General Questions",
        "N/A",
        "N/A",
        "WebSite",
        "http://supplier.cummins.com/wps/portal/SupplierPortal/SupplierHome/SupplierPayments/InvoicingForDirectProducts/ElectronicCommerce/EDIFAQ"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Custom-Pak, Inc.",
    "missing": true
  },
  {
    "id": "missing",
    "name": "CVS Pharmacy",
    "missing": true
  },
  {
    "id": "missing",
    "name": "D&R Technology LLC",
    "missing": true
  },
  {
    "id": "Daechang",
    "name": "Daechang Seat Co., Ltd USA",
    "customMessage": true,
    "ediDocs": [
      [
        "Release",
        "830",
        "03/23/2018",
        "PDF",
        "Daechang_830_v1.0.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Daewoo Internation Corp. (America)",
    "missing": true
  },
  {
    "id": "daftrucks",
    "name": "DAF Trucks",
    "ediDocs": [
      [
        "Delivery Forecast",
        "DELFOR",
        "09/23/2003",
        "PDF",
        "DAFDelforSpec.pdf"
      ],
      [
        "Despatch Advice",
        "DESADV",
        "09/13/2002",
        "PDF",
        "DAFDesadvSpec.pdf"
      ],
      [
        "Invoice Message",
        "INVOIC",
        "06/02/2009",
        "PDF",
        "DAFInvoicSpec11D.pdf"
      ]
    ]
  },
  {
    "id": "daimler",
    "name": "Daimler",
    "ediDocs": [
      [
        "Daimler"
      ],
      [
        "Delivery Schedule Message",
        "DELFOR",
        "08/20/2004",
        "PDF",
        "DBPC_DELFOR_VDA4905_E_20_08_2004.pdf"
      ],
      [
        "Despatch Advice Message",
        "DESADV",
        "01/31/2006",
        "PDF",
        "DBPC_DESADV_DESA_ENG_31_01_2006.pdf"
      ],
      [
        "Daimler"
      ],
      [
        "EDI Manual",
        "All Transactions",
        "01/15/2018",
        "PDF",
        "WTL_01_008_2014-12 (004) Daimler 4913.pdf"
      ]
    ]
  },
  {
    "id": "daimlertruck",
    "name": "Daimler Truck North America",
    "vendorLink": "https://daimler.portal.covisint.com/web/freightliner/downloads/-/journal_content/",
    "ediDocs": [
      [
        "Supplier Documents",
        "",
        "",
        "URL",
        "https://docmaster.supplier.daimler.com/DMPublic/en/index.html"
      ],
      [
        "Accounts Payable EDI"
      ],
      [
        "Invoice",
        "810",
        "09/29/2014",
        "PDF",
        "810Iv4010-DTNA-V2-4.pdf"
      ],
      [
        "Remittance Advice",
        "820",
        "9/14/2010",
        "PDF",
        "820O3040DTNAv2_1.pdf"
      ],
      [
        "Application Advice",
        "824",
        "12/20/2011",
        "PDF",
        "824O4010DTNA810v3-2.pdf"
      ],
      [
        "Rejection Analysis Guide for 810",
        "824",
        "March 2020",
        "PDF",
        "EDI_824_Invoice_Rejection_Guide.pdf"
      ],
      [
        "Aftermarket EDI"
      ],
      [
        "Purchase Order",
        "850",
        "05/20/2016",
        "PDF",
        "850O4010DTNA-AFTMKTv3-1_upcoming_changes.pdf"
      ],
      [
        "Purchase Order Acknowledgement",
        "855",
        "05/25/2016",
        "PDF",
        "855Iv4010-DTNA-AFTMKT-V5-0_upcoming_changes.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "12/07/2016",
        "PDF",
        "856Iv4010-DTNA-AFTMKT-V4-7_upcoming_changes.pdf"
      ],
      [
        "Receiving Advice",
        "861",
        "9/10/2012",
        "PDF",
        "861Ov4010-DTNA-AFTMKT-V3-0.pdf"
      ],
      [
        "Functional Acknowledgment",
        "997",
        "02/18/2008",
        "PDF",
        "997I4010DTNASupplierv2_0.pdf"
      ],
      [
        "Manufacturing EDI"
      ],
      [
        "Application Advice",
        "824",
        "09/27/2017",
        "PDF",
        "824O4010DTNA856v3-2.pdf"
      ],
      [
        "Release",
        "830",
        "08/06/2015",
        "PDF",
        "830Ov2000-DTNA-MFG-V4-1.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "10/20/2015",
        "PDF",
        "850O4010DTNA-Mafgv1-0.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "09/05/2017",
        "PDF",
        "856Iv4010-DTNA-MFG-V4-9.pdf"
      ],
      [
        "Purchase Order Change Request",
        "860",
        "10/20/2015",
        "PDF",
        "860O4010DTNA-Mafgv1-0.pdf"
      ],
      [
        "Receiving Advice",
        "861",
        "01/2010",
        "PDF",
        "861v3050DTNAMFGv3_00.pdf"
      ],
      [
        "Shipping Schedule",
        "862",
        "08/26/2015",
        "PDF",
        "862Ov3020-DTNA-MFG-V4-0.pdf"
      ],
      [
        "Production Sequence",
        "866",
        "08/26/2015",
        "PDF",
        "866Ov3010-DTNA-MFG-V5-2.pdf"
      ],
      [
        "Warehouse Shipping Order",
        "940",
        "05/09/2017",
        "PDF",
        "940Ov4010-DTNA-V1.0.pdf"
      ],
      [
        "Functional Acknowledgment",
        "997",
        "01/2010",
        "PDF",
        "997v4010DTNAv3.0.pdf"
      ],
      [
        "Error Code",
        "",
        "03/23/2010",
        "PDF",
        "Error Code for Mafg.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Dakkota Integrated Systems",
    "missing": true
  },
  {
    "id": "dana",
    "name": "Dana Corporation",
    "customMessage": true,
    "ediDocs": [
      [
        "Release",
        "830",
        "04/16/2008",
        "PDF",
        "Dana_Axle_Driveshaft_830_v2003.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "10/15/2002",
        "PDF",
        "Dana850.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "09/12/2016",
        "PDF",
        "Dana_Corp_SAP_856_v4010_Supplier_Specifications-Jan2017.pdf"
      ],
      [
        "Light Axle Plant List",
        "N/A",
        "05/01/2008",
        "PDF",
        "Light_Axle_Plants.pdf"
      ],
      [
        "Driveshaft Plant List",
        "N/A",
        "05/01/2008",
        "PDF",
        "Driveshaft_duns_table.pdf"
      ]
    ]
  },
  {
    "id": "dayco",
    "name": "Dayco",
    "imgFileName": "Dayco.png",
    "ediDocs": [
      [
        "Aftermarket"
      ],
      [
        "Invoice",
        "810",
        "10/01/2015",
        "PDF",
        "Dayco Aftermarket 810 4010 Specs.pdf"
      ],
      [
        "Application Advice",
        "824",
        "10/01/2015",
        "PDF",
        "Dayco Aftermarket 824 4010 Specs.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "10/01/2015",
        "PDF",
        "Dayco Aftermarket 850 4010 Specs.pdf"
      ],
      [
        "Advance Ship Notice",
        "856",
        "10/01/2015",
        "PDF",
        "Dayco Aftermarket 856 4010 Specs.pdf"
      ],
      [
        "Purchase Order Change",
        "860",
        "10/01/2015",
        "PDF",
        "Dayco Aftermarket 860 4010 Specs.pdf"
      ],
      [
        "Functional Acknowledgment",
        "997",
        "10/01/2015",
        "PDF",
        "Dayco Aftermarket 997 4010 Specs.pdf"
      ],
      [
        "EDI Code Appendix",
        "",
        "08/18/2015",
        "PDF",
        "Dayco Aftermarket EDI Code Appendix.pdf"
      ],
      [
        "EDI Implementation Guide",
        "",
        "11/19/2013",
        "PDF",
        "Dayco Aftermarket EDI Implementation Guide.pdf"
      ],
      [
        "OEM"
      ],
      [
        "Invoice",
        "810",
        "02/14/2018",
        "PDF",
        "Dayco 810 4010 Specs_Updated.pdf"
      ],
      [
        "Application Advice",
        "824",
        "02/14/2018",
        "PDF",
        "Dayco 824 4010 Specs.pdf"
      ],
      [
        "Material Release",
        "830",
        "02/14/2018",
        "PDF",
        "Dayco 830 4010 Specs.pdf"
      ],
      [
        "Advance Ship Notice",
        "856",
        "02/14/2018",
        "PDF",
        "Dayco 856 4010 Specs.pdf"
      ],
      [
        "Receiving Advice",
        "861",
        "02/14/2018",
        "PDF",
        "Dayco 861 4010 Specs.pdf"
      ],
      [
        "Ship Schedule",
        "862",
        "02/14/2018",
        "PDF",
        "Dayco 862 4010 Specs.pdf"
      ],
      [
        "Functional Acknowledgment",
        "997",
        "02/14/2018",
        "PDF",
        "Dayco 997 4010 Specs.pdf"
      ],
      [
        "EDI Code Appendix",
        "",
        "11/10/2015",
        "PDF",
        "Dayco EDI Code Appendix.pdf"
      ],
      [
        "EDI Implementation Guide",
        "",
        "11/10/2015",
        "PDF",
        "Dayco EDI Implementation Guide.pdf"
      ]
    ]
  },
  {
    "id": "daytonfreight",
    "name": "Dayton Freight",
    "ediDocs": [
      [
        "Motor Carrier Bill of Lading",
        "211",
        "02/02/2007",
        "PDF",
        "211_4010.pdf"
      ]
    ]
  },
  {
    "id": "ddmplastics",
    "name": "DDM Plastics",
    "ediDocs": [
      [
        "Release",
        "830",
        "01/08/2004",
        "PDF",
        "830Doc.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "01/08/2004",
        "PDF",
        "856Doc.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Decoma (Mexico)",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Decoplas S.A. De C.V.",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Dedek & Bock Spring Mfg. Co",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Defiance Metal",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Delaware Valley Corp.",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Delco Corporation",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Delfingen Industry Group",
    "missing": true
  },
  {
    "id": "delphi",
    "name": "Delphi Automotive Systems",
    "vendorLink": "https://delphi.portal.covisint.com/web/portal/vega/-/journal_content/56_INSTANCE_pJy9/107627/114729",
    "ediDocs": [
      [
        "Application Error and Acknowledgement",
        "APERAK",
        "03/22/2001",
        "PDF",
        "aperak.pdf"
      ],
      [
        "Control",
        "CONTRL",
        "02/09/2001",
        "PDF",
        "Contrl.pdf"
      ],
      [
        "Delivery Schedule",
        "DELFOR",
        "04/05/2005",
        "PDF",
        "Delphi_delfor.pdf"
      ],
      [
        "Delivery Just In Time",
        "DELJIT",
        "03/31/2010",
        "PDF",
        "Delphi_deljit.pdf"
      ],
      [
        "Despatch Advice",
        "DESADV",
        "02/24/2012",
        "PDF",
        "Delphi_desadv.pdf"
      ],
      [
        "Receiving Advice",
        "RECADV",
        "09/20/2001",
        "PDF",
        "RECADV.pdf"
      ],
      [
        "VEGA Help Guide",
        "",
        "06/18/2003",
        "PDF",
        "vegahelpguide.pdf"
      ]
    ]
  },
  {
    "id": "delphissg",
    "name": "Delphi Steering Systems",
    "ediDocs": [
      [
        "Release",
        "830",
        "07/01/2003",
        "PDF",
        "830.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "04/01/1998",
        "PDF",
        "856.pdf"
      ],
      [
        "Ship Schedule",
        "862",
        "06/01/2005",
        "PDF",
        "862.pdf"
      ],
      [
        "Label Specifications",
        "N/A",
        "11/01/2007",
        "PDF",
        "n_a_label_spec.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Denso International (DTAM)",
    "missing": true
  },
  {
    "id": "DensoNA",
    "name": "Denso North America",
    "ediDocs": [
      [
        "Application Advice",
        "824",
        "03/29/2012",
        "PDF",
        "824 specs.pdf"
      ],
      [
        "Release",
        "830",
        "03/29/2012",
        "PDF",
        "830 specs.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "03/23/2012",
        "PDF",
        "856 specs.pdf"
      ],
      [
        "Receiving Advice",
        "861",
        "January 2013",
        "PDF",
        "861 specs.pdf"
      ],
      [
        "Shipping Schedule",
        "862",
        "03/29/2012",
        "PDF",
        "862 specs.pdf"
      ],
      [
        "Label Specifications",
        "",
        "",
        "PDF",
        "label specs.pdf"
      ]
    ]
  },
  {
    "id": "detroitdiesel",
    "name": "Detroit Diesel",
    "ediDocs": [
      [
        "Application Advice",
        "824",
        "02/23/2007",
        "PDF",
        "DDC_824_Application_Advice.pdf"
      ],
      [
        "Release",
        "830",
        "10/11/2011",
        "PDF",
        "DDC_830_Release.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "08/28/2024",
        "PDF",
        "20240903_Supplier EDI Spec.pdf"
      ],
      [
        "Shipping Schedule",
        "862",
        "10/11/2011",
        "PDF",
        "DDC_862_Shipping_Schedule.pdf"
      ],
      [
        "Text Message",
        "864",
        "08/01/1991",
        "PDF",
        "DDC_864_Text_Message.pdf"
      ],
      [
        "Functional Acknowledgment",
        "997",
        "07/16/2004",
        "PDF",
        "DDC_997_Functional_Acknowledgment.pdf"
      ]
    ]
  },
  {
    "id": "detroitmanufacturingsystems",
    "name": "Detroit Manufacturing Systems",
    "ediDocs": [
      [
        "Delivery Schedule Message",
        "DELFOR",
        "04/20/2017",
        "PDF",
        "DMS_DELFOR_d97a_v1.1.pdf"
      ],
      [
        "Despatch Advice Message",
        "DESADV",
        "10/13/2020",
        "PDF",
        "DMS_DESADV_d97a_v1.3.pdf"
      ]
    ]
  },
  {
    "id": "detroitmedicalcenter",
    "name": "Detroit Medical Center",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "06/23/2009",
        "PDF",
        "DetroitMedicalCenter810.pdf"
      ],
      [
        "Price/Sales Catalog",
        "832",
        "06/23/2009",
        "PDF",
        "DetroitMedicalCenter832.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "DH Howden",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Dial Corporation",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Dicks",
    "missing": true
  },
  {
    "id": "dillards",
    "name": "Dillards",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "05/15/2012",
        "PDF",
        "DILLARDS810map4030guidelinedoc.pdf.pdf"
      ],
      [
        "Credit/Debit Memo",
        "812",
        "09/13/2012",
        "PDF",
        "DILLARDS812map4030guidelinedoc.pdf.pdf"
      ],
      [
        "Organizational Relationship",
        "816",
        "03/15/2011",
        "PDF",
        "DILLARDS816map4030guidelinedoc.pdf.pdf"
      ],
      [
        "Payment OrderRemittance Advice",
        "820",
        "02/28/2011",
        "PDF",
        "DILLARDS820map4030guidelinedoc.pdf.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "11/27/2012",
        "PDF",
        "DILLARDS850map4030guidelinedoc.pdf.pdf"
      ],
      [
        "Product Activity",
        "852",
        "02/28/2011",
        "PDF",
        "DILLARDS852map430guidelinedoc.pdf.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "04/15/2015",
        "PDF",
        "DILLARDS856map4030guidelinedoc.pdf.pdf"
      ],
      [
        "Purchase Order Change",
        "860",
        "08/04/2011",
        "PDF",
        "DILLARDS860map4030guidelinedoc.pdf.pdf"
      ],
      [
        "Text Message",
        "864",
        "05/20/2015",
        "PDF",
        "DILLARDS864map4030guidelinedoc.pdf.pdf"
      ],
      [
        "Functional Acknowledgement",
        "997",
        "02/28/2011",
        "PDF",
        "DILLARDS997map4030guidelinedoc.pdf.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "DimcoGray Corporation",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Directions Studio LLC",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Display Specialists",
    "missing": true
  },
  {
    "id": "diversifiedmachine",
    "name": "Diversified Machine",
    "ediDocs": [
      [
        "EDI Specs",
        "",
        "05/15/2007",
        "PDF",
        "Diversified_Machine_EDI_Guidelines.pdf"
      ],
      [
        "Bar Code Specs",
        "",
        "08/04/1999",
        "PDF",
        "DMI-BARCODE.pdf"
      ],
      [
        "FAQ",
        "",
        "05/15/2007",
        "PDF",
        "EDI_FAQ.pdf"
      ]
    ]
  },
  {
    "id": "dmax",
    "name": "Dmax",
    "ediDocs": [
      [
        "Delivery Schedule",
        "DELFOR",
        "05/22/2003",
        "PDF",
        "DMAX_DELFOR_IG_V05.pdf"
      ],
      [
        "Delivery Just In Time",
        "DELJIT",
        "05/22/2003",
        "PDF",
        "DMAX_DELJIT_IG_V05.pdf"
      ],
      [
        "Despatch Advice",
        "DESADV",
        "06/17/2003",
        "PDF",
        "DMAX_DESADV_IG_V02.pdf"
      ]
    ]
  },
  {
    "id": "doitbestcorp",
    "name": "Do It Best Corp",
    "ediDocs": [
      [
        "Invoice (4010)",
        "810",
        "3/06/2012",
        "PDF",
        "810V4010_Invoice1.0.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Dofasco Tube",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Dollar Tree",
    "missing": true
  },
  {
    "id": "Domtar",
    "name": "Domtar",
    "ediDocs": [
      [
        "Motor Carrier Load Tender",
        "204",
        "03/12/2002",
        "PDF",
        "204SPECS_toolkit.pdf"
      ],
      [
        "Shipment Status Message",
        "214",
        "03/12/2002",
        "PDF",
        "214SPECS_toolkit.pdf"
      ],
      [
        "Response to a Load Tender",
        "990",
        "03/12/2002",
        "PDF",
        "990SPECS_toolkit.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "DOTS",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Dr. Schneider GMBH",
    "missing": true
  },
  {
    "id": "draexlmaier",
    "name": "Draexlmaier",
    "ediDocs": [
      [
        "Delivery Forcast Message",
        "DELFOR",
        "07/16/2008",
        "PDF",
        "Draexlmaier_Implementation_Guidelines_for_DELFOR_D97.A_v1.7.pdf"
      ],
      [
        "Delivery Just In Time Message",
        "DELJIT",
        "07/14/2008",
        "PDF",
        "Draexlmaier_Implementation_Guidelines_for_DELJIT_D97.A_v1.0.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Dressbarn",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Drive Train Industries",
    "missing": true
  },
  {
    "id": "drugstor",
    "name": "Drugstor",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "01/03/2014",
        "PDF",
        "DRUGSTOR_810_v1.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "09/14/2008",
        "PDF",
        "DRUGSTOR_850_v1.pdf"
      ],
      [
        "Purchase Order Acknowledgement",
        "855",
        "10/09/2007",
        "PDF",
        "DRUGSTOR_855.pdf"
      ],
      [
        "Advance Ship Notice",
        "856",
        "08/30/2007",
        "PDF",
        "DRUGSTOR_856.pdf"
      ],
      [
        "Functional Acknowledgment",
        "997",
        "10/12/2007",
        "PDF",
        "DRUGSTOR_997.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Duane Reade",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Dupont",
    "missing": true
  },
  {
    "id": "dura",
    "name": "Dura Automotive",
    "ediDocs": [
      [
        "Material Release",
        "830",
        "03/24/2011",
        "PDF",
        "DURA_830_Specs.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "03/25/2011",
        "PDF",
        "DURA_856_Specs.pdf"
      ],
      [
        "Receiving Advice",
        "861",
        "",
        "PDF",
        "Dura 861.pdf"
      ],
      [
        "Supplier Guide",
        "N/A",
        "01/12/2000",
        "PDF",
        "EDI_Supplier_Guide.pdf"
      ],
      [
        "Shipping Label Supplier Guide ",
        "N/A",
        "10/18/2007",
        "PDF",
        "Dura_Shipping_label_Guide.pdf"
      ],
      [
        "Label Example",
        "N/A",
        "N/A",
        "PDF",
        "Dura_label_Example.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Duranco",
    "missing": true
  },
  {
    "id": "paccar",
    "name": "Dynacraft (A Division of Paccar)",
    "customMessage": true
  },
  {
    "id": "dynamic",
    "name": "Dynamic Manufacturing",
    "ediDocs": [
      [
        "Delivery Forecast",
        "DELFOR",
        "05/23/2024",
        "DOC",
        "Dynamic DELFOR.docx"
      ],
      [
        "Despatch Advice",
        "DESADV",
        "11/01/2001",
        "DOC",
        "DYNAMIC_DESADV_20200507.docx"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Dynamic Paint Products",
    "missing": true
  },
  {
    "id": "dynax",
    "name": "Dynax Corporation",
    "imgFileName": "dynax.bmp",
    "ediDocs": [
      [
        "Planning Schedule -- Weekly Release (4010)",
        "830",
        "06/23/2011",
        "PDF",
        "DXA_830.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "E.R. Wagner Mfg.",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Eastman Footwear Corporation",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Eastman Kodak",
    "missing": true
  },
  {
    "id": "eaton",
    "name": "Eaton Corporation",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "07/26/2006",
        "PDF",
        "http://www.eaton.com/ecm/groups/public/@pub/@eaton/@corp/documents/content/98065446.pdf"
      ],
      [
        "Application Advice",
        "824",
        "12/15/2003",
        "PDF",
        "http://www.eaton.com/ecm/groups/public/@pub/@eaton/@corp/documents/content/98065455.pdf"
      ],
      [
        "Release",
        "830",
        "10/10/2006",
        "PDF",
        "http://www.eaton.com/ecm/groups/public/@pub/@eaton/@corp/documents/content/98065456.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "09/07/2006",
        "PDF",
        "http://www.eaton.com/ecm/groups/public/@pub/@eaton/@corp/documents/content/98065457.pdf"
      ],
      [
        "Delivery Schedule",
        "862",
        "07/25/2002",
        "PDF",
        "http://www.eaton.com/ecm/groups/public/@pub/@eaton/@corp/documents/content/98065458.pdf"
      ],
      [
        "Delivery Schedule",
        "DELFOR",
        "06/18/2004",
        "PDF",
        "http://www.eaton.com/ecm/groups/public/@pub/@eaton/@corp/documents/content/98065460.pdf"
      ],
      [
        "Despatch Advice",
        "DESADV",
        "06/18/2004",
        "PDF",
        "http://www.eaton.com/ecm/groups/public/@pub/@eaton/@corp/documents/content/98065461.pdf"
      ],
      [
        "Control",
        "CONTRL",
        "10/21/2004",
        "PDF",
        "http://www.eaton.com/ecm/groups/public/@pub/@eaton/@corp/documents/content/98065459.pdf"
      ]
    ]
  },
  {
    "id": "eberspacher",
    "name": "Eberspacher",
    "ediDocs": [
      [
        "Delivery Forcast",
        "DELFOR",
        "08/01/2007",
        "PDF",
        "delfor.pdf"
      ],
      [
        "Despatch Advice",
        "DESADV",
        "04/18/2018",
        "PDF",
        "ENA_EDI Implementation_Guide_6.30.2016.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "EBY",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Echelon Corporation",
    "missing": true
  },
  {
    "id": "edminiat",
    "name": "Ed Miniat",
    "customMessage": true,
    "ediDocs": [
      [
        "Advanced Ship Notice",
        "856",
        "08/27/2015",
        "PDF",
        "EdMiniat_856_Specification_20150909.pdf"
      ]
    ]
  },
  {
    "id": "eds",
    "name": "EDS",
    "ediDocs": [
      [
        "FTP Users Guide",
        "",
        "01/09/2003",
        "PDF",
        "EDS.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Eikenberry & Associates",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Elder Beerman",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Electrical Supplies",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Elgin Die Mold",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Ellsworth Adhesive",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Emcon",
    "missing": true
  },
  {
    "id": "emersonpowertransmission",
    "name": "Emerson Power Transmission",
    "ediDocs": [
      [
        "Purchase Order",
        "850",
        "04/24/2008",
        "PDF",
        "EPT_850_4010.pdf"
      ],
      [
        "Purchase Order Changes",
        "860",
        "04/24/2008",
        "PDF",
        "EPT_860_4010.pdf"
      ],
      [
        "Guide",
        "",
        "04/24/2008",
        "PDF",
        "EDI_Trading_Partner_Profile.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "EMJ Metals",
    "missing": true
  },
  {
    "id": "empireelectronics",
    "name": "Empire Electronics, Inc.",
    "ediDocs": [
      [
        "Release",
        "830",
        "06/25/2004",
        "PDF",
        "EEi830_Implementation Guide.pdf"
      ]
    ]
  },
  {
    "id": "emp",
    "name": "Engineered Machined Products Inc.",
    "ediDocs": [
      [
        "Release",
        "830",
        "02/01/2003",
        "PDF",
        "EMP_830_4010.pdf"
      ],
      [
        "Shipping Schedule",
        "862",
        "05/01/2003",
        "PDF",
        "EMP_862_4010.pdf"
      ],
      [
        "Facility Addresses",
        "",
        "04/24/2008",
        "PDF",
        "EMP_Facility_Address_Master.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "England Corsair",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Enplas",
    "missing": true
  },
  {
    "id": "EnterpriseElectronics",
    "name": "Enterprise Electronics",
    "customMessage": true,
    "ediDocs": [
      [
        "Release",
        "830",
        "06/03/2016",
        "PDF",
        "EnterpriseElectronics_830_1 1.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "10/20/2023",
        "PDF",
        "Enterprise_Electronics_856_Ship_Notice.pdf"
      ]
    ]
  },
  {
    "id": "envision",
    "name": "Envision",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "02/01/2003",
        "PDF",
        "810_MAS90_x12_4010.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "05/01/2003",
        "PDF",
        "850_MAS90_x12_4010.pdf"
      ],
      [
        "Facility Addresses",
        "855",
        "04/24/2008",
        "PDF",
        "855_MAS90_x12_4010.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "EPC Range Road",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Equinox",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Erb Co., Inc.",
    "missing": true
  },
  {
    "id": "esl",
    "name": "ESL",
    "ediDocs": [
      [
        "Release",
        "830",
        "06/26/1998",
        "PDF",
        "Shipment_Schedule_Import_File_Description_830.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "03/05/2004",
        "PDF",
        "Shipment_Results_Specifications_856.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Estes Express",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Evco Plastics",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Exacto Spring Corporation",
    "missing": true
  },
  {
    "id": "exide",
    "name": "Exide Technologies",
    "ediDocs": [
      [
        "Purchase Order Acknowledgement",
        "855",
        "03/06/2009",
        "PDF",
        "Exide_855_Inbound_V4010_Map2.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Export Corporation",
    "missing": true
  },
  {
    "id": "facil",
    "name": "Facil",
    "ediDocs": [
      [
        "EDI Parameters",
        "N/A",
        "11/21/2012",
        "PDF",
        "EDI-Parameters request form.pdf"
      ],
      [
        "Implementation Guidelines",
        "DESADV",
        "01/01/2007",
        "PDF",
        "Facil DESADV Guidelines-Edifact.pdf"
      ],
      [
        "EDI Implementation Documentation ",
        "DELFOR",
        "01/08/2007",
        "PDF",
        "Infor DELFOR.PDF"
      ]
    ]
  },
  {
    "id": "fagor",
    "name": "Fagor Ederlan",
    "ediDocs": [
      [
        "Release",
        "DELFOR",
        "06/15/2018",
        "PDF",
        "FAGOR EDERLAN GLOBAL DELFOR VDA4984 V1.1.pdf"
      ],
      [
        "Ship Notice",
        "DESADV",
        "03/17/2021",
        "PDF",
        "FAGOR EDERLAN GLOBAL DESADV VDA4987 V1.4.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Fairway Products",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Familiprix",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Family Dollar",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Fastco Industries",
    "missing": true
  },
  {
    "id": "faurecia",
    "name": "Faurecia",
    "vendorLink": "https://www.forvia.com/en/edi-portal",
    "ediDocs": [
      [
        "Logistic flows, Levelled procurement"
      ],
      [
        "Daily Ship Schedule (D.96A)",
        "DELJIT",
        "11/24/2017",
        "PDF",
        "faurecia_edi_guideline_deljit_d96a_manifest_v4r0.pdf"
      ],
      [
        "Daily Ship Schedule (D.97A)",
        "DELJIT",
        "05/11/2018",
        "PDF",
        "faurecia_edi_guideline_deljit_d97a_manifest_v4r0_0.pdf"
      ],
      [
        "Logistic flows, Levelled and Non-Levelled procurement"
      ],
      [
        "Weekly Planning Schedule (D.96A)",
        "DELFOR",
        "03/23/2022",
        "PDF",
        "Faurecia EDI Guideline DELFOR D96A V3R1 New.pdf"
      ],
      [
        "Weekly Planning Schedule (D.97A)",
        "DELFOR",
        "11/13/2024",
        "PDF",
        "Faurecia EDI Guideline DELFOR D97A V2R2 New.pdf"
      ],
      [
        "Logistic Flows, Ship-Notice and Labels from Supplier"
      ],
      [
        "Ship Notice (D.96A)",
        "DESADV",
        "03/12/2024",
        "PDF",
        "Faurecia EDI Guideline DESADV D96A V3R5 New.pdf"
      ],
      [
        "Ship Notice (D.97A)",
        "DESADV",
        "03/12/2024",
        "PDF",
        "Faurecia EDI Guideline DESADV D97A V6R5 New.pdf"
      ],
      [
        "Labels",
        "N/A",
        "06/15/2024",
        "PDF",
        "Faurecia_guideline_GTL_2D_BARCODE_SLC1_AIAG_V1.3.pdf"
      ],
      [
        "Labels",
        "N/A",
        "12/17/2024",
        "PDF",
        "faurecia_project_eti9_b10_lisa_v1.0.pdf"
      ],
      [
        "Financial flows"
      ],
      [
        "Daily Ship Schedule",
        "DELJIT",
        "11/21/2002",
        "PDF",
        "FaureciaDELJIT.pdf"
      ],
      [
        "Advance Shipping Notice",
        "DESADV",
        "11/21/2002",
        "PDF",
        "FaureciaDESADV.pdf"
      ]
    ]
  },
  {
    "id": "fastenal",
    "name": "Fastenal",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "04/20/2012",
        "PDF",
        "810-Fastenal.pdf"
      ],
      [
        "Remittance Advice",
        "820",
        "02/15/2004",
        "PDF",
        "820-Fastenal.pdf"
      ],
      [
        "Application Advice",
        "824",
        "06/30/2009",
        "PDF",
        "824-Fastenal.pdf"
      ],
      [
        "Inventory Advice(4010)",
        "846",
        "07/22/2014",
        "PDF",
        "846-Fastenal v4010-1.pdf"
      ],
      [
        "Inventory Advice(5030)",
        "846",
        "07/22/2014",
        "PDF",
        "846-Fastenal v5030.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "04/12/2012",
        "PDF",
        "Fastenal_Spec_850_v4010_Combined_20120412.pdf.pdf"
      ],
      [
        "Purchase Order Acknowledgment",
        "855",
        "05/10/2012",
        "PDF",
        "Fastenal_Spec_855_v4010_10192009.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "05/13/2015",
        "PDF",
        "Fastenal 4010 856 ASN EDI Guidelines.pdf"
      ],
      [
        "Vendor Shipping Label Requirements",
        "",
        "",
        "PDF",
        "Vendor Shipping Label Requirements.pdf"
      ]
    ]
  },
  {
    "id": "FCC",
    "name": "FCC",
    "customMessage": true,
    "ediDocs": [
      [
        "Application Advice",
        "824",
        "11/11/2015",
        "PDF",
        "New824specs.pdf"
      ],
      [
        "Release",
        "830",
        "04/02/2015",
        "PDF",
        "FCC_830.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "04/03/2015",
        "PDF",
        "FCC_850.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "02/18/2019",
        "PDF",
        "856 Spec 2-26-2019 1113_001.pdf"
      ],
      [
        "Ship Schedule",
        "862",
        "04/02/2015",
        "PDF",
        "FCC_862.pdf"
      ],
      [
        "Master Label Requirements",
        "",
        "",
        "PDF",
        "Final_FCC_Master Label_09_24_18.pdf"
      ],
      [
        "Container Label Requirements",
        "",
        "",
        "PDF",
        "Final_FCC_ContainerLabelSpec_09_24_18.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "FCI",
    "missing": true
  },
  {
    "id": "federalmogul",
    "name": "Federal Mogul",
    "ediDocs": [
      [
        "Release",
        "830",
        "07/07/2003",
        "PDF",
        "FMEDI830_3020.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "11/01/1995",
        "PDF",
        "FM856.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "07/07/2003",
        "PDF",
        "FMEDI850.pdf"
      ],
      [
        "Purchase Order Acknowledgement",
        "855",
        "07/07/2003",
        "PDF",
        "FMEDI855.pdf"
      ],
      [
        "Purchase Order Change Request",
        "860",
        "07/07/2003",
        "PDF",
        "FMEDI860.pdf"
      ],
      [
        "Purchase Order Change Acknowledgement",
        "865",
        "07/07/2003",
        "PDF",
        "FMEDI865.pdf"
      ],
      [
        "Asynch Instructions",
        "",
        "07/07/2003",
        "PDF",
        "FM Asynch Instructions.pdf"
      ],
      [
        "Powertrain"
      ],
      [
        "Invoice",
        "810",
        "08/08/2008",
        "PDF",
        "Federal-Mogul_810_ver4010_Everest.pdf"
      ],
      [
        "Release",
        "830",
        "01/26/2014",
        "PDF",
        "FM830out.pdf"
      ],
      [
        "Purchase Order",
        "850",
        " Dec 2014",
        "PDF",
        "850_FEDERAL_20140520.pdf"
      ],
      [
        "Ship Notice/Manifest",
        "856",
        "Nov 2015",
        "PDF",
        "856_FEDERAL_Powertrain_revised.pdf"
      ],
      [
        "Purchase Order Change Request",
        "860",
        "07/18/2008",
        "PDF",
        "Federal-Mogul_860_ver4010_Everest.pdf"
      ],
      [
        "Motor Parts"
      ],
      [
        "Purchase Order",
        "850",
        "05/04/2016",
        "PDF",
        "Federal-Mogul 850 ver4010 - SAP.pdf"
      ],
      [
        "Ship Notice/Manifest",
        "856",
        "07/22/2008",
        "PDF",
        "Federal-Mogul 856 ver4010 - SAP.pdf"
      ],
      [
        "Purchase Order Change Request",
        "860",
        "05/04/2016",
        "PDF",
        "Federal-Mogul 860 ver4010 - SAP.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Federal Screw Works",
    "missing": true
  },
  {
    "id": "federatedcoop",
    "name": "Federated COOP",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "2/11/2016",
        "PDF",
        "Federated Invoice_Guide.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "",
        "PDF",
        "Federated FOOD_po_Vics_850_Guide.pdf.pdf"
      ],
      [
        "EDI Implementation Guide",
        "",
        "",
        "PDF",
        "Federated Food_Duns_and_Password_Info.pdf.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "FedEx Freight",
    "missing": true
  },
  {
    "id": "fedex-kinkos",
    "name": "FedEx-Kinkos",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "07/14/2006",
        "PDF",
        "FedEx_810_4010.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Fiberesin Industries, Inc",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Fiberlinks Textiles, Inc.",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Filens (May Dept Stores)",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Findlay Industries",
    "missing": true
  },
  {
    "id": "missing",
    "name": "FirstGroup America",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Fisher Dynamics",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Flambeau Products",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Flat Rock Metal",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Flex Technologies Inc.",
    "missing": true
  },
  {
    "id": "flex-n-gate",
    "name": "Flex-N-Gate",
    "ediDocs": [
      [
        "Release",
        "830",
        "03/11/2013",
        "PDF",
        "FNG_830.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "11/07/2013",
        "PDF",
        "FNG_856.pdf"
      ],
      [
        "Shipping Schedule",
        "862",
        "03/01/1999",
        "PDF",
        "FNG_862_4010.pdf"
      ],
      [
        "Guide",
        "",
        "05/06/2004",
        "PDF",
        "FNG_EDI_Overview.pdf"
      ],
      [
        "Label Standards",
        "",
        "11/23/2005",
        "PDF",
        "FNGLineFeedLabelSpecsRev12.pdf"
      ],
      [
        "EDI Overview Steel and Non Steel",
        "",
        "04/03/2013",
        "PDF",
        "FNGAIAGEDIOverviewSteelandRegularRev3.pdf"
      ],
      [
        "EDI Enveloping",
        "",
        "10/09/2003",
        "PDF",
        "FNGAIAGEDIEnvelopingRev11.pdf"
      ],
      [
        "Flex-N-Gate Non-Raw Metal"
      ],
      [
        "Ship Notice",
        "856",
        "02/15/2024",
        "PDF",
        "Flex-N-Gate 856 Advanced Ship Notice Non-Raw Metal Rev 13.pdf"
      ],
      [
        "Label Standards",
        "",
        "01/06/2023",
        "PDF",
        "Flex-N-Gate Label Requirement 2D Standards Version 2023v13.pdf"
      ],
      [
        "Vendor Notes for ASN Timing",
        "",
        "10/10/2024",
        "DOC",
        "Vendor 2D Label and ASN Format Timing example email.docx"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Flexalloy, Inc.",
    "missing": true
  },
  {
    "id": "fluidrouting",
    "name": "Fluid Routing Solutions",
    "ediDocs": [
      [
        "Application Advice",
        "824",
        "02/08/2017",
        "PDF",
        "ACG_824_Application_Advice_02082017.pdf"
      ],
      [
        "Material Release",
        "830",
        "02/08/2017",
        "PDF",
        "ACG_830_Material_Release_02082017.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "02/08/2017",
        "PDF",
        "ACG_856_Advanced_Ship_Notice_02082017.pdf"
      ],
      [
        "Ship Schedule",
        "862",
        "02/08/2017",
        "PDF",
        "ACG_862_Ship_Schedule_02082017.pdf"
      ],
      [
        "Functional Acknowledgement",
        "997",
        "02/08/2017",
        "PDF",
        "ACG_997_Functional_Acknowledgment_02082017.pdf"
      ],
      [
        "Container Label Specifications",
        "",
        "March 2017",
        "PDF",
        "ACG Global Label Standard.pdf"
      ],
      [
        "Supplier Electronic Communications & Labeling Requirements",
        "",
        " March2017",
        "PDF",
        "ACG Supplier Electronic Communications and Labeling.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Foamex Corporation",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Foleys (May Dept Stores)",
    "missing": true
  },
  {
    "id": "foodlion",
    "name": "Food Lion",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "12/30/2014",
        "PDF",
        "FOOD_LION_810_GUIDELINES.pdf.pdf"
      ],
      [
        "Payment Order/Remittance Advice",
        "820",
        "04/14/2013",
        "PDF",
        "FOOD_LION_820_GUIDELINES.pdf.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "12/30/2014",
        "PDF",
        "FOOD_LION_850_GUIDELINES.pdf.pdf"
      ],
      [
        "Product Activity Data",
        "852",
        "12/30/2014",
        "PDF",
        "FOOD_LION_852_GUIDELINES.pdf.pdf"
      ],
      [
        "Purchase Order Acknowledgement",
        "855",
        "12/30/2014",
        "PDF",
        "FOOD_LION_855_GUIDELINES.pdf.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "12/30/2014",
        "PDF",
        "FOOD_LION_856_GUIDELINES.pdf.pdf"
      ],
      [
        "Functional Acknowledgment",
        "997",
        "04/11/2011",
        "PDF",
        "FOOD_LION_997_GUIDELINES.pdf.pdf"
      ]
    ]
  },
  {
    "id": "ford",
    "name": "Ford Motor Company",
    "vendorLink": "https://www.gtpcm.ford.com/edi-specification-tp",
    "ediDocs": [
      [
        "All Specs",
        "N/A",
        "",
        "PDF",
        "Ford_FCSD_Specifications.pdf"
      ],
      [
        "PDC EDI Manual",
        "N/A",
        "05/24/2024",
        "PDF",
        "PDCEDIManual.pdf"
      ],
      [
        "Supplier Direct Ship EDI Manual",
        "N/A",
        "12/10/2007",
        "PDF",
        "SDS_SupplierDirectShipEDIManual.pdf"
      ],
      [
        "Status Details",
        "315",
        "06/23/2003",
        "PDF",
        "I3153050.pdf"
      ],
      [
        "Invoice",
        "810",
        "09/21/2001",
        "PDF",
        "810.pdf"
      ],
      [
        "Remittance Advice",
        "820",
        "10/23/2001",
        "PDF",
        "820.pdf"
      ],
      [
        "Release",
        "830",
        "07/03/2002",
        "PDF",
        "830.pdf"
      ],
      [
        "Price Catalog",
        "832",
        "01/16/2003",
        "PDF",
        "FD832I.pdf"
      ],
      [
        "Benefit Enrollment and Maintenance",
        "834",
        "01/22/2003",
        "PDF",
        "fd834O.pdf"
      ],
      [
        "Request for Quotation",
        "840",
        "08/24/2001",
        "PDF",
        "840.pdf"
      ],
      [
        "Purchase Order (CPARS)",
        "850",
        "09/14/2001",
        "PDF",
        "cpar850.pdf"
      ],
      [
        "Standard Shipping Notice",
        "856",
        "02/11/2002",
        "PDF",
        "856.pdf"
      ],
      [
        "Shipping Notice Primary Metals",
        "856",
        "02/11/2002",
        "PDF",
        "856PM.pdf"
      ],
      [
        "Purchase Order Change (CPARS)",
        "860",
        "06/19/2002",
        "PDF",
        "cpars860.pdf"
      ],
      [
        "Receiving Advice",
        "861",
        "05/06/2003",
        "PDF",
        "FD8612001o.pdf"
      ],
      [
        "Shipping Delivery Schedule",
        "862",
        "01/16/2003",
        "PDF",
        "FD862O.pdf"
      ],
      [
        "Report of Test Results",
        "863",
        "06/25/2009",
        "PDF",
        "Ford863.pdf"
      ],
      [
        "Text Message",
        "864",
        "04/30/2004",
        "PDF",
        "ford864.pdf"
      ],
      [
        "Production Sequence",
        "866",
        "03/19/2003",
        "PDF",
        "FD866O.pdf"
      ],
      [
        "File Transfer",
        "996",
        "04/29/2003",
        "PDF",
        "996_outbound.PDF"
      ],
      [
        "Functional Acknowledgment",
        "997",
        "10/05/2001",
        "PDF",
        "997i.pdf"
      ],
      [
        "Syntax and Service Report",
        "CONTRL",
        "04/29/2003",
        "PDF",
        "CONTRL.pdf"
      ],
      [
        "Delivery Schedule",
        "DELFOR",
        "08/26/2002",
        "PDF",
        "DELFOR.pdf"
      ],
      [
        "Delivery Just In Time",
        "DELJIT",
        "08/02/2001",
        "PDF",
        "fddeljit.pdf"
      ],
      [
        "Despatch Advice",
        "DESADV",
        "01/16/2003",
        "PDF",
        "FDESADV98b.pdf"
      ],
      [
        "Label Standard",
        "",
        "July 2017",
        "PDF",
        "Ford_Label_Specification_Dated July_2017.pdf"
      ],
      [
        "Component Sales"
      ],
      [
        "Invoice",
        "810",
        "09/08/2015",
        "PDF",
        "810.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "09/08/2015",
        "PDF",
        "850.pdf"
      ],
      [
        "Advance Shipping Notice",
        "856",
        "01/26/2007",
        "PDF",
        "856.pdf"
      ],
      [
        "VDA"
      ],
      [
        "Release for Production Material",
        "4905",
        "February 2012",
        "PDF",
        "VDA4905_Ford_Europe.pdf"
      ],
      [
        "Self Billing Invoice",
        "4908",
        "",
        "PDF",
        "VDA4908_Ford_Europe.pdf"
      ],
      [
        "Advance Shipping Notice",
        "4913",
        "June 2013",
        "PDF",
        "VDA4913_Ford_Europe.pdf"
      ],
      [
        "Daily Call in for Production Material",
        "4915",
        "February 2012",
        "PDF",
        "VDA4915_Ford_Europe.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Fort Garry Industries",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Fred Meyer",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Freds Inc",
    "missing": true
  },
  {
    "id": "freightcaramerica",
    "name": "FreightCar America",
    "customMessage": true,
    "ediDocs": [
      [
        "Invoice",
        "810",
        "09/14/2017",
        "PDF",
        "FreightCar America_810_specs_v2_12.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "04/16/2013",
        "PDF",
        "FreightCarAmerica_v4010_850.pdf"
      ],
      [
        "Purchase Order Acknowledgement",
        "855",
        "09/27/2010",
        "PDF",
        "FreightCarAmerica_v4010_855.pdf"
      ],
      [
        "Purchase Order Change",
        "860",
        "03/11/2015",
        "PDF",
        "FreightCarAmerica_v4010_860.pdf"
      ],
      [
        "Purchase Order Acknowledgement",
        "865",
        "09/27/2010",
        "PDF",
        "FreightCarAmerica_v4010_865.pdf"
      ]
    ]
  },
  {
    "id": "freightliner",
    "name": "Freightliner",
    "ediDocs": [
      [
        "Accounting"
      ],
      [
        "Invoice",
        "810 (3010)",
        "04/29/1997",
        "PDF",
        "Freightliner (Accounting)_810_v3010.pdf"
      ],
      [
        "Payment Order / Remittance Advice",
        "820 (3040)",
        "02/10/97",
        "PDF",
        "Freightliner (Accounting)_820_v3040.pdf"
      ],
      [
        "Aftermarket",
        "",
        "",
        "",
        "undefined"
      ],
      [
        "Purchase Order",
        "850 (4010)",
        "07/31/2000",
        "PDF",
        "Freightliner (Aftermrkt)_850_v4010.pdf"
      ],
      [
        "850 (4010) Implementation Guide",
        "850 (4010)",
        "01/09/2003",
        "PDF",
        "Freightliner (Aftermrkt)_850 ImplementationGuide.pdf"
      ],
      [
        "Ship Notice",
        "856 (4010)",
        "05/28/2002",
        "PDF",
        "Freightliner (Aftermrkt)_856_v4010.pdf"
      ],
      [
        "Direct Ship"
      ],
      [
        "810 (3010) Implementation Guide",
        "810",
        "01/09/2003",
        "PDF",
        "Freightliner (DirectShip)_810 ImplementationGuide_v3010.pdf"
      ],
      [
        "OEM"
      ],
      [
        "Application Advice",
        "824 (4010)",
        "05/08/2002",
        "PDF",
        "Freightliner_824_v4010.pdf"
      ],
      [
        "Release",
        "830 (2000)",
        "11/17/2000",
        "PDF",
        "Freightliner_830_v2000.pdf"
      ],
      [
        "Purchase Order Acknowledgement",
        "855 (4010)",
        "05/18/2006",
        "PDF",
        "Frieghtliner855v4010Supplier PO Acknowledgement.pdf"
      ],
      [
        "Ship Notice",
        "856 (4010)",
        "11/11/1999",
        "PDF",
        "Freightliner_856_v4010.pdf"
      ],
      [
        "Shipping Schedule",
        "862 (3020)",
        "08/01/2000",
        "PDF",
        "Freightliner_862_v3020.pdf"
      ],
      [
        "Production Sequence",
        "866 (3010)",
        "08/01/2000",
        "PDF",
        "Freightliner_866_v3010.pdf"
      ],
      [
        "Functional Acknowledgement",
        "997 (4010)",
        "08/27/1999",
        "PDF",
        "Freightliner_997_v4010.pdf"
      ],
      [
        "810 (3010) & 856 (4010) Implementation Guide",
        "",
        "11/09/2003",
        "PDF",
        "Freightliner_810856_Guide.pdf"
      ],
      [
        "OEM & Aftermarket"
      ],
      [
        "Ship Notice",
        "856",
        "05/08/2002",
        "PDF",
        "Freightliner (OEM & Aftermrkt)_856_v4010.pdf"
      ],
      [
        "Miscellaneous"
      ],
      [
        "EDI Overview",
        "",
        "08/06/01",
        "PDF",
        "Freightliner_EDI Overview.pdf"
      ],
      [
        "EDI Requirements",
        "",
        "01/09/2003",
        "PDF",
        "Freightliner_EDI Requirements.pdf"
      ],
      [
        "4010 Interchange Envelope Structure",
        "",
        "11/12/1999",
        "PDF",
        "Freightliner_InterchangeEnvelopeStructure_v4010.pdf"
      ],
      [
        "Ship Codes",
        "",
        "01/09/2003",
        "PDF",
        "Freightliner_Ship Codes.pdf"
      ],
      [
        "Trading Partner Information",
        "",
        "01/09/2003",
        "PDF",
        "Freightliner_TP Info.pdf"
      ]
    ]
  },
  {
    "id": "fteautomotive",
    "name": "FTE Automotive",
    "ediDocs": [
      [
        "Release and Ship Notice Process",
        "NA",
        "08/09/2010",
        "PDF",
        "SQM_3.7_Supplier_Releases_and_ASNs.pdf"
      ],
      [
        "Release",
        "830",
        "04/26/2010",
        "PDF",
        "SQM_9.26_FTE_830_Supplier_Release_Mapping.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "04/26/2010",
        "PDF",
        "SQM_9.27_FTE_856_Supplier_ASN_Mapping.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Futaba Corporation Of America",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Garden Fresh",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Garden Ridge",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Gates Rubber",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Gaymar Industries Inc.",
    "missing": true
  },
  {
    "id": "missing",
    "name": "GDX Canada",
    "missing": true
  },
  {
    "id": "GEAppliances",
    "name": "GE Appliances",
    "ediDocs": [
      [
        "Purchase Order",
        "850",
        "06/19/2016",
        "PDF",
        "GE Appliances 850 Guideline 4010 v1.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "06/19/2016",
        "PDF",
        "GE Appliances 856 Guideline 4010 v2.pdf"
      ],
      [
        "Purchase Order Change Request",
        "860",
        "06/19/2016",
        "PDF",
        "GE Appliances 860 Guideline 4010 v1.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "GE Drives and Control Systems Inc.",
    "missing": true
  },
  {
    "id": "missing",
    "name": "GE Medical Diagnostics",
    "missing": true
  },
  {
    "id": "GeminiGroup",
    "name": "Gemini Group",
    "ediDocs": [
      [
        "Planning Schedule with Release Capability",
        "830",
        "FEBRUARY 1998",
        "PDF",
        "AIAG_830_Gemini.pdf.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "FEBRUARY 1998",
        "PDF",
        "AIAG_856Gemini.pdf.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Gemini Plastics",
    "missing": true
  },
  {
    "id": "missing",
    "name": "General Fastener Co.",
    "missing": true
  },
  {
    "id": "generalmotors",
    "name": "General Motors Corporation",
    "customMessage": true,
    "ediDocs": [
      [
        "Baltimore Plant (SAP)"
      ],
      [
        "Delivery Schedule Message",
        "DELFOR",
        "11/20/2007",
        "PDF",
        "Baltimore/BALTIMORE_(SAP)_DELFOR_V1.0.pdf"
      ],
      [
        "Despatch Advice Message",
        "DESADV",
        "11/20/2007",
        "PDF",
        "Baltimore/BALTIMORE_(SAP)_DESADV-V1.0.pdf"
      ],
      [
        "Corporate"
      ],
      [
        "Application Error and Ack",
        "APERAK",
        "01/15/2000",
        "PDF",
        "Corporate/GMCORP_APERAK.pdf"
      ],
      [
        "Acknowledgement/Rejection Advice",
        "CONTRL",
        "01/15/2000",
        "PDF",
        "Corporate/GMCORP_CONTRL.pdf"
      ],
      [
        "Delivery Schedule",
        "DELFOR",
        "01/15/2000",
        "PDF",
        "Corporate/GMCORP_DELFOR.pdf"
      ],
      [
        "Delivery Just In Time",
        "DELJIT",
        "01/15/2000",
        "PDF",
        "Corporate/GMCORP_DELJIT.pdf"
      ],
      [
        "Despatch Advice",
        "DESADV",
        "01/15/2000",
        "PDF",
        "Corporate/GMCORP_DESADV.pdf"
      ],
      [
        "General Purpose",
        "GENERAL",
        "01/15/2000",
        "PDF",
        "Corporate/GMCORP_GENRAL.pdf"
      ],
      [
        "Invoice",
        "INVOIC",
        "09/01/1999",
        "PDF",
        "Corporate/GMCORP_INVOIC.pdf"
      ],
      [
        "Inventory Report",
        "INVRPT",
        "01/15/2000",
        "PDF",
        "Corporate/GMCORP_INVRPT.pdf"
      ],
      [
        "Purchase Order",
        "ORDERS",
        "01/15/2000",
        "PDF",
        "Corporate/GMCORP_ORDERS.pdf"
      ],
      [
        "Receiving Advice",
        "RECADV",
        "01/15/2000",
        "PDF",
        "Corporate/GMCORP_RECADV.pdf"
      ],
      [
        "Defense"
      ],
      [
        "Application Error and Ack",
        "APERAK",
        "02/26/2024",
        "PDF",
        "Defense/General Motors_GMD_APERAK_v97A_v1_2-26-24.pdf"
      ],
      [
        "Acknowledgement/Rejection Advice",
        "CONTRL",
        "01/15/2000",
        "PDF",
        "Defense/GM Corporate-CONTRL Message - revision 2-1_15_00.pdf"
      ],
      [
        "Delivery Schedule",
        "DELFOR",
        "02/26/2024",
        "PDF",
        "Defense/General Motors_GMD_DELFOR_D97A_v1_2-26-24.pdf"
      ],
      [
        "Despatch Advice",
        "DESADV",
        "04/15/2025",
        "PDF",
        "Defense/GM Defense DESADV v1.5_4_15_2025.pdf"
      ],
      [
        "Communication",
        "Communication",
        "02/05/2025",
        "PDF",
        "Defense/GM Defense Communications_05-FEB-25.pdf"
      ],
      [
        "Europe"
      ],
      [
        "Invoice Message",
        "INVOIC",
        "01/01/2004",
        "PDF",
        "GM_Europe/FIN_INVOIC_V2.5.pdf"
      ],
      [
        "Invoice Message",
        "INVOIC",
        "01/01/2004",
        "XLS",
        "GM_Europe/EDI_vers_mapping_v8.xls"
      ],
      [
        "FZE"
      ],
      [
        "Interchange Control Message",
        "CONTRL",
        "09/29/2003",
        "PDF",
        "FZE/GM_FZE_GUIDELINES_Communications_35703_13102003112529.pdf"
      ],
      [
        "Delivery Just In Time Message",
        "DELJIT",
        "09/26/2003",
        "PDF",
        "FZE/GM_FZE_GUIDELINES_DELJIT_2003-09-26_35704_13102003112752.pdf"
      ],
      [
        "Despatch Advice Message",
        "DESADV",
        "09/26/2003",
        "PDF",
        "FZE/GM_FZE_GUIDELINES_DESADV_2003-09-26_35705_13102003113025.pdf"
      ],
      [
        "Indirect"
      ],
      [
        "Request For Quotation",
        "840",
        "01/15/2000",
        "PDF",
        "Indirect/GMIND_840.pdf"
      ],
      [
        "Response To Request",
        "843",
        "08/10/1992",
        "PDF",
        "Indirect/GMIND_843.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "08/10/1992",
        "PDF",
        "Indirect/GMIND_850.pdf"
      ],
      [
        "Purchase Order Change",
        "860",
        "08/10/1992",
        "PDF",
        "Indirect/GMIND_860.pdf"
      ],
      [
        "Purchase Order Change Ack",
        "865",
        "08/10/1992",
        "PDF",
        "Indirect/GMIND_865.pdf"
      ],
      [
        "MGO"
      ],
      [
        "Delivery Forecast",
        "DELFOR",
        "12/05/1998",
        "PDF",
        "MGO/GMMGO_DELFOR.pdf"
      ],
      [
        "Sequence Message",
        "DELJIT (JS)",
        "04/01/1999",
        "PDF",
        "MGO/GMMGO_DELJIT_js.pdf"
      ],
      [
        "Kanban Message",
        "DELJIT (KB)",
        "22/10/1998",
        "PDF",
        "MGO/GMMGO_DELJIT_kb.pdf"
      ],
      [
        "Pick Up Sheet",
        "DELJIT (PUS)",
        "22/10/1998",
        "PDF",
        "MGO/GMMGO_DELJIT_pus.pdf"
      ],
      [
        "Ship Schedule",
        "DELJIT SH",
        "12/05/1998",
        "PDF",
        "MGO/GMMGO_DELJIT_sh.pdf"
      ],
      [
        "Despatch Advice",
        "DESADV",
        "06/29/2023",
        "PDF",
        "MGO/General_Motors_GM_MGO_DESADV_v97A_v2_1_20230629.pdf"
      ],
      [
        "Receiving Advice",
        "RECADV",
        "04/08/1998",
        "PDF",
        "MGO/GMMGO_RECADV.pdf"
      ],
      [
        "Shanghai"
      ],
      [
        "Delivery Forecast",
        "DELFOR",
        "12/26/2005",
        "PDF",
        "Shanghai/GMShanghai_DELFOR.pdf"
      ],
      [
        "DELJIT - PUS",
        "DELJIT",
        "08/28/2009",
        "PDF",
        "SGM EDI Implementation Guidelines_DELJIT-PUS.pdf"
      ],
      [
        "Despatch Advice",
        "DESADV",
        "12/26/2005",
        "PDF",
        "Shanghai/GMShanghai_DESADV.pdf"
      ],
      [
        "SPO"
      ],
      [
        "Application Error & Ack",
        "APERAK",
        "10/29/1998",
        "PDF",
        "SPO/GMSPO_APERAK.pdf"
      ],
      [
        "Delivery Schedule",
        "DELFOR",
        "04/06/1999",
        "PDF",
        "SPO/GMSPO_DELFOR.pdf"
      ],
      [
        "Despatch Advice",
        "DESADV",
        "08/25/2003",
        "PDF",
        "SPO/GM_DESADV_2003.pdf"
      ],
      [
        "Inventory Report",
        "INVRPT",
        "07/21/1998",
        "PDF",
        "SPO/GMSPO_INVRPT_rc.pdf"
      ],
      [
        "SPO Mexico"
      ],
      [
        "Delivery Just in Time Message",
        "DELJIT",
        "04/10/2011",
        "PDF",
        "SPOMexico/GM_SPO_Mexico_DELJIT_Guidelines_v1 May_2011 .pdf"
      ],
      [
        "Despatch Advice",
        "DESADV",
        "05/24/2011",
        "PDF",
        "SPOMexico/GM_SPO_Mexico_DESADV_Guidelines_v0_3 May_2011.pdf"
      ],
      [
        "Supplier"
      ],
      [
        "Profile & Packaging Set Up",
        "",
        "06/27/2023",
        "PDF",
        "SSCP Request Access_ Profile Set-Up_Packaging Set Up 6-27-23.pdf"
      ],
      [
        "Supplier User Manual",
        "",
        "06/27/2023",
        "PDF",
        "SSCP Supplier User Manual 6-27-23.pdf"
      ],
      [
        "GMCCA (Formerly SPO Direct)"
      ],
      [
        "Application Error and Ack",
        "APERAK",
        "11/17/1998",
        "PDF",
        "SPODirect/GMSPOSD_APERAK.pdf"
      ],
      [
        "Delivery Just In Time",
        "DELJIT",
        "08/03/2011",
        "PDF",
        "SPODirect/GMCCASD_DELJIT_v2_08032011.pdf"
      ],
      [
        "Despatch Advice",
        "DESADV",
        "09/06/2015",
        "PDF",
        "SPODirect/GMCCA_SD_DESADV_v3 0_09062015.pdf"
      ],
      [
        "Invoice",
        "INVOIC",
        "03/09/1999",
        "PDF",
        "SPODirect/GMSPOSD_INVOIC.pdf"
      ],
      [
        "Inventory Report",
        "INVRPT",
        "07/20/1998",
        "PDF",
        "SPODirect/GMSPOSD_INVRPT.pdf"
      ],
      [
        "Packing Slip",
        "",
        "",
        "XLSX",
        "packing slip template 9-2016.xlsx"
      ],
      [
        "Barcode",
        "",
        "",
        "PDF",
        "SSCC with UCC128 Guidelines 3-1-16.pdf"
      ],
      [
        "GS1 General Specification",
        "",
        "",
        "PDF",
        "GS1 General Specification 3.7.12 and ISO 3166-1 numeric country codes..pdf"
      ],
      [
        "Label Template Information"
      ],
      [
        "Global Trading Partner",
        "",
        "10/21/2010",
        "PDF",
        "Label-Info/lab1.pdf"
      ],
      [
        "Shipping Parts Identification",
        "",
        "10/21/2010",
        "PDF",
        "Label-Info/lab3.pdf"
      ],
      [
        "GM North America Single Carton Label",
        "",
        "03/26/2018",
        "PDF",
        "Label-Info/1724A_26MAR2018.pdf"
      ],
      [
        "GM North America Mixed Load Carton Label",
        "",
        "03/26/2018",
        "PDF",
        "Label-Info/1724C_26MAR2018.pdf"
      ],
      [
        "GM North America Master Carton Label",
        "",
        "03/26/2018",
        "PDF",
        "Label-Info/1724B_26MAR2018.pdf"
      ],
      [
        "GM1724 Global Transportation Label Review",
        "",
        "Mar 2018",
        "PDF",
        "Label-Info/GM1724LabelReview.pdf"
      ],
      [
        "AMK / SMM Version"
      ],
      [
        "Despatch Advice",
        "DESADV",
        "09/15/1998",
        "PDF",
        "AMKSMM/GMOV - PNA - DESADV.pdf"
      ],
      [
        "Frequently Asked Questions"
      ],
      [
        "FAQ",
        "",
        "04/28/2008",
        "PDF",
        "F_A.pdf"
      ]
    ]
  },
  {
    "id": "gentex",
    "name": "Gentex",
    "ediDocs": [
      [
        "Release & Purchase Order",
        "830 & 850",
        "08/30/2006",
        "PDF",
        "Supplier_EDI_SPECS.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "03/09/2009",
        "PDF",
        "Supplier_EDI INFO_New_850.pdf"
      ],
      [
        "Advance Ship Notice",
        "856",
        "06/06/2011",
        "PDF",
        "Gentex_856_ASN.pdf"
      ],
      [
        "Advance Ship Notice - Required Fields",
        "856",
        "06/06/2011",
        "PDF",
        "Gentex_856_ Required_fields.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Gestamp Inc.",
    "missing": true
  },
  {
    "id": "ghx",
    "name": "GHX",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "10/07/2015",
        "PDF",
        "GHX_810_EDISpecifications.pdf"
      ],
      [
        "Purchase Order Acknowledgement",
        "855",
        "07/28/2009",
        "PDF",
        "GHX_855_EDISpecifications.pdf"
      ]
    ]
  },
  {
    "id": "getrag",
    "name": "Getrag",
    "imgFileName": "getrag.bmp",
    "ediDocs": [
      [
        "Delivery Instruction",
        "VDA4905",
        "12/26/2013",
        "PDF",
        "Getrag_EDI_Guideline_vda4905_eng.pdf"
      ],
      [
        "Credit note indication",
        "VDA4908",
        "11/21/2012",
        "PDF",
        "Getrag_EDI_Guideline_vda4908_v1_english.pdf"
      ],
      [
        "Delivery Schedule",
        "VDA4913",
        "12/26/2013",
        "PDF",
        "Getrag_EDI_Guideline_vda4913_eng.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "GFM Corp",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Gillette",
    "missing": true
  },
  {
    "id": "gkndriveline",
    "name": "GKN Driveline",
    "ediDocs": [
      [
        "Advance Shipment Notification",
        "856",
        "05/25/2011",
        "PDF",
        "ecguide856_revised_may2011.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "GKN Sinter Metals",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Glacier Garlock Bearings",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Global Automotive System",
    "missing": true
  },
  {
    "id": "globalequipment",
    "name": "Global Equipment",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "April 2003",
        "PDF",
        "Global Equipment 810.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "",
        "PDF",
        "Global Equipment 850.pdf"
      ]
    ]
  },
  {
    "id": "golfsmith",
    "name": "Golfsmith",
    "imgFileName": "golfsmith.bmp",
    "ediDocs": [
      [
        "Invoice (4050)",
        "810",
        "03/30/2011",
        "PDF",
        "Golfsmith_810_4050_EDI_Guidelines.pdf"
      ],
      [
        "Inventory Inquiry/Advice (4050)",
        "846",
        "04/19/2011",
        "PDF",
        "Golfsmith_846_4050_EDI_Guidelines.pdf"
      ],
      [
        "Purchase Order (4050)",
        "850",
        "03/30/2011",
        "PDF",
        "Golfsmith_850_4050_EDI_Guidelines.pdf"
      ],
      [
        "Purchase Order Acknowledgment (4050)",
        "855",
        "04/05/2011",
        "PDF",
        "Golfsmith_855_4050_EDI_Guidelines.pdf"
      ],
      [
        "Advance Ship Notice (4050)",
        "856",
        "03/30/2011",
        "PDF",
        "Golfsmith_856_4050_EDI_Guidelines.pdf"
      ],
      [
        "PO Change Request - Buyer Initiated (4050)",
        "860",
        "04/19/2011",
        "PDF",
        "Golfsmith_860_4050_EDI_Guidelines.pdf"
      ],
      [
        "PO Change Ack/Request - Seller Initiated (4050)",
        "865",
        "03/30/2010",
        "PDF",
        "Golfsmith_865_4050 EDI_Guidelines.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Goodyear",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Goodys",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Gourmet Baker Inc.",
    "missing": true
  },
  {
    "id": "grainger",
    "name": "Grainger",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "",
        "PDF",
        "https___portal.hosted-commerce.net_portal_apps_fileDisplay810.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "",
        "PDF",
        "Grainger_EDI_850.pdf"
      ],
      [
        "Purchase Order Acknowledgement",
        "855",
        "",
        "PDF",
        "Grainger_EDI_855_POA_Spec_V7.pdf"
      ],
      [
        "Advance Ship Notice",
        "856",
        "",
        "PDF",
        "Grainger_Supplier_856_Spec_final_112807.pdf"
      ],
      [
        "Functional Acknowledgement",
        "997",
        "",
        "PDF",
        "Grainger_Supplier_997_Spec_final_112807.pdf"
      ]
    ]
  },
  {
    "id": "Grammer",
    "name": "Grammer Corporation",
    "ediDocs": [
      [
        "Ship Notice",
        "856",
        "",
        "PDF",
        "GRAMMER X12 856 4010 Version 1.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Grand Rapids Controls Inc",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Grand Traverse  Plastics Corp.",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Grayhill, Inc.",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Great-West Metal LTD.",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Grede Foundries",
    "missing": true
  },
  {
    "id": "missing",
    "name": "GreenField Research",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Greenwood Mills",
    "missing": true
  },
  {
    "id": "grupoantolin",
    "name": "Grupo Antolin-IRAUSA, S.A.",
    "imgFileName": "grupoantolin.gif",
    "vendorLink": "http://extranet.grupoantolin.com/EDI/Documentacion.asp",
    "ediDocs": [
      [
        "ANSI (v3020)"
      ],
      [
        "Delivery Forecast",
        "830",
        "08/06/2011",
        "PDF",
        "GA_ANSI_830_v3020_v1.0.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "11/14/2011",
        "PDF",
        "ANSI_X12_856v3020_080208_EN.pdf"
      ],
      [
        "EDIFACT (D.96A)"
      ],
      [
        "Delivery Forecast",
        "DELFOR",
        "05/26/2008",
        "PDF",
        "DELFORD96A_080201_EN.pdf"
      ],
      [
        "Despatch Advice",
        "DESADV",
        "10/21/2011",
        "PDF",
        "DESADVD96A_080204_EN2.pdf"
      ],
      [
        "VDA"
      ],
      [
        "Advance Ship Notice",
        "4913",
        "11/14/2011",
        "PDF",
        "VDA4913_080206_EN.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Guardian Automotive",
    "missing": true
  },
  {
    "id": "gunite",
    "name": "Gunite Corporation",
    "ediDocs": [
      [
        "Release",
        "830",
        "04/29/2008",
        "PDF",
        "Gunite_830_4010.pdf"
      ],
      [
        "Purchase Order",
        "850 (3060)",
        "09/26/2003",
        "PDF",
        "Gunite_850_3060_v1.pdf"
      ],
      [
        "Purchase Order",
        "850 (4010)",
        "09/26/2003",
        "PDF",
        "Gunite_850_4010_v1.pdf"
      ],
      [
        "Gunite Purchase Order Acknowledgement",
        "855",
        "01/24/2003",
        "PDF",
        "Gunite_855_3060.pdf"
      ],
      [
        "Ship Notice",
        "856 (3050)",
        "02/20/2003",
        "PDF",
        "Gunite_856_v3050.pdf"
      ],
      [
        "Ship Notice",
        "856 (4010)",
        "03/04/2003",
        "PDF",
        "Gunite_856_4010.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "H & L Tool Company Inc",
    "missing": true
  },
  {
    "id": "missing",
    "name": "HA International",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Hachette Book Group USA",
    "missing": true
  },
  {
    "id": "hagemeyer",
    "name": "Hagemeyer",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "",
        "PDF",
        "Hagemeyer r810v4r1.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Haldex Traction Systems Division",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Hammond Power Solutions",
    "missing": true
  },
  {
    "id": "hancock",
    "name": "Hancock",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "06/22/2015",
        "PDF",
        "Hancock_Fabric_810_(5010)_062215.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "06/22/2015",
        "PDF",
        "Hancock_Fabric_856_(5010)_06222015.pdf"
      ]
    ]
  },
  {
    "id": "hansamerica",
    "name": "Hans America",
    "ediDocs": [
      [
        "Release",
        "830",
        "09/09/2014",
        "PDF",
        "HansAmerica_830_v1 0.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "09/09/2014",
        "PDF",
        "HansAmerica_856_v1 0.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Harbor Graphics",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Hardy Sales",
    "missing": true
  },
  {
    "id": "harleydavidson",
    "name": "Harley Davidson",
    "imgFileName": "harleydavidson.jpg",
    "ediDocs": [
      [
        "Release",
        "830",
        "January 2014",
        "PDF",
        "EDI_830_January_2014.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "March 2015",
        "PDF",
        "EDI 856 March 2015.pdf"
      ],
      [
        "Ship Schedule",
        "862",
        "January 2014",
        "PDF",
        "SAP_862_January_2014.pdf"
      ],
      [
        "Schedule Issuer / Ship To Location Codes",
        "",
        "June 2015",
        "PDF",
        "Appendix A - Schedule Issuer -Ship To Codes 061115.pdf"
      ]
    ]
  },
  {
    "id": "harman_becker_auto",
    "name": "Harman Becker Automotive",
    "imgFileName": "harman_becker_auto.bmp",
    "ediDocs": [
      null
    ]
  },
  {
    "id": "missing",
    "name": "Harman Heavy Vehicle HDA",
    "missing": true
  },
  {
    "id": "harristeeter",
    "name": "Harris Teeter",
    "customMessage": true,
    "ediDocs": [
      [
        "Invoice",
        "810",
        "04/06/2009",
        "PDF",
        "Harris_Teeter_810_4030_Segment_Outline.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "04/06/2009",
        "PDF",
        "Harris_Teeter_850_4030_Segment_Outline.pdf"
      ],
      [
        "EDI Profile",
        "N/A",
        "04/06/2009",
        "PDF",
        "Harris_Teeter_Profile.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Hatch Stamping",
    "missing": true
  },
  {
    "id": "haworth",
    "name": "Haworth",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "09/18/2013",
        "PDF",
        "Haworth 810 IG.PDF"
      ],
      [
        "Release",
        "830",
        "04/30/2014",
        "PDF",
        "Haworth830IG.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "09/18/2013",
        "PDF",
        "Haworth 850 IG.PDF"
      ],
      [
        "Purchase Order Change Request",
        "860",
        "09/18/2013",
        "PDF",
        "Haworth 860 IG.PDF"
      ],
      [
        "EDI Headings",
        "",
        "08/09/2013",
        "PDF",
        "Haworth EDI Headings IG.PDF"
      ],
      [
        "EDI Data Transfers via FTP",
        "",
        "08/08/2013",
        "PDF",
        "Haworth FTP IG.PDF"
      ]
    ]
  },
  {
    "id": "hayeslemmerz",
    "name": "Hayes Lemmerz",
    "ediDocs": [
      [
        "Ship Notice",
        "856",
        "04/01/2003",
        "PDF",
        "856-4010-spec.pdf"
      ]
    ]
  },
  {
    "id": "hbpo",
    "name": "HBPO",
    "ediDocs": [
      [
        "Delivery Forecast",
        "DELFOR",
        "05/11/2010",
        "PDF",
        "HBPO_EDIFACT_DELFOR_D96A_TS.pdf"
      ],
      [
        "Despatch Advice",
        "DESADV",
        "01/15/2009",
        "PDF",
        "HBPO_EDIFACT_DESADV_D05B_TS.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "HD America",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Hect (May Dept Stores)",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Heidtman Steel Products",
    "missing": true
  },
  {
    "id": "heilind",
    "name": "Heilind Electronics",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "07/17/2014",
        "PDF",
        "I810 4010 Transaction.pdf"
      ],
      [
        "Purchase Order Acknowledgement",
        "855",
        "07/17/2014",
        "PDF",
        "I855 4010 Transaction.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "03/16/2017",
        "PDF",
        "I856 4010 Transaction.pdf"
      ],
      [
        "EDI Trading Partner Setup",
        "",
        "",
        "PDF",
        "EDI Setup ( Vendor-Heilind)1.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Hella Innenleuchten Slovakia Bratislava",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Hella KG Lippstadt",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Hella KGAA Hueck & Co.",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Hellerman Tyton USA",
    "missing": true
  },
  {
    "id": "helm",
    "name": "Helm Inc.",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "06/18/2008",
        "PDF",
        "HelmInvoiceSpec.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "06/18/2008",
        "PDF",
        "HelmPOSpec.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Heritage",
    "missing": true
  },
  {
    "id": "missing",
    "name": "HFI",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Hi-Lex America",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Hi-Stat Sarasota",
    "missing": true
  },
  {
    "id": "hillrom",
    "name": "Hill-Rom",
    "customMessage": true,
    "ediDocs": [
      [
        "Purchase Order",
        "850",
        "06/10/2010",
        "PDF",
        "850_Purchase_Order-Version_4010.pdf"
      ],
      [
        "Purchase Order",
        "860",
        "06/10/2010",
        "PDF",
        "860_Purchase_Order_Change-Version_4010.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Hillsdale Automotive",
    "missing": true
  },
  {
    "id": "hitachi",
    "name": "Hitachi",
    "ediDocs": [
      [
        "Release",
        "830",
        "",
        "PDF",
        "830 SupplyWEB_X12.pdf"
      ],
      [
        "Advanced Ship Notice",
        "856",
        "",
        "PDF",
        "856 SupplyWEB_X12.pdf"
      ],
      [
        "Ship Schedule",
        "862",
        "",
        "PDF",
        "862 SupplyWEB_X12.pdf"
      ],
      [
        "Acknowledgement",
        "997",
        "",
        "PDF",
        "997 SupplyWEB_X12.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Hitachi Cable Indiana, Inc.",
    "missing": true
  },
  {
    "id": "missing",
    "name": "HiTech",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Hoerbiger Hydraulics",
    "missing": true
  },
  {
    "id": "HollingsworthLLC",
    "name": "Hollingsworth LLC",
    "imgFileName": "HollingsworthLLC.jpg",
    "ediDocs": [
      [
        "Release",
        "830",
        "",
        "PDF",
        "830 Material Release Transaction Set Layout V5.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "",
        "PDF",
        "850 PO Transaction Set Layout V1.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "",
        "PDF",
        "856 PO ASN Transaction Set Layout V1.pdf"
      ],
      [
        "Acknowledgement",
        "997",
        "",
        "PDF",
        "997 Functional Acknowledgement Transaction Set Layout.pdf"
      ],
      [
        "Supplier Label Specifications",
        "",
        "",
        "PDF",
        "Supplier Label Specifications.pdf"
      ]
    ]
  },
  {
    "id": "HomeDepot",
    "name": "Home Depot",
    "ediDocs": [
      [
        "Invoice ",
        "810",
        "10/17/2013",
        "PDF",
        "US_810_4060[1].pdf"
      ],
      [
        "Remittance Advice",
        "820",
        "07/29/2013",
        "PDF",
        "820_4060_SPECS.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "02/26/2009",
        "PDF",
        "850_4060-msr[1].pdf"
      ],
      [
        "Ship Notice",
        "856",
        "11/25/2013",
        "PDF",
        "856_4060_RDC.pdf"
      ],
      [
        "ASN Implementation Guide",
        "",
        "",
        "PDF",
        "ASN Implementation Guide.pdf"
      ],
      [
        "CommerceHub"
      ],
      [
        "Invoice",
        "810",
        "02/26/2014",
        "PDF",
        "HubEDI The Home Depot Invoice.pdf"
      ],
      [
        "Payment Order/Remittance Advice",
        "820",
        "02/19/2014",
        "PDF",
        "HubEDI The Home Depot Remittance Advice.pdf"
      ],
      [
        "Inventory Inquiry/Advice",
        "846",
        "11/12/2013",
        "PDF",
        "HubEDI The Home Depot Inventory.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "10/11/2013",
        "PDF",
        "HubEDI The Home Depot Purchase Order.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "10/29/2013",
        "PDF",
        "HubEDI The Home Depot Fulfillment Confirmation.pdf"
      ],
      [
        "Integrated Supplier Setup Request Form",
        "",
        "08/26/2014",
        "PDF",
        "Integrated Supplier Setup Request - The Home Depot Special Orders(1).pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Homemakers",
    "missing": true
  },
  {
    "id": "honda",
    "name": "Honda",
    "customMessage": true,
    "ediDocs": [
      [
        "Honda Supply Team"
      ],
      [
        "All",
        "N/A",
        "N/A",
        "Website",
        "http://www.hondasupplyteam.com/wps/portal"
      ],
      [
        "Honda of Canada"
      ],
      [
        "All",
        "N/A",
        "N/A",
        "Website",
        "http://ediinfo.edictsystems.com/hub/EDI_Site/index.cfm?hub=HondaCan&PassKey=EDISite"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Hoosier Gasket Corporation",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Hopkins Mfg",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Hornell Brewing Co.",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Howard Ternes Packaging Company",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Hp Pelzer Automotive Systems, Inc.",
    "missing": true
  },
  {
    "id": "hubbell",
    "name": "Hubbell Incorporated",
    "ediDocs": [
      [
        "Purchase Order",
        "850",
        "04/04/2004",
        "PDF",
        "Hubbell_Outbound_850_V4010.pdf"
      ]
    ]
  },
  {
    "id": "huf_na",
    "name": "Huf North America",
    "ediDocs": [
      [
        "856",
        "Ship Notice",
        "12/14/2007",
        "PDF",
        "HUFNA_Supplier_856_In_Guidelines_for_X12_V3050.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Hughes Manufacturing",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Hunzicker Brothers",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Hypro Inc.",
    "missing": true
  },
  {
    "id": "hyundai",
    "name": "Hyundai",
    "ediDocs": [
      [
        "Hyundai Motor Manufacturing Alabama"
      ],
      [
        "Ship Notice",
        "856",
        "09/01/2016",
        "PDF",
        "HMMA-856-Spec.pdf"
      ],
      [
        "Hyundai Motor Manufacturing Czech"
      ],
      [
        "EDI Guidelines",
        "",
        "07/01/2008",
        "PDF",
        "Guidelines for HMMC EDI Standard_v1 1.pdf"
      ]
    ]
  },
  {
    "id": "iconnectcorp",
    "name": "iConnect Corporation",
    "ediDocs": [
      [
        "Release/Planning Schedule",
        "830",
        "03/20/2002",
        "PDF",
        "Generic_Planning_Schedule_v1.0_Spec.pdf"
      ],
      [
        "Release/Planning Schedule (004010)",
        "830",
        "08/07/2018",
        "PDF",
        "iConnect_830_1.0.pdf"
      ],
      [
        "Text Message",
        "864",
        "11/13/2008",
        "PDF",
        "iConnect_864_Text Message.pdf"
      ],
      [
        "FlatFile EDI Spec's"
      ],
      [
        "Invoice",
        "810",
        "",
        "HTML",
        "iConnectFlatfileSpec-810.html"
      ],
      [
        "Planning Schedule/Shipping Schedule",
        "830",
        "",
        "HTML",
        "iConnectFlatfileSpec-830.html"
      ],
      [
        "Purchase Order/Purchase Order Change ",
        "850/860",
        "",
        "HTML",
        "iConnectFlatfileSpec-850.html"
      ],
      [
        "Purchase Order Acknowledgement",
        "855",
        "",
        "HTML",
        "iConnectFlatfileSpec-855.html"
      ],
      [
        "Shipping Notice",
        "856",
        "",
        "HTML",
        "iConnectFlatfileSpec-856.html"
      ]
    ]
  },
  {
    "id": "igbautomotive",
    "name": "IGB Automotive",
    "ediDocs": [
      [
        "EDI Implementation Guide",
        "All",
        "06/03/2004",
        "PDF",
        "Infor_Supplier_EDI_Implementation_Guide_Revision_2_IGB_Automotive1.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Igus Inc.",
    "missing": true
  },
  {
    "id": "iljin",
    "name": "ILJIN",
    "imgFileName": "iljin.gif",
    "ediDocs": [
      [
        "Planning Schedule (4010)",
        "830",
        "07/06/2011",
        "PDF",
        "830-X12rel_004010.pdf"
      ],
      [
        "Ship Notice (4010)",
        "856",
        "07/06/2011",
        "PDF",
        "856-X12rel_004010.pdf"
      ]
    ]
  },
  {
    "id": "iljinsc",
    "name": "ILJIN South Carolina",
    "customMessage": true,
    "ediDocs": [
      [
        "Planning Schedule",
        "830",
        "02/06/2025",
        "PDF",
        "ILJIN_830_1.4.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "07/29/2015",
        "PDF",
        "Iljin_856_Specifications.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Illinois Lock/CCL Security",
    "missing": true
  },
  {
    "id": "imperialdistributorscanada",
    "name": "Imperial Distributors Canada Inc.",
    "ediDocs": [
      [
        "Purchase Order",
        "850",
        "06/01/2018",
        "PDF",
        "IDCI 850 EDI Implementation Guide.pdf"
      ],
      [
        "Purchase Order Acknowledgment",
        "855",
        "",
        "PDF",
        "IDCI 855 EDI Implementation Guide V1.6.pdf"
      ],
      [
        "Invoice",
        "810",
        "03/01/2025",
        "PDF",
        "IDCI 810 EDI Implementation Guide.pdf"
      ],
      [
        "Advanced Ship Notice",
        "856",
        "11/08/2024",
        "PDF",
        "Imperial Distributors EDI856 Inbound Supplier ASN Guide Ver1.2.pdf"
      ],
      [
        "Vendor shipping label specifications",
        "",
        "",
        "PDF",
        "vendor shipping label specifications.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Imperial Electric",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Imperial Marketing",
    "missing": true
  },
  {
    "id": "inausa",
    "name": "INA Bearing Company",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "10/27/2003",
        "PDF",
        "INA_810_4010.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Indian Head Industries",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Indiana Automotive Fasteners",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Industrial fabricators",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Industrial Woodworking Corp",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Industriam Stamping & Mfg.",
    "missing": true
  },
  {
    "id": "inergy",
    "name": "Inergy",
    "ediDocs": [
      [
        "Planning Schedule with Release Capability",
        "830",
        "03/14/2005",
        "PDF",
        "Inergy830.pdf"
      ],
      [
        "Ship Notice/Manifest",
        "856",
        "03/14/2005",
        "PDF",
        "Inergy856.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Informs",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Innertech (Spartanburg)",
    "missing": true
  },
  {
    "id": "inoacexteriorproducts",
    "name": "INOAC Exterior Products",
    "customMessage": true,
    "imgFileName": "inoacexteriorproducts.gif",
    "ediDocs": [
      [
        "Release",
        "830",
        "08/14/2013",
        "PDF",
        "INOAC_830_v1.0.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Intec Group, Inc.",
    "missing": true
  },
  {
    "id": "integram",
    "name": "Integram",
    "ediDocs": [
      [
        "Release",
        "830",
        "09/25/2002",
        "PDF",
        "830_Version_4010.pdf"
      ],
      [
        "Release Addendum",
        "830",
        "11/05/2004",
        "PDF",
        "EDI_830_Spec_Addendum_4010.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "09/25/2002",
        "PDF",
        "856_Version_4010.pdf"
      ]
    ]
  },
  {
    "id": "interline",
    "name": "Interline Brands",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "10/01/2015",
        "PDF",
        "InterlineBrands_810_Guide.pdf"
      ]
    ]
  },
  {
    "id": "intermatic",
    "name": "Intermatic",
    "ediDocs": [
      [
        "Purchase Order",
        "850",
        "10/26/2011",
        "PDF",
        "Intermatic_850_Specs.pdf"
      ],
      [
        "Purchase Order Acknowledgment",
        "855",
        "10/26/2011",
        "PDF",
        "Intermatic_855_Specs.pdf"
      ],
      [
        "Advance Ship Notice",
        "856",
        "10/26/2011",
        "PDF",
        "Intermatic_856_Specs.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Intermatic Production",
    "missing": true
  },
  {
    "id": "iac",
    "name": "International Automotive Components",
    "ediDocs": [
      [
        "Release (3010)",
        "830",
        "08/30/2002",
        "PDF",
        "830-3010.pdf"
      ],
      [
        "Release (3060)",
        "830",
        "11/20/1997",
        "PDF",
        "830-3060.pdf"
      ],
      [
        "Release (3060) addendum",
        "830",
        "03/07/2007",
        "PDF",
        "830-3060-addendum.pdf"
      ],
      [
        "Shipping Notice (3010)",
        "856",
        "06/09/2004",
        "PDF",
        "856-3010.pdf"
      ],
      [
        "Shipping Notice (3060)",
        "856",
        "03/07/2007",
        "PDF",
        "856-3060.pdf"
      ],
      [
        "Shipping Notice (3060) addendum",
        "856",
        "03/07/2007",
        "PDF",
        "856-3060-addendum.pdf"
      ],
      [
        "Shipping Schedule (3010)",
        "862",
        "12/08/1995",
        "PDF",
        "862-3010.pdf"
      ],
      [
        "Shipping Schedule (3060)",
        "862",
        "03/07/2007",
        "PDF",
        "862-3060.pdf"
      ],
      [
        "Envelope Structure (3010)",
        "N/A",
        "07/26/2007",
        "PDF",
        "ANSI_ASCX12_Envelope_Structure3010.pdf"
      ],
      [
        "Envelope Structure (3060)",
        "N/A",
        "07/26/2007",
        "PDF",
        "ANSI_ASCX12_Envelope_Structure3060.pdf"
      ],
      [
        "Plant ID List",
        "N/A",
        "06/08/2007",
        "PDF",
        "IACNA_Plant_EDI_IDs.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "International Magnaproducts",
    "missing": true
  },
  {
    "id": "InterstateBatteries",
    "name": "Interstate Batteries",
    "ediDocs": [
      [
        "Purchase Order",
        "850",
        "03/18/2016",
        "PDF",
        "IBSA 4010 850 PO Outbound from IBSA.pdf"
      ],
      [
        "Purchase Order Acknowledgement",
        "855",
        "03/18/2016",
        "PDF",
        "IBSA 4010 855 PO Ack Inbound from Trojan.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "03/18/2016",
        "PDF",
        "IBSA 4010 856 ASN Inbound from Trojan.pdf"
      ]
    ]
  },
  {
    "id": "intertec",
    "name": "Intertec",
    "imgFileName": "intertec.png",
    "ediDocs": [
      [
        "Planning Schedule with Release Capability",
        "830",
        "05/03/2013",
        "PDF",
        "se830o41SPECS.pdf"
      ],
      [
        "Ship Notice/",
        "856",
        "05/03/2013",
        "PDF",
        "se856i41SPECS.pdf"
      ],
      [
        "Sample ASN",
        "856",
        "05/07/2008",
        "PDF",
        "se856-ASNsample.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Intertec Systems, Ltd.",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Intertech Inc",
    "missing": true
  },
  {
    "id": "inteva",
    "name": "Inteva Products",
    "ediDocs": [
      [
        "Ship Schedule",
        "DELJIT",
        "11/11/2011",
        "PDF",
        "IntevaDELJIT.pdf"
      ],
      [
        "Despatch Advice",
        "DESADV",
        "01/01/2011",
        "PDF",
        "IntevaDESADV.pdf"
      ],
      [
        "Delivery Forecast",
        "DELFOR",
        "10/30/2009",
        "PDF",
        "IntevaDELFOR.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Intier Automotive",
    "missing": true
  },
  {
    "id": "iroquois_industries_inc",
    "name": "Iroquois Industries",
    "imgFileName": "iroquois_industries_inc.bmp",
    "ediDocs": [
      [
        "Planning Schedule (4010)",
        "830",
        "7/6/2011",
        "PDF",
        "830-X12rel004010.pdf"
      ],
      [
        "Ship Notice (4010)",
        "856",
        "7/6/2011",
        "PDF",
        "856-X12rel004010.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Irvin Automotive Jarapamex",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Isspro Inc.",
    "missing": true
  },
  {
    "id": "Isuzu",
    "name": "Isuzu",
    "ediDocs": [
      [
        "Ship Notice",
        "856",
        "09/19/2023",
        "PDF",
        "ISUZU-EDI-856-862-830-ver-4010_09192023.pdf"
      ]
    ]
  },
  {
    "id": "itt",
    "name": "ITT Automotive",
    "ediDocs": [
      [
        "Release",
        "830",
        "05/01/2000",
        "PDF",
        "ITT_830_and_856_4010.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "05/01/2000",
        "PDF",
        "ITT_830_and_856_4010.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "ITW Deltar",
    "missing": true
  },
  {
    "id": "missing",
    "name": "ITW Tool Works",
    "missing": true
  },
  {
    "id": "missing",
    "name": "IWDLink",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Jacobson Mfg",
    "missing": true
  },
  {
    "id": "JaguarLandRover",
    "name": "Jaguar Land Rover",
    "ediDocs": [
      [
        "EDIFACT"
      ],
      [
        "DELFOR",
        "830",
        "06/11/2013",
        "PDF",
        "JLR EDIFACT_DELFOR_D97a_MIG.PDF"
      ],
      [
        "DELFOR",
        "830",
        "10/14/2013",
        "XLS",
        "JAGUR1oDELFOR97aANY_Spec_v1.6.xls"
      ],
      [
        "DELJIT",
        "862",
        "11/18/2013",
        "PDF",
        "JLR EDIFACT_DELFOR_D97a_MIG.PDF"
      ],
      [
        "DELJIT",
        "862",
        "10/15/2013",
        "XLS",
        "JAGUR1oDELJIT98bANY_Spec_v1.9.xls"
      ],
      [
        "VDA"
      ],
      [
        "Delivery Forecasts",
        "4905",
        "06/11/2013",
        "PDF",
        "JLR_Forecast Schedule_VDA_4905_eng V4.pdf"
      ],
      [
        "Delivery Note",
        "4913",
        "10/12/2014",
        "XLS",
        "VDA 4913 MIG_v7 0.xlsx"
      ],
      [
        "Delivery Just in Time",
        "4915",
        "06/11/2013",
        "PDF",
        "JLR_Delivery Schedule_VDA_4915_eng V4.pdf"
      ],
      [
        "ASN Frequently Asked Questions",
        "",
        "",
        "PDF",
        "ASN VDA-4913 FAQ v1 0.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Jamak Fabrication",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Jane and Company",
    "missing": true
  },
  {
    "id": "jatco",
    "name": "Jatco",
    "ediDocs": [
      [
        "Ship Notice",
        "856",
        "12/21/2009",
        "PDF",
        "JATCO 856.pdf"
      ]
    ]
  },
  {
    "id": "jcpenney",
    "name": "JCPenney",
    "ediDocs": [
      [
        "Return Merchandise Authorization",
        "180",
        "07/13/2006",
        "PDF",
        "180_RtnMerchAuth.pdf"
      ],
      [
        "Motor Carrier Load Tender",
        "204",
        "11/14/2006",
        "PDF",
        "204_MtrCarrierLdTndr.pdf"
      ],
      [
        "Motor Carrier Freight Details and Invoice",
        "210",
        "11/14/2006",
        "PDF",
        "210_MtrCarrDtlsInv.pdf"
      ],
      [
        "Motor Transportation Carrier Shipment Status Message",
        "214",
        "07/14/2006",
        "PDF",
        "214_ShpmntStatMsg.pdf"
      ],
      [
        "Request for Routing Instructions",
        "753",
        "07/17/2006",
        "PDF",
        "753_RqstRtngInstr.pdf"
      ],
      [
        "Routing Instructions",
        "754",
        "08/24/2006",
        "PDF",
        "754_RtngInstr.pdf"
      ],
      [
        "Invoice",
        "810",
        "10/03/2006",
        "PDF",
        "810_Invoice.pdf"
      ],
      [
        "Credit/Debit Adjustment",
        "812",
        "08/29/2006",
        "PDF",
        "812_CreditDebitAdj.pdf"
      ],
      [
        "Payment Order/Remittance Advice",
        "820",
        "09/14/2006",
        "PDF",
        "820_PaymntRemitAdv.pdf"
      ],
      [
        "Application Advice",
        "824",
        "09/20/2006",
        "PDF",
        "824_AppAdvice.pdf"
      ],
      [
        "Planning Schedule with Release Capability",
        "830",
        "10/03/2006",
        "PDF",
        "830_PlanningSched.pdf"
      ],
      [
        "Purchase Order - Retail",
        "850",
        "09/22/2006",
        "PDF",
        "850_PurchOrdrRetail.pdf"
      ],
      [
        "Purchase Order - Other Businesses",
        "850",
        "01/11/2007",
        "PDF",
        "850_PurchOrdrOther.pdf"
      ],
      [
        "Product Activity Data",
        "852",
        "10/10/2006",
        "PDF",
        "852_ProductActivity.pdf"
      ],
      [
        "Purchase Order Acknowledgment",
        "855",
        "10/11/2006",
        "PDF",
        "855_PurchOrdrAck.pdf"
      ],
      [
        "Ship Notice/Manifest",
        "856",
        "9/21/2007",
        "PDF",
        "856_ShipNotice.pdf"
      ],
      [
        "Purchase Order Change Request - Buyer Initiated",
        "860",
        "12/08/2006",
        "PDF",
        "860_PurchOrdrChnge.pdf"
      ],
      [
        "Text Store Location Address",
        "864",
        "02/27/2007",
        "PDF",
        "864.pdf"
      ],
      [
        "Order Status Inquiry",
        "869",
        "10/11/2006",
        "PDF",
        "869_OrdrInqry.pdf"
      ],
      [
        "Order Status Report",
        "870",
        "11/1/2007",
        "PDF",
        "870_OrdrStatRpt.pdf"
      ],
      [
        "Response to a Load Tender",
        "990",
        "11/09/2006",
        "PDF",
        "990_RespLoadTndr.pdf"
      ],
      [
        "Functional Acknowledgment",
        "997",
        "11/10/2006",
        "PDF",
        "997_FuncAck.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Jefferson Elora Corp",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Jennings",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Jernberg Industries",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Jeros Tackle (Meg Tackle Imports, Inc)",
    "missing": true
  },
  {
    "id": "missing",
    "name": "JFK Systems Inc",
    "missing": true
  },
  {
    "id": "missing",
    "name": "JM Packaging",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Joerns Healthcare Inc.",
    "missing": true
  },
  {
    "id": "missing",
    "name": "John Gillette",
    "missing": true
  },
  {
    "id": "johnsoncontrols",
    "name": "Johnson Controls",
    "ediDocs": [
      [
        "Johnson Controls Interiors"
      ],
      [
        "Ship Notice",
        "856",
        "02/16/2000",
        "PDF",
        "JCI_Interiors_856_Specs.pdf"
      ],
      [
        "Delivery Forecast",
        "DELFOR",
        "15/02/2007",
        "PDF",
        "DELFOR_D07A_JCI_Supplier_v2.1.pdf"
      ],
      [
        "Delivery Just in Time Message",
        "DELJIT",
        "15/02/2017",
        "PDF",
        "DELJIT_D07A_JCI_Supplier_v3.1.pdf"
      ],
      [
        "Plant Code List",
        "N/A",
        "09/27/1999",
        "PDF",
        "JCI_Interiors_DUNS_List.pdf"
      ],
      [
        "Mailbox ID's",
        "N/A",
        "09/27/1999",
        "PDF",
        "JCI_Interiors_Mailbox_IDs.pdf"
      ],
      [
        "Envelope Structure",
        "N/A",
        "09/27/1999",
        "PDF",
        "JCI_Interiors_X12_ICS_Specs.pdf"
      ],
      [
        "Johnson Controls Seating"
      ],
      [
        "Application Advice",
        "824",
        "05/08/2001",
        "PDF",
        "JCI_Seating_X12_824_Specs.pdf"
      ],
      [
        "Planning Schedule with Release Capability",
        "830",
        "05/08/2001",
        "PDF",
        "JCI_Seating_X12_830_Specs.pdf"
      ],
      [
        "Ship Notice/Manifest",
        "856",
        "08/16/2001",
        "PDF",
        "JCI_Seating_X12_856_Specs.pdf"
      ],
      [
        "Shipping Schedule",
        "862",
        "05/08/2001",
        "PDF",
        "JCI_Seating_X12_862_Specs.pdf"
      ],
      [
        "Functional Acknowledgment",
        "997",
        "05/08/2001",
        "PDF",
        "JCI_Seating_X12_997_Specs.pdf"
      ],
      [
        "Plant Codes",
        "N/A",
        "05/08/2001",
        "PDF",
        "JCI_Seating_DUNS_List.pdf"
      ],
      [
        "Envelope Structure",
        "N/A",
        "05/08/2001",
        "PDF",
        "JCI_Seating_X12_Envelope.pdf"
      ],
      [
        "Johnson Controls Power Solutions Division"
      ],
      [
        "Purchase Order",
        "850",
        "02/18/2014",
        "PDF",
        "JCI EDI 850 ImplementationGuide_Global.pdf"
      ],
      [
        "Ship Notice/Manifest",
        "856",
        "11/05/2014",
        "PDF",
        "JCI EDI 856 ImplemenationGuideSuppliers_Global_V1.3.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Jordan",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Journeys",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Jtekt Automotive",
    "missing": true
  },
  {
    "id": "Jtekt",
    "name": "Jtekt Column Systems North America",
    "customMessage": true,
    "ediDocs": [
      [
        "Planning Schedule",
        "830",
        "07/10/2007",
        "PDF",
        "JTEKT_830_v1.1.pdf"
      ],
      [
        "Advance Ship Notice",
        "856",
        "07/10/2007",
        "PDF",
        "JTEKT_830_v1.1.pdf"
      ]
    ]
  },
  {
    "id": "ki",
    "name": "K I",
    "ediDocs": [
      [
        "Purchase Order",
        "850 (4010)",
        "10/14/2010",
        "PDF",
        "KI_EDI_850_Purchase_Order_Specification_Raw_Materials.pdf"
      ],
      [
        "Purchase Order Acknowledgment",
        "855 (4010)",
        "09/16/2010",
        "PDF",
        "KI_EDI_855_PO_Acknowledgment_Specification_Raw_Materials.pdf"
      ],
      [
        "Advance Ship Notice",
        "856 (4010)",
        "11/04/2010",
        "PDF",
        "KI EDI 856 Advance Ship Notice SpecificationRawMaterials.pdf"
      ],
      [
        "Purchase Order Change",
        "860 (4010)",
        "07/27/2010",
        "PDF",
        "KI_EDI_860_Purchase_Order_Change_Specification_Raw_Materials.pdf"
      ],
      [
        "Supply Chain Guide",
        "N/A",
        "09/16/2010",
        "PDF",
        "SupplyChainGuide.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "K&G",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Kamaya",
    "missing": true
  },
  {
    "id": "kamax",
    "name": "Kamax",
    "ediDocs": [
      [
        "Purchase Order",
        "850",
        "10/19/2018",
        "PDF",
        "850_Guideline_EN.pdf"
      ],
      [
        "Ship Notice/Manifest",
        "856",
        "10/23/2018",
        "PDF",
        "856_Guideline_EN.pdf"
      ]
    ]
  },
  {
    "id": "karmax",
    "name": "Karmax Heavy Stamping",
    "ediDocs": [
      [
        "Application Advice",
        "824",
        "03/19/2002",
        "PDF",
        "Karmax_824.pdf"
      ],
      [
        "Ship Notice/Manifest",
        "856",
        "11/25/2002",
        "PDF",
        "magna856v100.pdf"
      ],
      [
        "Ship Notice/Manifest Business Practices",
        "856",
        "11/25/2002",
        "PDF",
        "magna856rbpv100.pdf"
      ]
    ]
  },
  {
    "id": "kautex",
    "name": "Kautex",
    "ediDocs": [
      [
        "EDI Specs",
        "",
        "",
        "PDF",
        "97A_Detroit (3).pdf"
      ],
      [
        "Delivery Forecast",
        "DELFOR",
        "11/23/2016",
        "PDF",
        "SUPPLIER_DELFOR_D97A_V1_0_1.pdf"
      ],
      [
        "Despatch Advise",
        "DESADV",
        "03/28/2018",
        "PDF",
        "KAUTEX_SUPPLIER_DESADV_D97A1_4.pdf"
      ],
      [
        "EDI Samples",
        "",
        "",
        "PDF",
        "Supplier 97A.pdf"
      ],
      [
        "VAN Letter",
        "",
        "",
        "PDF",
        "VAN-letter-supplier.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Kawasaki",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Keats Manufacturing",
    "missing": true
  },
  {
    "id": "keiper",
    "name": "Keiper",
    "imgFileName": "keiper.bmp",
    "ediDocs": [
      [
        "Material Release Transaction Set (2040)",
        "830",
        "07/26/2011",
        "PDF",
        "x830_KeiperSpecifications.pdf"
      ],
      [
        "Advance Ship Notice/Manfest (4010)",
        "856",
        "07/26/2011",
        "PDF",
        "X856_KEIPER.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Kennerly",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Kenworth",
    "missing": true
  },
  {
    "id": "keyplastics",
    "name": "Key Plastics",
    "ediDocs": [
      [
        "Key Plastics"
      ],
      [
        "Planning Schedule With Release Capability and Fuctional Acknowledgement",
        "830, 997",
        "06/01/1998",
        "PDF",
        "Keyplastics3060.pdf"
      ],
      [
        "Planning Schedule With Release Capability",
        "830",
        "09/15/2003",
        "PDF",
        "Keyplastics4010.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Keystone Powdered Metal",
    "missing": true
  },
  {
    "id": "kia",
    "name": "Kia Motor Manufacturing",
    "ediDocs": [
      [
        "Kia Motors Slovakia (KMS)"
      ],
      [
        "EDI Guidelines",
        "",
        "05/02/2016",
        "PDF",
        "User guide for KMS EDI Standard_Ver2 3 (2).pdf"
      ]
    ]
  },
  {
    "id": "kiekert",
    "name": "Kiekert",
    "imgFileName": "kiekert.png",
    "ediDocs": [
      [
        "4905",
        "Delivery Instruction",
        "April 1996",
        "PDF",
        "4905_V4_April 1996_eng.pdf"
      ],
      [
        "4913",
        "Advance Shipping Notice",
        "",
        "PDF",
        "Kiekert 4913 EN.pdf"
      ]
    ]
  },
  {
    "id": "kimberlyclark",
    "name": "Kimberly-Clark Corporation",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "04/01/2007",
        "PDF",
        "Kimberly Clark EDI Implementation Guide.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "10/02/1995",
        "PDF",
        "APEX - PUR850_3010.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Kinco International",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Kingsville Stamping",
    "missing": true
  },
  {
    "id": "kitchencollection",
    "name": "Kitchen Collection",
    "ediDocs": [
      [
        "EDI Implementation Guide",
        "",
        "",
        "PDF",
        "Kitchen Collection EDI_Mapping_Guide.pdf.pdf"
      ]
    ]
  },
  {
    "id": "klaussnerfurniture",
    "name": "Klaussner Furniture",
    "imgFileName": "klaussnerfurniture.gif",
    "ediDocs": [
      [
        "Purchase Order",
        "850",
        "09/21/2010",
        "PDF",
        "EDI_850_Document_Fabric.pdf"
      ],
      [
        "Advance Ship Notice",
        "856",
        "09/21/2010",
        "PDF",
        "EDI_856_Document_856.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Kmart",
    "missing": true
  },
  {
    "id": "kohler",
    "name": "Kohler",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "02/14/2007",
        "PDF",
        "supplier_810_4010_edi_specs.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "11/04/2011",
        "PDF",
        "Kohler_850_Specifications.pdf"
      ],
      [
        "Purchase Order Acknowledgement",
        "855",
        "11/29/2011",
        "PDF",
        "Kohler_855_Specifications.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "02/14/2007",
        "PDF",
        "supplier_856_4010_edi_specs.pdf"
      ],
      [
        "Purchase Order Change",
        "860",
        "02/14/2007",
        "PDF",
        "supplier_860_4010_edi_specs.pdf"
      ],
      [
        "EDI Questionaire",
        "",
        "02/14/2007",
        "PDF",
        "KohlerEDIQuestionnaire.pdf"
      ],
      [
        "Trader Partner Agreement",
        "",
        "02/14/2007",
        "PDF",
        "EDI Trading Partner Agreement_Final 112204_.pdf"
      ]
    ]
  },
  {
    "id": "kohls",
    "name": "Kohls",
    "imgFileName": "kohls.jpg",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "11/30/2012",
        "PDF",
        "Kohls_810.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Kolcraft Enterprises",
    "missing": true
  },
  {
    "id": "kongsberg",
    "name": "Kongsberg",
    "imgFileName": "kongsberg.png",
    "ediDocs": [
      [
        "Planning Schedule with Release Capacity",
        "830",
        "",
        "PDF",
        "830_v3060_Kongsberg_v1.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "",
        "PDF",
        "856_v4010_Kongsberg_v1.pdf"
      ]
    ]
  },
  {
    "id": "kostal",
    "name": "Kostal",
    "ediDocs": [
      [
        "Inventory Inquiry Advice",
        "846",
        "03/20/2008",
        "PDF",
        "846-Stock_on_hand-sys-koa.pdf"
      ],
      [
        "Ship Notice/Manifest",
        "856",
        "03/20/2008",
        "PDF",
        "EC_EDI_KM_856 Ship Notice_KOA-SYS_en.pdf"
      ],
      [
        "Receiving Advice",
        "861",
        "03/20/2008",
        "PDF",
        "861-Received-Material-KOA-SYS.pdf"
      ],
      [
        "Delivery Forecast",
        "DELFOR",
        "06/28/2005",
        "PDF",
        "http://www.kostal.com/english/downloads/EDI-EDIFACT-DELFOR-92.PDF"
      ],
      [
        "VMI Delivery Forecast",
        "DELFOR",
        "06/28/2005",
        "PDF",
        "http://www.kostal.com/english/downloads/EDIFACT%20VMI%20DELFOR01%20engl.pdf"
      ],
      [
        "Despatch Advise",
        "DESADV",
        "09/23/2003",
        "PDF",
        "http://www.kostal.com/english/downloads/EDIFACT%20DESADV01%20ENGL.PDF"
      ],
      [
        "Inventory Report",
        "INVRPT",
        "06/27/2005",
        "PDF",
        "http://www.kostal.com/english/downloads/EDIFACT%20INVRPT05%20engl.pdf"
      ],
      [
        "EDI Terms and Conditions",
        "N/A",
        "05/26/2009",
        "PDF",
        "http://www.kostal.com/english/downloads/EDI-Terms-and-Condition.PDF"
      ],
      [
        "EDI Guidelines",
        "N/A",
        "05/26/2009",
        "PDF",
        "http://www.kostal.com/english/downloads/EDI_Guideline_V3.pdf"
      ]
    ]
  },
  {
    "id": "kotobukiya",
    "name": "Kotobukiya",
    "ediDocs": [
      [
        "Delivery Forecast",
        "DELFOR",
        "12/03/2012",
        "PDF",
        "GUM DELFORD96A_last.pdf"
      ],
      [
        "Despatch Advice",
        "DESADV",
        "11/11/2016",
        "PDF",
        "GUM DESADVD96A.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Koyo Corporation of USA",
    "missing": true
  },
  {
    "id": "krispykreme",
    "name": "Krispy Kreme",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "11/07/2003",
        "PDF",
        "KK810specs.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "08/01/2001",
        "PDF",
        "KK850Specs.pdf"
      ],
      [
        "Text Message",
        "864",
        "10/24/2001",
        "PDF",
        "KK864specs.pdf"
      ]
    ]
  },
  {
    "id": "kroger",
    "name": "Kroger",
    "customMessage": true,
    "imgFileName": "kroger.bmp",
    "ediDocs": [
      [
        "Invoice (4010)",
        "810",
        "06/12/2008",
        "PDF",
        "4010_810N_061208.pdf"
      ],
      [
        "Invoice (5010)",
        "810",
        "11/04/2011",
        "PDF",
        "5010_810_040512.pdf"
      ]
    ]
  },
  {
    "id": "Kromberg",
    "name": "Kromberg & Schubert",
    "customMessage": true,
    "imgFileName": "Kromberg.jpg",
    "ediDocs": [
      [
        "Delivery instruction",
        "4905",
        "April 1996",
        "PDF",
        "LieferAbrufe_CALL-OFFS VDA4905.pdf"
      ],
      [
        "Invoice",
        "4906",
        "May 1993",
        "PDF",
        "Rechnung_Invoices VDA4906.pdf"
      ],
      [
        "Delivery Note",
        "4913",
        "March 1996",
        "PDF",
        "Lieferscheine_ASN VDA4913.pdf"
      ],
      [
        "English"
      ],
      [
        "Delivery instruction",
        "4905",
        "April 1996",
        "PDF",
        "4905_V4_April 1996_eng.pdf"
      ],
      [
        "Delivery Note",
        "4913",
        "March 1996",
        "PDF",
        "VDA-4913_1996_EN.PDF"
      ]
    ]
  },
  {
    "id": "kruegerinternational",
    "name": "Krueger International",
    "ediDocs": [
      [
        "Planning Schedule",
        "830",
        "08/30/2010",
        "PDF",
        "KI_EDI_830_Planning_Schedule.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "06/11/2010",
        "PDF",
        "KI_EDI_850_Purchase_Order_Specification_Raw_Materials.pdf"
      ],
      [
        "Purchase Order Acknowledgment",
        "855",
        "05/17/2010",
        "PDF",
        "KI_EDI_855_Purchase_Order_Acknowledgment_Specification.pdf"
      ],
      [
        "Advance Ship Notice",
        "856",
        "12/15/2009",
        "PDF",
        "KI_EDI_856_Advance_Ship_Notice_Specification.pdf"
      ],
      [
        "Purchase Order Change",
        "860",
        "07/27/2010",
        "PDF",
        "KI_EDI_860_Purchase_Order_Change_Specification_Raw_Materials.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "KTH/KMI",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Kumho Tire Company Inc.",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Kurt Manufacturing",
    "missing": true
  },
  {
    "id": "KwangJin",
    "name": "Kwang Jin",
    "customMessage": true,
    "ediDocs": [
      [
        "Release",
        "830",
        "09/30/2014",
        "PDF",
        "KwangJin_830_v1.1.pdf"
      ],
      [
        "Advance Ship Notice",
        "856",
        "09/18/2014",
        "PDF",
        "KwangJin_856_v1.1.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "KW Australia",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Kyklos Bearing International",
    "missing": true
  },
  {
    "id": "landw_engineering",
    "name": "L & W Engineering",
    "ediDocs": [
      [
        "Release",
        "830",
        "10/21/2005",
        "PDF",
        "LWE830outb_specs.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "10/21/2005",
        "PDF",
        "LWE856inb_specs.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Laboratoires Colba Inc.",
    "missing": true
  },
  {
    "id": "labcorp",
    "name": "Laboratory Corporation of America",
    "ediDocs": [
      [
        "Invoice, Purchase Order, Purchase Order Change",
        "810, 850, 855",
        "05/21/2008",
        "PDF",
        "4010LabCorp_IC_4_NewVends.pdf"
      ],
      [
        "Enrollment Form",
        "N/A",
        "05/21/2008",
        "DOC",
        "TRADING_PARTNER_Enrollment_Form.doc"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Lacks Trim Systems",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Laird Technologies",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Lamp Plus",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Lancaster",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Lang Mekra",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Larocca",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Larosa",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Lawson",
    "missing": true
  },
  {
    "id": "missing",
    "name": "LDM Technologies",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Lea Sachs",
    "missing": true
  },
  {
    "id": "lear",
    "name": "Lear Corporation",
    "vendorLink": "https://www.lear.com/Site/Suppliers/EDI-Guidelines.aspx",
    "ediDocs": [
      [
        "Version 3060 Documents"
      ],
      [
        "Envelope Structure",
        "N/A",
        "N/A",
        "PDF",
        "http://www.lear.com/user_area/extranet_files/lear-93-EDI_ANSI_ASC_X12_Envelope_Structure_3060.pdf"
      ],
      [
        "Plant IDs",
        "N/A",
        "04/30/2009",
        "PDF",
        "http://www.lear.com/user_area/extranet_files/lear-94-EDI_3060_IDs.pdf"
      ],
      [
        "Production Release",
        "830",
        "11/20/1997",
        "PDF",
        "http://www.lear.com/user_area/extranet_files/lear-95-EDI_830-3060.pdf"
      ],
      [
        "Ship Notice/Manifest",
        "856",
        "06/09/2004",
        "PDF",
        "http://www.lear.com/user_area/extranet_files/lear-96-EDI_856-3060.pdf"
      ],
      [
        "Shipping Schedule",
        "862",
        "06/09/2004",
        "PDF",
        "http://www.lear.com/user_area/extranet_files/lear-97-EDI_862-3060.pdf"
      ],
      [
        "Lear's Seating Systems Division (SSD)"
      ],
      [
        "Envelope Structure",
        "N/A",
        "N/A",
        "PDF",
        "http://www.lear.com/user_area/extranet_files/lear-86-EDI_ANSI_ASC_X12_Envelope_Structure_3010.pdf"
      ],
      [
        "Plant IDs",
        "N/A",
        "04/30/2009",
        "PDF",
        "http://www.lear.com/user_area/extranet_files/lear-87-EDI_3010_IDs.pdf"
      ],
      [
        "Production Release (3010)",
        "830",
        "08/30/2002",
        "PDF",
        "http://www.lear.com/user_area/extranet_files/lear-88-EDI_830-3010.pdf"
      ],
      [
        "Ship Notice/Manifest (3010)",
        "856",
        "04/28/2009",
        "PDF",
        "http://www.lear.com/user_area/extranet_files/lear-89-EDI_856-3010.pdf"
      ],
      [
        "Shipping Schedule (3010)",
        "862",
        "07/03/2007",
        "PDF",
        "http://www.lear.com/user_area/extranet_files/lear-90-EDI_862-3010.pdf"
      ],
      [
        "Production Sequence (3010)",
        "866",
        "03/24/2005",
        "PDF",
        "http://www.lear.com/user_area/extranet_files/lear-91-EDI_866-3010.pdf"
      ],
      [
        "Warehouse Stock Transfer Receipt Advice(4010)",
        "944",
        "01/09/2009",
        "PDF",
        "http://www.lear.com/user_area/extranet_files/lear-92-EDI_944-4010.pdf"
      ],
      [
        "Lear's Electronic Systems Division (ESD)"
      ],
      [
        "Plant ID's (2040)",
        "N/A",
        "04/30/2009",
        "PDF",
        "http://www.lear.com/user_area/extranet_files/lear-98-EDI_ESD_Addresses-2040.pdf"
      ],
      [
        "Production Release (2040)",
        "830",
        "04/04/2003",
        "PDF",
        "http://www.lear.com/user_area/extranet_files/lear-99-EDI_ESD_2040-830.pdf"
      ],
      [
        "Ship Notice/Manifest (2040)",
        "856",
        "04/04/2003",
        "PDF",
        "http://www.lear.com/user_area/extranet_files/lear-100-EDI_ESD_2040-856.pdf"
      ],
      [
        "Production Release (3040)",
        "830",
        "09/26/2001",
        "PDF",
        "http://www.lear.com/user_area/extranet_files/lear-101-EDI_ESD_3040-830.pdf"
      ],
      [
        "Ship Notice/Manifest (3040)",
        "856",
        "11/24/2003",
        "PDF",
        "http://www.lear.com/user_area/extranet_files/lear-102-EDI_ESD_3040-856.pdf"
      ],
      [
        "Functional Acknowledgement(3040)",
        "997",
        "10/05/2001",
        "PDF",
        "http://www.lear.com/user_area/extranet_files/lear-103-EDI_ESD_3040-997.pdf"
      ],
      [
        "Envelope Structure(3040)",
        "N/A",
        "N/A",
        "PDF",
        "Lear-3040 ANSI_ASC X12_Envelope_Structure EPMS NA.pdf"
      ],
      [
        "Barcode Specs",
        "N/A",
        "N/A",
        "PDF",
        "i-Connect_Suppiler_label-Spec.pdf"
      ],
      [
        "Lear Sweden Division"
      ],
      [
        "Odette Transport Label Guideline",
        "N/A",
        "N/A",
        "PDF",
        "http://www.lear.com/user_area/extranet_files/lear-104-Odette_Transport_Label_Guideline.pdf"
      ],
      [
        "Sweden AVIEXP Guideline",
        "AVIEXP",
        "N/A",
        "PDF",
        "http://www.lear.com/user_area/extranet_files/lear-104-Odette_Transport_Label_Guideline.pdf"
      ],
      [
        "Sweden Communication Agreements",
        "N/A",
        "08/17/2009",
        "PDF",
        "http://www.lear.com/user_area/extranet_files/lear-106-Sweden_ComApp_Agreements.pdf"
      ],
      [
        "VDA Specifications"
      ],
      [
        "Delivery Instruction",
        "4905",
        "03/11/2010",
        "PDF",
        "Lear_VDA_4905_Corp_EDI_Guideline_ENG_ver_1.pdf"
      ],
      [
        "Delivery Note",
        "4913",
        "03/11/2010",
        "PDF",
        "Lear_VDA_4913_Corp_EDI_Guideline_ENG_ver_1.pdf"
      ],
      [
        "EDIFACT Specifications"
      ],
      [
        "Despatch Advice",
        "DESADV",
        "05/16/2002",
        "PDF",
        "EDIFACT DESADV_sup_lear_97.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Leggett & Platt",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Levi Straus",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Lewis Spring & Manufacturing Co",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Ligon Brothers",
    "missing": true
  },
  {
    "id": "linamar",
    "name": "Linamar",
    "ediDocs": [
      [
        "Release",
        "830",
        "05/01/2008",
        "PDF",
        "830_Standard_May_1st.pdf"
      ],
      [
        "Ship Notice",
        "856",
        " 01/01/2012",
        "PDF",
        "856 Standard_2012_Linamar.pdf"
      ],
      [
        "Plant Codes",
        "N/A",
        "03/01/2008",
        "PDF",
        "Linamar_Plant_Codes.pdf"
      ],
      [
        "Supplier Form",
        "N/A",
        "03/01/2008",
        "PDF",
        "Supplier_Form.pdf"
      ]
    ]
  },
  {
    "id": "litensauto",
    "name": "Litens Automotive Group",
    "ediDocs": [
      [
        "Planning Schedule With Release Capability",
        "830",
        "04/17/2006",
        "PDF",
        "Litens830.pdf"
      ],
      [
        "Ship Notice/Manifest",
        "856",
        "04/17/2006",
        "PDF",
        "Litens856.pdf"
      ],
      [
        "Shipping Schedule",
        "862",
        "04/17/2006",
        "PDF",
        "Litens862.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Loblaws",
    "missing": true
  },
  {
    "id": "missing",
    "name": "London Drug",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Lord and Taylor",
    "missing": true
  },
  {
    "id": "loweelectric",
    "name": "Lowe Electric",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "10/12/2012",
        "PDF",
        "Eclipse_Vendor_810_4010.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "10/12/2012",
        "PDF",
        "Eclipse_Vendor_850_4010.pdf"
      ],
      [
        "Purchase Order Acknowledgement",
        "855",
        "10/12/2012",
        "PDF",
        "Eclipse_Vendor_855_4010.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "10/12/2012",
        "PDF",
        "Eclipse_Vendor_856_4010.pdf"
      ],
      [
        "EDI Information Sheet",
        "",
        "",
        "PDF",
        "Lowe_Electric_EDI_Info.pdf"
      ]
    ]
  },
  {
    "id": "lowes",
    "name": "Lowes",
    "ediDocs": [
      [
        "Return Merchandise Authorization",
        "180",
        "10/06/2008",
        "PDF",
        "http://www.loweslink.com/pubdocuments/edi180ProcurementImpGuide.pdf"
      ],
      [
        "Motor Carrier Load Tender ",
        "204",
        "12/21/2006",
        "PDF",
        "http://www.loweslink.com/llmain/pubdocuments/204v4010.pdf"
      ],
      [
        "Motor Carrier Freight Invoice ",
        "210",
        "02/27/2007",
        "PDF",
        "http://www.loweslink.com/llmain/pubdocuments/4010210ImpGuide.pdf"
      ],
      [
        "Motor Carrier Bill of Lading ",
        "211",
        "02/02/2007",
        "PDF",
        "4010211.pdf"
      ],
      [
        "Transportation Carrier Shipment Status Message ",
        "214",
        "02/09/2006",
        "PDF",
        "http://www.loweslink.com/llmain/pubdocuments/214v4010.pdf"
      ],
      [
        "Request for Routing Instructions",
        "753",
        "03/29/2023",
        "PDF",
        "EDI_753_Request_RoutingImplementation_Guide.pdf"
      ],
      [
        "Invoice ",
        "810",
        "07/06/2011",
        "PDF",
        "Lowes 810_4010_ImpGuide.pdf"
      ],
      [
        "Remittance Advice ",
        "820",
        "04/09/2007",
        "PDF",
        "http://www.loweslink.com/llmain/pubdocuments/4010820ImpGuide.pdf"
      ],
      [
        "Application Advice",
        "824",
        "01/18/2005",
        "PDF",
        "http://www.loweslink.com/llmain/pubdocuments/824_4060_Specs_1-18-05.pdf"
      ],
      [
        "Purchase Order (Stock)",
        "850",
        "05/21/2009",
        "PDF",
        "Lowes 8504010.pdf"
      ],
      [
        "Purchase Order (SOS)",
        "850",
        "06/07/2007",
        "PDF",
        "http://www.loweslink.com/llmain/pubdocuments/8504010SOS.pdf"
      ],
      [
        "Product Activity (POS) Data ",
        "852",
        "07/15/2007",
        "PDF",
        "http://www.loweslink.com/llmain/pubdocuments/8524010.pdf"
      ],
      [
        "Purchase Order Acknowledgement",
        "855",
        "04/25/2005",
        "PDF",
        "http://www.loweslink.com/llmain/pubdocuments/8554010.pdf"
      ],
      [
        "Advance Ship Notice ",
        "856",
        "04/25/2011",
        "PDF",
        "Lowes 8564010Specs_20110518.pdf"
      ],
      [
        "Order Status Report (SOS)",
        "870",
        "08/16/2005",
        "PDF",
        "http://www.loweslink.com/llmain/pubdocuments/8704010SOS.pdf"
      ],
      [
        "Response To Load Tender ",
        "990",
        "03/17/2005",
        "PDF",
        "http://www.loweslink.com/llmain/pubdocuments/990v4010.pdf"
      ],
      [
        "Functional Acknowledgment ",
        "997",
        "11/09/1998",
        "PDF",
        "http://www.loweslink.com/llmain/pubdocuments/9974010.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "LTC Roll & Engineering Co",
    "missing": true
  },
  {
    "id": "missing",
    "name": "LTV Copperweld",
    "missing": true
  },
  {
    "id": "Lucid",
    "name": "Lucid Motors",
    "ediDocs": [
      [
        "Application Error and Acknowledgement Message",
        "APERAK",
        "09/15/2020",
        "PDF",
        "Specs APERAK.pdf"
      ],
      [
        "Delivery Schedule Message",
        "DELFOR",
        "05/09/2021",
        "PDF",
        "Lucid Motors DELFOR D.04A v1.7 Final.pdf"
      ],
      [
        "Delivery Just In Time Message",
        "DELJIT",
        "05/09/2021",
        "PDF",
        "Lucid Motors DELJIT D.04B v1.7 Final.pdf"
      ],
      [
        "Dispatch and Transport Data",
        "DESADV",
        "05/09/2021",
        "PDF",
        "Lucid Motors DESADV D.07A v1.10 Final.pdf"
      ],
      [
        "Invoice Message",
        "INVOIC",
        "05/09/2021",
        "PDF",
        "Lucid Motors INVOIC D.07A v1.6 Final (1).pdf"
      ],
      [
        "Purchase Order Message",
        "ORDERS",
        "05/09/2021",
        "PDF",
        "EDI Specification ORDERS.pdf"
      ],
      [
        "Purchase Order Change Request Message",
        "ORDCHG",
        "05/09/2021",
        "PDF",
        "Lucid Motors ORDCHG D.01B v1.6 Final.pdf"
      ],
      [
        "Receiving Advice Message",
        "RECADV",
        "05/09/2021",
        "PDF",
        "Lucid Motors RECADV D.03A v1.6 Final.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Ludlow Composites",
    "missing": true
  },
  {
    "id": "missing",
    "name": "LUNT MFG CO",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Lyon Manufacturing, Inc.",
    "missing": true
  },
  {
    "id": "missing",
    "name": "M & Q Plastics EL Paso",
    "missing": true
  },
  {
    "id": "macktruck",
    "name": "Mack Truck",
    "ediDocs": [
      [
        "Sample Data"
      ],
      [
        "142 Data",
        "142",
        "07/01/2002",
        "PDF",
        "MackTruck_142_v4010_TestData.pdf"
      ],
      [
        "810 Data",
        "810",
        "07/01/2002",
        "PDF",
        "MackTruck_810_v4010_TestData.pdf"
      ],
      [
        "820 Data",
        "820",
        "07/01/2002",
        "PDF",
        "MackTruck_820_v4010_TestData.pdf"
      ],
      [
        "824 Data",
        "824",
        "07/01/2002",
        "PDF",
        "MackTruck_824_v4010_TestData.pdf"
      ],
      [
        "830 Data",
        "830",
        "07/01/2002",
        "PDF",
        "MackTruck_830_TestData.pdf"
      ],
      [
        "850bo Data",
        "850",
        "09/01/2002",
        "PDF",
        "MackTruck_850bo_v4010_TestData.pdf"
      ],
      [
        "850sa Data",
        "850",
        "09/01/2002",
        "PDF",
        "MackTruck_850sa_v4010_TestData.pdf"
      ],
      [
        "856 Data",
        "856",
        "07/01/2002",
        "PDF",
        "MackTruck_856_v4010_TestData.pdf"
      ],
      [
        "866 Data",
        "866",
        "04/01/2001",
        "PDF",
        "MackTruck_866_v4010_TestData.pdf"
      ],
      [
        "866fbo Data",
        "866",
        "07/01/2002",
        "PDF",
        "MackTruck_866fbo_v4010_TestData.pdf"
      ],
      [
        "Intro Sheet",
        "",
        "04/30/2008",
        "PDF",
        "MackTruck_Introduction.pdf"
      ],
      [
        "Specifications"
      ],
      [
        "Specifications",
        "",
        "",
        "PDF",
        "http://www.volvo.com/volvoit/edi/en-gb/northamerica/specifications/Specifications.htm"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "MacPherson",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Macsteel Service Centers USA",
    "missing": true
  },
  {
    "id": "Macys",
    "name": "Macys",
    "vendorLink": "https://www.macysnet.com/mdocweb/documents.aspx?category=Vendor+Standards#gotoVendor ",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "06/16/2010",
        "PDF",
        "MACYS810map4030guidelinedoc.pdf.pdf"
      ],
      [
        "Remittance Advice",
        "820",
        "06/15/2015",
        "PDF",
        "MACYS820map4030guidelinedoc.pdf.pdf"
      ],
      [
        "Inventory Advice",
        "846",
        "06/01/2007",
        "PDF",
        "MACYS846map4030guidelinedoc.pdf.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "12/16/2010",
        "PDF",
        "MACYS850map4030guidelinedoc.pdf.pdf"
      ],
      [
        "Product Activity Data",
        "852",
        "10/23/2013",
        "PDF",
        "MACYS852map4030guidelinedoc.pdf.pdf"
      ],
      [
        "Ship Notice/Manifest",
        "856",
        "06/01/2007",
        "PDF",
        "MACYS856map4030guidelinedoc.pdf.pdf"
      ],
      [
        "Functional Acknowledgment",
        "997",
        "06/01/2007",
        "PDF",
        "MACYS997map4030guidelinedoc.pdf.pdf"
      ]
    ]
  },
  {
    "id": "magna",
    "name": "Magna International Inc.",
    "customMessage": true,
    "vendorLink": "http://supplyweb.magna.com/downloads/guidelines.htm",
    "ediDocs": [
      [
        "AIM"
      ],
      [
        "Release",
        "830",
        "04/11/2007",
        "PDF",
        "Magna_AIM/830_Specifications_4010.pdf"
      ],
      [
        "Shipping Notice",
        "856",
        "11/19/2007",
        "PDF",
        "Magna_AIM/856_Specifications_4010.pdf"
      ],
      [
        "AIAG"
      ],
      [
        "Release",
        "830",
        "04/12/1999",
        "PDF",
        "Magna_AIAG/Magna 830 1.2a.pdf"
      ],
      [
        "Shipping Notice",
        "856",
        "11/14/2002",
        "PDF",
        "Magna_AIAG/Magna856_093.pdf"
      ],
      [
        "Bar Code Label Specification",
        "",
        "",
        "PDF",
        "Magna_AIAG/Kamtek Supplier label specifications_March_2014.pdf"
      ],
      [
        "Cam-Slide New Market"
      ],
      [
        "Release",
        "830 (3060)",
        "12/23/2003",
        "PDF",
        "Magna_CamSlide-New_Market/830Ver3060.pdf"
      ],
      [
        "Release Addendum",
        "830 (3060)",
        "03/19/2005",
        "PDF",
        "Magna_CamSlide-New_Market/830AddendumVer3060.pdf"
      ],
      [
        "Release",
        "830 (4010)",
        "11/25/2003",
        "PDF",
        "Magna_CamSlide-New_Market/830Ver4010.pdf"
      ],
      [
        "Release Addendum",
        "830 (4010)",
        "03/19/2005",
        "PDF",
        "Magna_CamSlide-New_Market/830AddendumVer4010.pdf"
      ],
      [
        "Shipping Notice",
        "856 (2040 & 3060)",
        "12/23/2003",
        "PDF",
        "Magna_CamSlide-New_Market/856Ver2040&3060.pdf"
      ],
      [
        "Shipping Notice",
        "856 (4010)",
        "11/25/2003",
        "PDF",
        "Magna_CamSlide-New_Market/856Ver4010.pdf"
      ],
      [
        "Deco Automotive"
      ],
      [
        "Shipping Notice",
        "856",
        "10/10/2007",
        "PDF",
        "Magna_Deco/Magna_856_100.pdf"
      ],
      [
        "Supplier Quality Manual & Requirements",
        "",
        "07/11/2016",
        "PDF",
        "Magna_Deco/Magna Supplier Manual(V1-CMS Plants).pdf"
      ],
      [
        "Vendor EDI Setup Form",
        "",
        "",
        "PDF",
        "Magna_Deco/VENDOR EDI INFO.pdf"
      ],
      [
        "Gaz"
      ],
      [
        "Release",
        "830",
        "10/10/2007",
        "PDF",
        "Magna_GAZ/JSO-N-003_EDI Guideline_ANSI-X12_830_Planning_Schedule.pdf"
      ],
      [
        "Shipping Notice",
        "856",
        "10/10/2007",
        "PDF",
        "Magna_GAZ/JSO-N-003_EDI Guideline_ANSI-X12_856_Ship_Notice.pdf"
      ],
      [
        "Shipping Schedule",
        "862",
        "10/10/2007",
        "PDF",
        "Magna_GAZ/JSO-N-003_EDI Guideline_ANSI-X12_862_Shipping_Schedule.pdf"
      ],
      [
        "Innertech"
      ],
      [
        "Release",
        "830",
        "06/16/2010",
        "PDF",
        "Magna_Innertech/Innertech_856_ShipNotice.pdf"
      ],
      [
        "Integram"
      ],
      [
        "Release",
        "830",
        "09/25/2002",
        "PDF",
        "Magna_Integram/830_Version_4010.pdf"
      ],
      [
        "Release Addendum",
        "830",
        "11/05/2004",
        "PDF",
        "Magna_Integram/EDI_830_Spec_Addendum_4010.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "09/25/2002",
        "PDF",
        "Magna_Integram/856_Version_4010.pdf"
      ],
      [
        "International"
      ],
      [
        "Release",
        "830",
        "04/12/1999",
        "PDF",
        "Magna_International/mr830 1.2a.pdf"
      ],
      [
        "Shipping Notice",
        "856",
        "11/25/2002",
        "PDF",
        "Magna_International/magna856v100.pdf"
      ],
      [
        "Shipping Schedule",
        "862",
        "02/14/2001",
        "PDF",
        "Magna_International/m862_100.pdf"
      ],
      [
        "Intier Automotive Seating"
      ],
      [
        "Planning Schedule (4010)",
        "830",
        "11/25/2003",
        "PDF",
        "Magna_Intier/830Ver4010.pdf"
      ],
      [
        "Planning Schedule Addendum(4010)",
        "830",
        "11/25/2003",
        "PDF",
        "Magna_Intier/830AddendumVer4010.pdf"
      ],
      [
        "Ship Notice(4010)",
        "856",
        "11/25/2003",
        "PDF",
        "Magna_Intier/856Ver4010.pdf"
      ],
      [
        "Modatek"
      ],
      [
        "Ship Notice",
        "856",
        "11/25/2002",
        "PDF",
        "Magna_Modatek/Mod856v2.pdf"
      ],
      [
        "Nascote"
      ],
      [
        "Release",
        "830",
        "01/01/1999",
        "PDF",
        "Magna_Nascote/830_Spec._Sheet.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "03/28/2006",
        "PDF",
        "Magna_Nascote/Vendor_x12_856_Specs_2006-03-28.pdf"
      ],
      [
        "Barcode Specifications",
        "N/A",
        "11/20/2007",
        "PDF",
        "Magna_Nascote/Bar_Code_Label_Specs_M.pdf"
      ],
      [
        "Norplas"
      ],
      [
        "Release",
        "830",
        "04/12/1999",
        "PDF",
        "Magna_Norplas/mr830_1.2a.pdf"
      ],
      [
        "Shipping Notice",
        "856",
        "11/25/2002",
        "PDF",
        "Magna_Norplas/magna856v100.pdf"
      ],
      [
        "Shipping Schedule",
        "862",
        "02/14/2001",
        "PDF",
        "Magna_Norplas/m862_100.pdf"
      ],
      [
        "Polycon"
      ],
      [
        "Release",
        "830 (3060)",
        "04/12/1999",
        "PDF",
        "Magna_Polycon/Polycon_830_EDI_Spec_Ver_3060.pdf"
      ],
      [
        "Release",
        "830 (4010)",
        "03/01/1999",
        "PDF",
        "Magna_Polycon/Polycon_830_EDI_Spec_Ver_4010.pdf"
      ],
      [
        "Shipping Notice",
        "856",
        "03/01/1999",
        "PDF",
        "Magna_Polycon/Polycon_856_ver_3060.pdf"
      ],
      [
        "Contact List",
        "N/A",
        "04/28/2009",
        "PDF",
        "Magna_Polycon/Polycon_Materials_Group_Contact_List.pdf"
      ],
      [
        "Steyr"
      ],
      [
        "Despatch Advice",
        "DESADV",
        "08/10/2015",
        "PDF",
        "Magna_Steyr/MSF_DESADV_EN (1).pdf"
      ],
      [
        "TechCraft"
      ],
      [
        "Release",
        "830 (3060)",
        "07/25/2002",
        "PDF",
        "Magna_TechCraft/830Ver3060.pdf"
      ],
      [
        "Release",
        "830 (4010)",
        "11/25/2003",
        "PDF",
        "Magna_TechCraft/830Ver4010.pdf"
      ],
      [
        "Ship Notice",
        "856 (2040,3060)",
        "12/23/2003",
        "PDF",
        "Magna_TechCraft/856Ver2040and3060.pdf"
      ],
      [
        "Ship Notice",
        "856 (4010)",
        "11/25/2003",
        "PDF",
        "Magna_TechCraft/856Ver4010.pdf"
      ],
      [
        "Shipping Schedule",
        "862",
        "11/25/2003",
        "PDF",
        "Magna_TechCraft/862Ver4010.pdf"
      ],
      [
        "EDI Spec Addendum 3060",
        "N/A",
        "11/05/2004",
        "PDF",
        "Magna_TechCraft/EDI_Spec_Addendum_3060.pdf"
      ],
      [
        "EDI Spec Addendum 4010",
        "N/A",
        "11/05/2004",
        "PDF",
        "Magna_TechCraft/EDI_Spec_Addendum_4010.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Magnetti Marelli Cofap",
    "missing": true
  },
  {
    "id": "mahleclevite",
    "name": "Mahle Clevite Inc.",
    "ediDocs": [
      [
        "Purchase Order",
        "850",
        "01/17/2002",
        "PDF",
        "Dana_Clevite_Engine Parts_850_4010.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "08/22/2001",
        "PDF",
        "Dana_Clevite_Engine Parts_856_4010.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Mahle Engine Components USA, Inc.",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Major Electric",
    "missing": true
  },
  {
    "id": "missing",
    "name": "MAKSteel",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Mancor",
    "missing": true
  },
  {
    "id": "mannhummel",
    "name": "Mann and Hummel",
    "ediDocs": [
      [
        "Delivery Forecast",
        "DELFOR",
        "05/09/2002",
        "PDF",
        "MH_DELFOR_97a.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Manual Transmissions of Muncie",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Manufacturers Industrial Group",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Maple Stamping",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Mariner Neptune",
    "missing": true
  },
  {
    "id": "markiv",
    "name": "Mark IV Automotive/Dayco Products",
    "ediDocs": [
      [
        "EDI Specifications and Implementation Guide",
        "ALL",
        "11/21/2014",
        "PDF",
        "http://www.markivautosupplier.com/assets/Mark_IV_Automotive_EDI_Implementation_Guide.pdf"
      ],
      [
        "Barcode Specifications",
        "N/A",
        "02/17/2005",
        "PDF",
        "http://www.markivautosupplier.com/assets/Barcode%20Spec.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Marketing Displays International",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Marketing Displays Intl.",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Markin Tubing",
    "missing": true
  },
  {
    "id": "marshalls",
    "name": "Marshalls",
    "ediDocs": [
      [
        "Purchase Order",
        "850",
        "03/24/2006",
        "PDF",
        "MARSHALLS_850_guideline.pdf.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "12/17/2004",
        "PDF",
        "MARSHALLS_856_gudeline.pdf.pdf"
      ],
      [
        "Purchase Order Change",
        "860",
        "12/02/2004",
        "PDF",
        "MARSHALLS_860_guideline.pdf.pdf"
      ]
    ]
  },
  {
    "id": "martinreainternational",
    "name": "Martinrea",
    "ediDocs": [
      [
        "International"
      ],
      [
        "Release",
        "830",
        "",
        "PDF",
        "Martirnea EDI 830 SPECS.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "",
        "PDF",
        "Martirnea EDI 856 SPECS v1.pdf"
      ],
      [
        "Arteaga"
      ],
      [
        "Vendor EDI information sheet",
        "",
        "",
        "DOC",
        "Arteaga Vendor EDI information sheet.docx"
      ],
      [
        "Planning Schedule",
        "830",
        "",
        "PDF",
        "Martirnea EDI 830 SPECS.pdf"
      ],
      [
        "Advanced Ship Notice",
        "856",
        "",
        "PDF",
        "Martirnea EDI 856 SPECS.pdf"
      ],
      [
        "Vendor shipping label specifications",
        "",
        "",
        "PDF",
        "vendor shipping label specifications.pdf"
      ],
      [
        "North Vernon / Allevard-Sogefi"
      ],
      [
        "Vendor shipping label specifications",
        "",
        "",
        "PDF",
        "vendor shipping label specifications.pdf"
      ],
      [
        "Planning Schedule",
        "830",
        "",
        "PDF",
        "Martirnea EDI 830 SPECS.PDF"
      ],
      [
        "Advanced Ship Notice",
        "856",
        "",
        "PDF",
        "Martirnea EDI 856 SPECS.PDF"
      ],
      [
        "Columbia"
      ],
      [
        "Release",
        "830",
        "01/01/2009",
        "PDF",
        "Specification Martinrea EDI 830.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "11/01/2014",
        "PDF",
        "Specification Martinrea EDI 856 v2.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Martinrea - Bishop Circle Assm",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Martinrea Intl.",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Masterbilt Products",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Maxim Integrated Products",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Maxzone",
    "missing": true
  },
  {
    "id": "mayco",
    "name": "Mayco",
    "ediDocs": [
      [
        "Release",
        "830",
        "02/01/1998",
        "PDF",
        "AIAG_830.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "02/01/1998",
        "PDF",
        "AIAG_856.pdf"
      ]
    ]
  },
  {
    "id": "mazda",
    "name": "Mazda Corporation",
    "ediDocs": [
      [
        "EDI Specifications Guide",
        "ALL",
        "07/17/2012",
        "PDF",
        "http://suppliers.mazdausa.com/Library/edi_manual.pdf"
      ],
      [
        "Barcode Specifications",
        "N/A",
        "08/31/2013",
        "PDF",
        "http://suppliers.mazdausa.com/Library/edi_bar_code_labels.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "MCGARD",
    "missing": true
  },
  {
    "id": "missing",
    "name": "McKesson",
    "missing": true
  },
  {
    "id": "missing",
    "name": "McLaughlin Body Company",
    "missing": true
  },
  {
    "id": "missing",
    "name": "McMahon / Metro Richelieu",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Mechanical & Industrial Fasteners",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Medler Electric",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Mellon Bank",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Memorial Hermann",
    "missing": true
  },
  {
    "id": "menasha",
    "name": "Menasha Corporation",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "10/19/2015",
        "PDF",
        "Menasha_X12_004010_810.pdf"
      ]
    ]
  },
  {
    "id": "menlologistics",
    "name": "Menlo Logistics",
    "imgFileName": "menlologistics.gif",
    "ediDocs": [
      [
        "Logistics Service Request",
        "219",
        "02/14/2010",
        "PDF",
        "Client-MWL_219_Logistics_Request_V03.pdf"
      ]
    ]
  },
  {
    "id": "mercedes",
    "name": "Mercedes",
    "ediDocs": [
      [
        "Payment Advice",
        "820",
        "03/12/2007",
        "PDF",
        "EDISpec12MAR2007.pdf"
      ],
      [
        "Application Advice",
        "824",
        "03/12/2007",
        "PDF",
        "EDISpec12MAR2007.pdf"
      ],
      [
        "Release",
        "830",
        "03/12/2007",
        "PDF",
        "EDISpec12MAR2007.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "02/04/2016",
        "PDF",
        "EDI specification 856_V1.4.pdf"
      ],
      [
        "Shiping Schedule",
        "862",
        "03/12/2007",
        "PDF",
        "EDISpec12MAR2007.pdf"
      ],
      [
        "Functional Acknowledgement",
        "997",
        "03/12/2007",
        "PDF",
        "EDISpec12MAR2007.pdf"
      ],
      [
        "Steel Offload Process",
        "",
        "",
        "",
        "undefined"
      ],
      [
        "Multiple",
        "820, 830, 847, 856, 861, 997",
        "08/31/2010",
        "PDF",
        "EDI Spec Steel Offload_Aug31-2010.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Merchant Dist",
    "missing": true
  },
  {
    "id": "mercurymarine",
    "name": "Mercury Marine",
    "ediDocs": [
      [
        "Release",
        "830",
        "04/16/2007",
        "PDF",
        "Mercury_Marine_830_856_4010.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "04/16/2007",
        "PDF",
        "Mercury_Marine_830_856_4010.pdf"
      ],
      [
        "Miscellaneous",
        "EDI Document",
        "Date Updated",
        "",
        "undefined"
      ],
      [
        "EFT(ACH)Implementation Guide",
        "Financial EDI",
        "10/19/2006",
        "PDF",
        "EFT_ACH_Implementation_Guide.pdf"
      ],
      [
        "EFT(ACH) Authorization Form",
        "Financial EDI",
        "NA",
        "DOC",
        "EFT(ACH)Authorization_Form.doc"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Meridian Automotive Systems",
    "missing": true
  },
  {
    "id": "meridiantechnologies",
    "name": "Meridian Technologies",
    "imgFileName": "meridiantechnologies.bmp",
    "ediDocs": [
      [
        "Material Release Transaction Set (4010)",
        "830",
        "11/18/2009",
        "PDF",
        "Plex_830_v04010.pdf"
      ],
      [
        "Advance Ship Notice/Manfest (4010)",
        "856",
        "03/25/2010",
        "PDF",
        "Plex_856_v04010.pdf"
      ],
      [
        "Ship Schedule (4010)",
        "862",
        "12/05/2009",
        "PDF",
        "Plex_862_v04010.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Mervyns",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Metal And Wire Products",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Metal Ceramics",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Metal Improvement Company",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Metal One America Inc.",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Metal-Matic, Inc.",
    "missing": true
  },
  {
    "id": "metaldyne",
    "name": "Metaldyne",
    "ediDocs": [
      [
        "Release",
        "830",
        "10/01/2012",
        "PDF",
        "830_Planning_Release_EDI_Specification.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "07/07/2010",
        "PDF",
        "856_ASN_EDI_Specification.pdf"
      ],
      [
        "Functional Acknowledgement",
        "997",
        "07/07/2010",
        "PDF",
        "997_Functional_Acknowledgement_EDI_Specification.pdf"
      ],
      [
        "Barcode Label Specification",
        "",
        "",
        "PDF",
        "Barcode_Label_Specification.pdf"
      ],
      [
        "EDI BarCode Labeling",
        "",
        "04/04/2006",
        "PDF",
        "EDI_BarCode_Labeling.pdf"
      ],
      [
        "Metaldyne Supplier EDI Questionnaire",
        "",
        "",
        "DOC",
        "Metaldyne_Supplier__EDI_Questionnaire.doc"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Meteor Sealing Systems",
    "missing": true
  },
  {
    "id": "methodeelectronics",
    "name": "Methode Electronics",
    "ediDocs": [
      [
        "Release",
        "830",
        "12/10/2007",
        "PDF",
        "Methode Electronics 830-specs.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "12/10/2007",
        "PDF",
        "Methode Electronics 856-specs.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "MetoKote Corporation",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Metro Health Systems",
    "missing": true
  },
  {
    "id": "mgmbrakes",
    "name": "MGM Brakes",
    "ediDocs": [
      [
        "Release",
        "830",
        "06/24/2004",
        "PDF",
        "830_Specs.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "06/24/2004",
        "PDF",
        "856_Specs.pdf"
      ],
      [
        "Barcode Specifications",
        "N/A",
        "06/24/2004",
        "PDF",
        "Barcode_Label_Requirements.pdf"
      ],
      [
        "Implementation Guidelines",
        "856",
        "06/24/2004",
        "PDF",
        "Trading_Partner_Implementation_Guidelines.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Miami Systems",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Michael Day Enterprises",
    "missing": true
  },
  {
    "id": "maci",
    "name": "Michigan Automotive Compressor, Inc. (MACI)",
    "ediDocs": [
      [
        "Multiple",
        "824, 830, 856, 997",
        "01/05/2009",
        "PDF",
        "MACI_Supplier_EDI_Specifications.pdf"
      ],
      [
        "Label Requirements",
        "N/A",
        "05/10/2004",
        "PDF",
        "MACI_AIAG_Tag_Specifications_05-10-04.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "MidStates",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Midway Industries",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Midwest Rubber Company",
    "missing": true
  },
  {
    "id": "midweststamping",
    "name": "Midwest Stamping",
    "ediDocs": [
      [
        "Release",
        "830",
        "03/01/1999",
        "PDF",
        "VR830specs4010.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "03/01/1999",
        "PDF",
        "VR856specs4010.pdf"
      ],
      [
        "Shipping Schedule",
        "862",
        "03/01/1999",
        "PDF",
        "VR862specs4010.pdf"
      ],
      [
        "Text Message",
        "864",
        "03/01/1999",
        "PDF",
        "VR864specs4010.pdf"
      ],
      [
        "Functional Acknowledgement",
        "997",
        "03/01/1999",
        "PDF",
        "VR997specs4010.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Mikimoto (America) Co.",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Mill Steel",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Milliken",
    "missing": true
  },
  {
    "id": "mitchellplastics",
    "name": "Mitchell Plastics",
    "ediDocs": [
      [
        "Delivery Forecast",
        "DELFOR",
        "03/01/2016",
        "PDF",
        "Delivery Forecast - DELFOR SPEC (2).pdf"
      ],
      [
        "Ship Schedule",
        "DELJIT",
        "03/01/2016",
        "PDF",
        "Ship Schedule - DELJIT SPEC.pdf"
      ],
      [
        "Despatch Advice",
        "DESADV",
        "11/25/2016",
        "PDF",
        "UMMP Despatch Advice - DESADV SPEC.pdf"
      ],
      [
        "Container Label Requirements",
        "",
        "11/13/2015",
        "PDF",
        "STD-006 Container_Label_Standard_v1.pdf"
      ]
    ]
  },
  {
    "id": "mitsubishi",
    "name": "Mitsubishi",
    "ediDocs": [
      [
        "Remittance Advice",
        "820",
        "08/04/2000",
        "PDF",
        "IG820V4010.pdf"
      ],
      [
        "Application Advice",
        "824",
        "06/18/2004",
        "PDF",
        "IG824V4010ASN.pdf"
      ],
      [
        "Release",
        "830",
        "03/15/2004",
        "PDF",
        "ig830v2002.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "02/07/2001",
        "PDF",
        "IG856V2002.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Mitsubishi Electric",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Mitsui Soko",
    "missing": true
  },
  {
    "id": "missing",
    "name": "MNP",
    "missing": true
  },
  {
    "id": "mobis",
    "name": "MOBIS Alabama, LLC",
    "ediDocs": [
      [
        "Mobis RDC Service Parts"
      ],
      [
        "Invoice",
        "810",
        "01/21/2005",
        "PDF",
        "RDC/810_RDC_Invoice_-1.0-.pdf"
      ],
      [
        "Remittance Advice",
        "820",
        "01/21/2005",
        "PDF",
        "RDC/820_RDC_Remittance_Advice-1.0-.pdf"
      ],
      [
        "Planning Schedule",
        "830",
        "01/21/2005",
        "PDF",
        "RDC/830_RDC_Planning_Schedule-1.0-.pdf"
      ],
      [
        "Shipping Notice",
        "856",
        "01/21/2005",
        "PDF",
        "RDC/856_RDC_Ship_Notice-1.0-.pdf"
      ],
      [
        "Receiving Advice",
        "861",
        "01/21/2005",
        "PDF",
        "RDC/861_RDC_ReceivingAdvice-1.0-.pdf"
      ],
      [
        "Functional Acknowledgment",
        "997",
        "01/21/2005",
        "PDF",
        "RDC/997_RDC_Functional_Acknowledgement_-1.0-.pdf"
      ],
      [
        "Mobis USA Production Parts"
      ],
      [
        "Planning Schedule",
        "830",
        "01/21/2005",
        "PDF",
        "ServiceParts/830 Prod.Parts Planning Schedule -1.0-.pdf"
      ],
      [
        "Shipping Notice",
        "856",
        "01/21/2005",
        "PDF",
        "ServiceParts/856 Prod.Parts Ship Notice -1.0-.pdf"
      ],
      [
        "Receiving Advice",
        "861",
        "01/21/2005",
        "PDF",
        "ServiceParts/861 Prod.Parts ReceivingAdvice -1.0-.pdf"
      ],
      [
        "Release",
        "862",
        "01/21/2005",
        "PDF",
        "ServiceParts/862 Prod.Parts Shipping Schedule -1.0-.pdf"
      ],
      [
        "Functional Acknowledgment",
        "997",
        "01/21/2005",
        "PDF",
        "ServiceParts/997 Prod.Parts Functional Acknowledgement -1.0-.pdf"
      ],
      [
        "Barcode Layout Specifications",
        "N/A",
        "01/21/2005",
        "PDF",
        "ServiceParts/MOBIS_Barcode_Label_Layout1.pdf"
      ],
      [
        "Barcode Requirements",
        "N/A",
        "01/21/2005",
        "PDF",
        "ServiceParts/Service_Parts_Barcode_Requirements.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Modatek",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Modern Industries",
    "missing": true
  },
  {
    "id": "modine",
    "name": "Modine",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "10/22/2014",
        "PDF",
        "Modine Mfg 810 v5010_updated.pdf"
      ],
      [
        "Application Advice",
        "824",
        "07/21/2014",
        "PDF",
        "Modine Mfg 824 v5010.pdf"
      ],
      [
        "Release",
        "830",
        "09/18/2014",
        "PDF",
        "Modine Mfg 830 v5010.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "09/17/2014",
        "PDF",
        "Modine Mfg 856 v5010.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Modineer",
    "missing": true
  },
  {
    "id": "mohawk",
    "name": "Mohawk Industries",
    "ediDocs": [
      [
        "Ship Notice",
        "856",
        "",
        "Excel",
        "Pak-Lite ASN_X12 Mapping.xlsx"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Molded Fiber Glass",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Momentive Performance Materials",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Montaplast Na",
    "missing": true
  },
  {
    "id": "mpglobal",
    "name": "MP Global",
    "ediDocs": [
      [
        "ANSI X12 Versions"
      ],
      [
        "Warehouse Shipping Order",
        "940",
        "03/29/2012",
        "PDF",
        "940guidelines.pdf"
      ],
      [
        "Warehouse Shipping Advice",
        "945",
        "03/29/2012",
        "PDF",
        "945guidelines.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "MPI International (Indiana)",
    "missing": true
  },
  {
    "id": "mscindustrial",
    "name": "MSC Industrial",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "03/29/2016",
        "PDF",
        "MSC Industrial Supplier 810.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "",
        "PDF",
        "MSC_Supplier_850_MAP_4010-96C6.pdf"
      ],
      [
        "Purchase Order Acknowledgement",
        "855",
        "",
        "PDF",
        "MSC_Vendor 855 MAP.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "03/29/2016",
        "PDF",
        "MSC_Vendor_856_MAP-96C6.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "MTM",
    "missing": true
  },
  {
    "id": "mtuamerica",
    "name": "MTU America",
    "ediDocs": [
      [
        "Freight Receipt and Invoice",
        "310",
        "08/22/2007",
        "PDF",
        "4010_310.pdf"
      ]
    ]
  },
  {
    "id": "mtudetroitdiesel",
    "name": "MTU Detroit Diesel",
    "ediDocs": [
      [
        "Ship Notice",
        "856",
        "09/30/2009",
        "PDF",
        "MTU-DD_856_Specifications_(V04)_20090930.pdf"
      ],
      [
        "Shipping Schedule",
        "862",
        "01/14/2009",
        "PDF",
        "MTU-DD_862_Specifications_(V03)_20090114.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Multimatic",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Murata Electronics of NA, Inc.",
    "missing": true
  },
  {
    "id": "napa",
    "name": "Napa",
    "imgFileName": "napa.gif",
    "ediDocs": [
      [
        "Napa Balkamp"
      ],
      [
        "Purchase Order",
        "850",
        "03/07/2009",
        "PDF",
        "Napa850_4010v2.pdf"
      ],
      [
        "Ship Notice/Manifest",
        "856",
        "05/08/2001",
        "PDF",
        "Napa856_4010.pdf"
      ],
      [
        "Automotive Redistribution Centers"
      ],
      [
        "Purchase Order",
        "850",
        "09/17/2003",
        "PDF",
        "850_ARC_4010.pdf"
      ],
      [
        "Ship Notice/Manifest",
        "856",
        "05/08/2001",
        "PDF",
        "856_ARC_4010.pdf"
      ],
      [
        "Supplier Questionnaire",
        "N/A",
        "12/23/2003",
        "PDF",
        "ARC_Supplier_EDI_Questionnaire.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Napa Balkamp",
    "missing": true
  },
  {
    "id": "napmrailindustryforum",
    "name": "Napm Rail Industry Forum",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "APRIL 1998",
        "PDF",
        "Rail Industry Forum_810rifdf_4010.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "APRIL 1998",
        "PDF",
        "Rail Industry Forum 850_4010.pdf"
      ],
      [
        "Ship Notice/Manifest",
        "856",
        "08/02/2011",
        "PDF",
        "Rail Industry Forum UP Supplys EDI Spec 856 v4010 042811.pdf"
      ],
      [
        "Acknowledgment",
        "997",
        "April 1998",
        "PDF",
        "Rail Industry Forum 997.pdf"
      ]
    ]
  },
  {
    "id": "narmco",
    "name": "Narmco",
    "ediDocs": [
      [
        "Release",
        "830",
        "",
        "PDF",
        "830 SupplyWEB_X12CC - EDI.pdf"
      ],
      [
        "Ship Notice/Manifest",
        "856",
        "",
        "PDF",
        "856 SupplyWEB_X12 - EDI.pdf"
      ],
      [
        "Acknowledgment",
        "997",
        "",
        "PDF",
        "997 SupplyWEB_X12_spec - EDI.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Nash Finch",
    "missing": true
  },
  {
    "id": "missing",
    "name": "National Fast Freight",
    "missing": true
  },
  {
    "id": "missing",
    "name": "National Furniture",
    "missing": true
  },
  {
    "id": "missing",
    "name": "National Grocer",
    "missing": true
  },
  {
    "id": "missing",
    "name": "National Materials de Mexico",
    "missing": true
  },
  {
    "id": "missing",
    "name": "National Rivet",
    "missing": true
  },
  {
    "id": "navico",
    "name": "Navico",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "07/15/2009",
        "PDF",
        "Navico_810_4030.pdf"
      ],
      [
        "Release",
        "830",
        "01/22/2010",
        "PDF",
        "Navico_830_4030.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "10/20/1997",
        "PDF",
        "Navico_850_4030.pdf"
      ],
      [
        "Purchase Order Acknowledgement",
        "855",
        "10/20/1997",
        "PDF",
        "Navico_855_4030.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "10/20/1997",
        "PDF",
        "Navico_856_4030.pdf"
      ]
    ]
  },
  {
    "id": "navistar",
    "name": "Navistar",
    "fullName": "Navistar Corporation",
    "vendorLink": "http://www.navistarsupplier.com/EDI/EDI_Implementation_Guides.aspx",
    "ediDocs": [
      [
        "EDI - General Documents",
        "N/A",
        "N/A",
        "Website",
        "http://www.navistarsupplier.com/"
      ],
      [
        "EDI - Implementation Guides",
        "N/A",
        "N/A",
        "Website",
        "http://www.navistarsupplier.com/EDI/EDI_Implementation_Guides.aspx"
      ],
      [
        "EDI - Business Guides - Truck",
        "N/A",
        "N/A",
        "Website",
        "http://www.navistarsupplier.com/EDI/EDI_Business_Guides_Truck.aspx"
      ],
      [
        "EDI - Business Guides - Parts",
        "N/A",
        "N/A",
        "Website",
        "http://www.navistarsupplier.com/EDI/EDI_Business_Guides_Service_Parts.aspx"
      ]
    ]
  },
  {
    "id": "neapco",
    "name": "Neapco Drivelines",
    "ediDocs": [
      [
        "Remittance Advice",
        "820",
        "05/05/2008",
        "PDF",
        "neapco_drivelines_820_EDI_Guidelines.pdf"
      ],
      [
        "Planning Schedule with Release Capability",
        "830",
        "11/18/2009",
        "PDF",
        "NDL EDI SPECS/Plex_830_v04010.pdf"
      ],
      [
        "Shipping Notice",
        "856",
        "03/25/2010",
        "PDF",
        "NDL EDI SPECS/Plex_856_v04010.pdf"
      ],
      [
        "Receiving Advice",
        "861",
        "05/05/2008",
        "DOC",
        "NDL EDI SPECS/0_07952149_413044689467593.rtf"
      ],
      [
        "Ship Schedule",
        "862",
        "12/05/2009",
        "PDF",
        "NDL EDI SPECS/Plex_862_v04010.pdf"
      ],
      [
        "Application Advice",
        "824",
        "",
        "DOC",
        "NDL EDI SPECS/0_07952150_413044685300926.doc"
      ],
      [
        "Supplier Letter",
        "N/A",
        "",
        "PDF",
        "NDL EDI SPECS/EDI Spec.pdf"
      ],
      [
        "Europe VDA"
      ],
      [
        "Release for Production Material",
        "4905",
        "05/14/2008",
        "PDF",
        "Europe/VDA4905_V1-1.pdf"
      ],
      [
        "EDI for Advance Shipping Note ",
        "4913-2",
        "05/01/2011",
        "PDF",
        "Europe/VDA4913.pdf"
      ],
      [
        "Daily Call - In for Production Material",
        "4915-2 v.3",
        "05/01/2011",
        "PDF",
        "Europe/VDA4915_V3.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "NEDCAR",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Negotium",
    "missing": true
  },
  {
    "id": "nemak",
    "name": "Nemak",
    "customMessage": true,
    "ediDocs": [
      [
        "Release",
        "830",
        "09/28/2016",
        "PDF",
        "830_1.4.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "03/15/2022",
        "PDF",
        "Nemak_856_v1 3_15032022.pdf"
      ],
      [
        "Ship Schedule",
        "862",
        "09/28/2016",
        "PDF",
        "Nemak 862_1.3.pdf"
      ],
      [
        "Text Message",
        "864",
        "11/13/2008",
        "PDF",
        "Nemak_864_Text Message.pdf"
      ],
      [
        " Sub-Supplier Label Specifications and Packaging Guidelines",
        "",
        "",
        "PDF",
        "Nemak Vendor Label Standard.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Netshape Corp.",
    "missing": true
  },
  {
    "id": "neos",
    "name": "New England Office Supply",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "06/25/2009",
        "PDF",
        "NEOS810.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "06/25/2009",
        "PDF",
        "NEOS850.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "New Life Transport",
    "missing": true
  },
  {
    "id": "missing",
    "name": "New Technology Steel",
    "missing": true
  },
  {
    "id": "missing",
    "name": "NewCor",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Nexcom",
    "missing": true
  },
  {
    "id": "nexteer",
    "name": "Nexteer",
    "vendorLink": "http://www.nexteer.com/supplier-portal/processes/shipping-and-labeling/",
    "ediDocs": [
      [
        "ANSIX12 Specifications"
      ],
      [
        "Release",
        "830",
        "March, 2010",
        "PDF",
        "Global-Supplier-EDI-Specification-830.pdf"
      ],
      [
        "Shipping Schedule",
        "862",
        "03/19/2010",
        "PDF",
        "Global-Supplier-EDI-Specification-862.pdf"
      ],
      [
        "Advanced Shipping Notice",
        "856",
        "02/13/2013",
        "PDF",
        "Global-Supplier-EDI-Specification-856.pdf"
      ],
      [
        "EDIFACT Specifications"
      ],
      [
        "Delivery Forecast",
        "DELFOR",
        "09/10/2012",
        "PDF",
        "NEXTEER_DELFOR_121009.pdf"
      ],
      [
        "Ship Schedule",
        "DELJIT",
        "09/10/2012",
        "PDF",
        "NEXTEER_DELJIT_121009.pdf"
      ],
      [
        "Despatch Advice",
        "DESADV",
        "11/05/2013",
        "PDF",
        "NEXTEER_DESADV_121009.pdf"
      ],
      [
        "Label Requirements",
        "",
        "04/05/2014",
        "PDF",
        "Label-Requirements-Standards-DELJIT.pdf"
      ]
    ]
  },
  {
    "id": "nhkseating",
    "name": "NHK Seating",
    "ediDocs": [
      [
        "Release",
        "830",
        "07/19/2010",
        "PDF",
        "http://www.nhkseating.com/images/NHK%20EDI%20830.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "07/19/2010",
        "PDF",
        "http://www.nhkseating.com/images/NHK%20EDI%20856.pdf"
      ],
      [
        "Shipping Schedule",
        "862",
        "07/19/2010",
        "PDF",
        "http://www.nhkseating.com/images/NHK%20862%20EDI%20Standards.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Nichicon America Corp",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Nidec-Motors & Actuators",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Nifast Carol Stream",
    "missing": true
  },
  {
    "id": "nifco",
    "name": "Nifco LLC",
    "ediDocs": [
      [
        "Planning Schedule With Release Capability",
        "830",
        "02/01/2003",
        "PDF",
        "Nifco_830_4010_Specs.pdf"
      ],
      [
        "Ship Notice/Manifest",
        "856",
        "10/01/2003",
        "PDF",
        "Nifco_856_4010_Specs050911.pdf"
      ],
      [
        "Shipping Schedule",
        "862",
        "12/01/2004",
        "PDF",
        "Nifco_862_4010_Specs050911.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "NISC",
    "missing": true
  },
  {
    "id": "nissan",
    "name": "Nissan North America",
    "ediDocs": [
      [
        "ANSI X-12 v2001"
      ],
      [
        "Envelope",
        "NA",
        "01/27/2011",
        "PDF",
        "2001/05-ENVELOPE_01272011_Envelope_ANSI_X-12_2001.pdf"
      ],
      [
        "Application Advice",
        "824",
        "04/21/2016",
        "PDF",
        "NISSAN_824_4010_v1.1.pdf"
      ],
      [
        "Material Release",
        "830",
        "02/01/25/2016",
        "PDF",
        "NISSAN_830_4010_v1.2.pdf"
      ],
      [
        "Advance Shipping Notice ",
        "856",
        "02/27/2017",
        "PDF",
        "MFG856R_Manufacturing ASN 2001_02272017.pdf"
      ],
      [
        "Receiving Advice",
        "861",
        "07/09/2021",
        "PDF",
        "SCM861R Receiving Advice Acceptance Certificate__4010_07092021.pdf"
      ],
      [
        "Shipping Schedule",
        "862",
        "04/25/2016",
        "PDF",
        "NISSAN_862_v4010_v1.5.pdf"
      ],
      [
        "Order Status Report",
        "870",
        "12/21/2022",
        "PDF",
        "NOVA870R Order Status Report__5010_12212022.pdf"
      ],
      [
        "NNA SERVICE PARTS"
      ],
      [
        "Release",
        "830",
        "01/07/2011",
        "PDF",
        "TPC_Supplier_830_v4010_07_1.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "04/13/2006",
        "PDF",
        "TPC_Supplier_856_v4010_0601.pdf"
      ],
      [
        "Supplier Packaging Handbook",
        "N/A",
        "07/15/2007",
        "PDF",
        "Nissan_Service_Parts_and_Accessories_Supplier_Packaging_Handbook_7-15-07.pdf"
      ],
      [
        "NISSAN TRADING CORPORATION"
      ],
      [
        "Release",
        "830",
        "10/08/2007",
        "PDF",
        "NissanTradingCorp/830motors.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "10/08/2007",
        "PDF",
        "NissanTradingCorp/856motors.pdf"
      ],
      [
        "Barcode Specifications",
        "N/A",
        "04/28/2009",
        "PDF",
        "NissanTradingCorp/Bar_Code_Label_Standards.pdf"
      ],
      [
        "Supplier Packaging Handbook",
        "N/A",
        "12/01/2002",
        "PDF",
        "NissanTradingCorp/SUPPLIERMANUALNITCO.pdf"
      ],
      [
        "NISSAN MEXICO, S.A. de C.V."
      ],
      [
        "Application Advice",
        "824",
        "09/27/2004",
        "PDF",
        "NISSAN_824_004010.pdf"
      ],
      [
        "Release",
        "830",
        "",
        "PDF",
        "NISSAN_830_002001.pdf"
      ],
      [
        "Advance Ship Notice",
        "856",
        "",
        "PDF",
        "NISSAN_856_003020.pdf"
      ],
      [
        "Receiving Advice/Acceptance Certificate",
        "861",
        "09/24/2004",
        "PDF",
        "NISSAN_861_004010.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Nitco Inc.",
    "missing": true
  },
  {
    "id": "missing",
    "name": "NJT Enterprises (dba Mayco Intl.)",
    "missing": true
  },
  {
    "id": "noma",
    "name": "Noma Corporation",
    "ediDocs": [
      [
        "Ship Notice",
        "856",
        "04/21/2005",
        "PDF",
        "Noma_856_4010.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Nordstrom",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Norgren/GT",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Norplas Industries Inc.",
    "missing": true
  },
  {
    "id": "nal",
    "name": "North America Lighting",
    "ediDocs": [
      [
        "Release",
        "830",
        "11/08/2013",
        "PDF",
        "Plex_830_v04010_20131108.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "11/08/2013",
        "PDF",
        "Plex_856_v4010_20131108.pdf"
      ],
      [
        "Ship Schedule",
        "862",
        "11/08/2013",
        "PDF",
        "Plex_862_v04010_20131108.pdf"
      ],
      [
        "Label Specifications",
        "",
        "",
        "XLSX",
        "NAL_Label_Specs.xlsx"
      ],
      [
        "Sample Label",
        "",
        "",
        "PDF",
        "New Plex Label 2016.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Northern Engraving Corp.",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Northern Tool",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Nova Steel",
    "missing": true
  },
  {
    "id": "novant",
    "name": "Novant Health",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "01/28/2009",
        "PDF",
        "4010_810_Specs.pdf"
      ]
    ]
  },
  {
    "id": "novelis",
    "name": "Novelis North America (NNA)",
    "ediDocs": [
      [
        "Advance Ship Notice",
        "856",
        "10/20/2016",
        "PDF",
        "Novelis_856_I_004010_IMG_v1.7.pdf"
      ],
      [
        "Quality Certification",
        "863",
        "10/19/2016",
        "PDF",
        "Novelis_863_I_004010_IMG_v1_4.pdf"
      ]
    ]
  },
  {
    "id": "novem",
    "name": "Novem",
    "ediDocs": [
      [
        "Delivery Forecast",
        "DELFOR",
        "03/03/2016",
        "PDF",
        "EDIFACT_DELFOR_D97A_V31.pdf"
      ],
      [
        "Despatch Advice",
        "DESADV",
        "07/13/2015",
        "PDF",
        "EDIFACT_DESADV_D97A_V2.pdf"
      ],
      [
        "EDI Communication Sheet",
        "",
        "",
        "PDF",
        "EDI Kommunikationssheet.pdf"
      ]
    ]
  },
  {
    "id": "ntnbower",
    "name": "NTN-Bower Corp",
    "ediDocs": [
      [
        "Specs",
        "All Transactions",
        "",
        "PDF",
        "TRANS4M_EDI820.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Nucor",
    "missing": true
  },
  {
    "id": "missing",
    "name": "NYE Synthetic Lubricant",
    "missing": true
  },
  {
    "id": "nyloncraft",
    "name": "Nyloncraft",
    "ediDocs": [
      [
        "Planning Schedule With Release Capability",
        "830",
        "10/28/2005",
        "PDF",
        "http://www.nyloncraft.com/pdfs/NCI_edi830-4010_Generic.pdf"
      ],
      [
        "Ship Notice/Manifest",
        "856",
        "10/29/2005",
        "PDF",
        "http://www.nyloncraft.com/pdfs/NCI_edi856-4010%20_Generic.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "NYX Incorporated",
    "missing": true
  },
  {
    "id": "oreilly",
    "name": "O'Reilly / Ozark Automotive Inc.",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "",
        "PDF",
        "Inbound Invoice (810).pdf"
      ],
      [
        "Purchase Order",
        "850",
        "10/15/2008",
        "PDF",
        "OZARK850.pdf"
      ],
      [
        "Shipping Notice",
        "856",
        "05/2012",
        "PDF",
        "ASN (856).pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Oakland Tool & Mfg.",
    "missing": true
  },
  {
    "id": "officedepot",
    "name": "Office Depot",
    "ediDocs": [
      [
        "Ship Notice",
        "856",
        "11/01/2004",
        "PDF",
        "OD EDI Guide 856.pdf"
      ]
    ]
  },
  {
    "id": "ofs",
    "name": "OFS Optics",
    "ediDocs": [
      [
        "All Transactions",
        "",
        "12/09/2002",
        "PDF",
        "OFS_Implementation_Guide_120902.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Ogihara Mfg",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Ohio Module Manufacturing Company (Detroit)",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Olympic Steel",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Omron Automotive Electronics",
    "missing": true
  },
  {
    "id": "missing",
    "name": "OnStar",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Optek Technologies",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Orgill, Inc.",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Orscheln Farm and Home",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Orscheln Products LLC",
    "missing": true
  },
  {
    "id": "oshkosh",
    "name": "OshKosh",
    "ediDocs": [
      [
        "Implementation Guide",
        "All",
        "06/30/2008",
        "PDF",
        "4010_Implementation_Guide.pdf"
      ],
      [
        "Supplier Manual",
        "",
        "01/01/2014",
        "PDF",
        "Oshkosh_Corporation_EDI_Manual_2_7_2014.pdf"
      ],
      [
        "Organizational Relationships",
        "816",
        "07/08/2015",
        "PDF",
        "OSK_X12_816_4010 PDF.pdf"
      ],
      [
        "Planning Schedule",
        "830",
        "07/15/2015",
        "PDF",
        "OSK_X12_830_4010 PDF.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "11/12/2015",
        "PDF",
        "OSK_X12_850_4010 PDF.pdf"
      ],
      [
        "Order Acknowledgment",
        "855",
        "11/13/2015",
        "PDF",
        "OSK_X12_855_4010 PDF.pdf"
      ],
      [
        "Ship Notice/Manifest",
        "856",
        "09/02/2015",
        "PDF",
        "OSK_X12_856_4010 PDF.pdf"
      ],
      [
        "Purchase Order Change Request-Buyer Initiated",
        "860",
        "11/13/2015",
        "PDF",
        "OSK_X12_865_4010 PDF.pdf"
      ],
      [
        "Shipping Schedule",
        "862",
        "08/19/2010",
        "PDF",
        "862_20100803.pdf"
      ],
      [
        "Purchase Order Change Acknowledgment/Request - Seller Initiated",
        "865",
        "09/03/2015",
        "PDF",
        "OSK_X12_865_4010 PDF.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Osman Sylvania",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Osram Sylvania (Home Lighting)",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Overwaitea Food Group",
    "missing": true
  },
  {
    "id": "owenscorning",
    "name": "Owens Corning",
    "ediDocs": [
      [
        "All Transactions",
        "",
        "08/07/2002",
        "PDF",
        "Owens_Corning_Supplier_Implementation_Guide.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "P&R Fasteners",
    "missing": true
  },
  {
    "id": "missing",
    "name": "P-K Tool",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Paccar Inc",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Pacific Fresh",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Pacific Sun",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Pacific Sunwear",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Packaging Concepts",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Packaging Corporation of America",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Page Break Warehouse",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Pamida",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Par 4 Plastics",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Paramount Apparel",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Paris Business Products",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Park Nameplate Co., Inc.",
    "missing": true
  },
  {
    "id": "parkohio",
    "name": "Park Ohio Assembly Components Group",
    "ediDocs": [
      [
        "Application Advice",
        "824",
        "02/08/2017",
        "PDF",
        "ACG_824_Application_Advice_02082017.pdf"
      ],
      [
        "Material Release",
        "830",
        "02/08/2017",
        "PDF",
        "ACG_830_Material_Release_02082017.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "02/08/2017",
        "PDF",
        "ACG_856_Advanced_Ship_Notice_02082017.pdf"
      ],
      [
        "Ship Schedule",
        "862",
        "02/08/2017",
        "PDF",
        "ACG_862_Ship_Schedule_02082017.pdf"
      ],
      [
        "Functional Acknowledgement",
        "997",
        "02/08/2017",
        "PDF",
        "ACG_997_Functional_Acknowledgment_02082017.pdf"
      ],
      [
        "Container Label Specifications",
        "",
        "March 2017",
        "PDF",
        "ACG Global Label Standard.pdf"
      ],
      [
        "Supplier Electronic Communications & Labeling Requirements",
        "",
        " March2017",
        "PDF",
        "ACG Supplier Electronic Communications and Labeling.pdf"
      ]
    ]
  },
  {
    "id": "parkerhannifin",
    "name": "Parker Hannifin Corp.",
    "imgFileName": "parkerhannifin.bmp",
    "ediDocs": [
      [
        "Invoice Transaction Set",
        "810 (3040)",
        "N/A",
        "PDF",
        "VEND_810_INB_3040_SPEC.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Parts for Trucks",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Party Packagers",
    "missing": true
  },
  {
    "id": "paulstra",
    "name": "Paulstra CRC Corporation",
    "ediDocs": [
      [
        "Planning Schedule",
        "830",
        "03/24/2010",
        "PDF",
        "EDI_specifications.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Peiker acustic, Inc.",
    "missing": true
  },
  {
    "id": "pepboys",
    "name": "Pep Boys",
    "ediDocs": [
      [
        "Invoice",
        "810 (4030)",
        "04/23/2008",
        "PDF",
        "http://info.pepboys.com/edi/PepBoys810_4030_v1_1FINAL.pdf"
      ],
      [
        "Purchase Order",
        "850 (4030)",
        "06/30/2008",
        "PDF",
        "http://info.pepboys.com/edi/PepBoys850_4030_v1_1FINAL.pdf"
      ],
      [
        "Purchase Order Acknowledgement",
        "855 (4030)",
        "04/01/2008",
        "PDF",
        "http://info.pepboys.com/edi/PepBoys855_4030_FINAL.pdf"
      ],
      [
        "Ship Notice",
        "856 (4030)",
        "10/20/2008",
        "PDF",
        "http://info.pepboys.com/edi/PepBoys856_4030_FINAL.pdf"
      ],
      [
        "Ship-to Codes",
        "N/A",
        "09/09/2010",
        "PDF",
        "http://info.pepboys.com/edi/EDI%20DC%20ship%20to%20codes%2009%2009%202010.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Pepro Enterprises Inc",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Petco",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Peterson American Company",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Peterson Spring",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Petosky Plastics",
    "missing": true
  },
  {
    "id": "missing",
    "name": "PHB Corporation",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Philips Home Furnishing",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Phillips - Metal Injection Mld",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Phillips Multi-Shot",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Phillips Plastics - Custom",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Phoenix Forge",
    "missing": true
  },
  {
    "id": "pierburg",
    "name": "Pierburg Inc.",
    "ediDocs": [
      [
        "Delivery Note (English)",
        "4913",
        "03/01/1996",
        "PDF",
        "VDA-4913_1996_EN.pdf"
      ],
      [
        "Delivery Note (German)",
        "4913",
        "03/01/1996",
        "PDF",
        "VDA-4913_1996_German.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Piggly Wiggly Carolina Company Inc.",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Pilkington Na",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Pioneer Automotive",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Piqua Technologies",
    "missing": true
  },
  {
    "id": "pistongroup",
    "name": "Piston Group",
    "ediDocs": [
      [
        "Application Advice",
        "824",
        "08/01/2012",
        "PDF",
        "T4M-824-4010-SPECS.pdf"
      ],
      [
        "Release",
        "830",
        "08/01/2012",
        "PDF",
        "T4M-830-4010-SPECS.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "08/01/2012",
        "PDF",
        "T4M-856-4010-SPECS.pdf"
      ],
      [
        "Shipping Schedule",
        "862",
        "08/01/2012",
        "PDF",
        "T4M-862-4010-SPECS.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Pittsburgh Plug & Products",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Plastech Engineered Products",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Plastic Components Inc.",
    "missing": true
  },
  {
    "id": "plasticomnium",
    "name": "Plastic Omnium",
    "ediDocs": [
      [
        "Delivery Forecast",
        "DELFOR",
        "11/07/2003",
        "PDF",
        "DELFOR D97A - Scoop PO Supplier Guide.pdf"
      ],
      [
        "Despatch Advice",
        "DESADV",
        "03/24/2020",
        "PDF",
        "DESADVD96AGuidelinesV4_PlasticOmnium.pdf"
      ],
      [
        "Barcode",
        "",
        "",
        "PDF",
        "GTLabelPOCES Guidelines.pdf"
      ],
      [
        "Americas"
      ],
      [
        "Despatch Advice",
        "DESADV",
        "09/12/2024",
        "PDF",
        "OPmobility Exterior - EDI_DESADV_D97A_Americas.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Plastic Products",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Plastic Solutions",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Plastomer Corporation",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Plaza Fleet Parts",
    "missing": true
  },
  {
    "id": "plex",
    "name": "Plex Systems",
    "imgFileName": "plex.bmp",
    "ediDocs": [
      [
        "4010 Versions"
      ],
      [
        "Planning Schedule (004010)",
        "830",
        "01/15/2019",
        "PDF",
        "Plex_830_v04010_20190115.pdf"
      ],
      [
        "Ship Notice/Manifest (004010)",
        "856",
        "01/29/2020",
        "PDF",
        "Plex_856_v04010_20200129.pdf"
      ],
      [
        "Shipping Schedule (004010)",
        "862",
        "10/30/2017",
        "PDF",
        "Plex_862_v04010_20171030.pdf"
      ],
      [
        "EDIFACT Versions"
      ],
      [
        "Delivery Forecast",
        "DELFOR",
        "10/05/2020",
        "PDF",
        "PLEX EDIFACT_DELFOR_96A_20201005.pdf"
      ],
      [
        "Despatch Advise Message",
        "DESADV",
        "02/03/2020",
        "PDF",
        "Plex 97A DESADV_20200203.pdf"
      ]
    ]
  },
  {
    "id": "polaris",
    "name": "Polaris",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "04/11/2002",
        "PDF",
        "POLARIS 810maprev2. (4).pdf"
      ],
      [
        "Release",
        "830",
        "",
        "XLS",
        "POLARIS 8304010 (2).xls"
      ],
      [
        "Purchase Order",
        "850",
        "",
        "XLS",
        "POLARIS 8504010 (2).xls"
      ],
      [
        "Ship Notice/Manifest",
        "856",
        "12/18/2002",
        "XLS",
        "POLARIS 856_4010 (1).xls"
      ],
      [
        "Purchse Order Change",
        "860",
        "",
        "XLS",
        "POLARIS 8604010 (2).xls"
      ],
      [
        "Shipping Schedule",
        "862",
        "",
        "XLS",
        "POLARIS 862_4010 (1).xls"
      ],
      [
        "Frequently Asked Questions",
        "",
        "",
        "PDF",
        "POLARIS ASNEDIFAQ (1).pdf"
      ],
      [
        "Pallet Label",
        "",
        "",
        "PDF",
        "POLARIS palletlabel.pdf"
      ]
    ]
  },
  {
    "id": "porsche",
    "name": "Porsche",
    "ediDocs": [
      [
        "EDI Guidelines",
        "",
        "09/02/2014",
        "PDF",
        "EDI-Guideline V4.2.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Port City Group",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Porter Groups LLC",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Power & Signal",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Power Packer Hydraulics",
    "missing": true
  },
  {
    "id": "missing",
    "name": "PPG Canada",
    "missing": true
  },
  {
    "id": "missing",
    "name": "PPL Corporation",
    "missing": true
  },
  {
    "id": "missing",
    "name": "PPL Electric Utilities",
    "missing": true
  },
  {
    "id": "precisionindustries",
    "name": "Precision Industries",
    "ediDocs": [
      [
        "Purchase Order",
        "850",
        "06/26/2009",
        "PDF",
        "out8504010.pdf"
      ],
      [
        "Purchase Order Acknowledgment",
        "855",
        "03/10/2010",
        "PDF",
        "inb855p21.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Precision Resource",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Precision Wire Forms",
    "missing": true
  },
  {
    "id": "missing",
    "name": "PrecisionForm, Inc.",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Precix",
    "missing": true
  },
  {
    "id": "prestolite",
    "name": "Prestolite",
    "imgFileName": "prestolite.png",
    "ediDocs": [
      [
        "Planning Schedule",
        "830",
        "11/21/2012",
        "PDF",
        "PWC830.pdf"
      ],
      [
        "Advance Ship Notice",
        "856",
        "11/21/2012",
        "PDF",
        "PWC856.pdf"
      ]
    ]
  },
  {
    "id": "PriceChopper",
    "name": "Price Chopper",
    "ediDocs": [
      [
        "Grocery Products Purchase Order",
        "875",
        "10/02/2008)",
        "PDF",
        "Price Chopper_Golub_875_Specifications.pdf.pdf"
      ],
      [
        "Grocery Products Invoice",
        "880",
        "08/09/2011",
        "PDF",
        "Price Chopper_Golub_880_Specifications.pdf.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Pridgeon & Clay",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Primary One",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Prince Metal Stampings USA Inc",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Princess Auto",
    "missing": true
  },
  {
    "id": "progressenergy",
    "name": "Progress Energy",
    "ediDocs": [
      [
        "Purchase Order",
        "850",
        "09/18/2006",
        "PDF",
        "Progress_Energy-850-004010.pdf"
      ],
      [
        "Purchase Order Change Request",
        "860",
        "09/18/2006",
        "PDF",
        "Progress_Energy-860-004010.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Progressive Stamping",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Promax Engineering",
    "missing": true
  },
  {
    "id": "psa",
    "name": "PSA PEUGEOT CITROEN",
    "ediDocs": [
      [
        "Delivery Schedule",
        "DELFOR",
        "",
        "PDF",
        "GLOBAL DELFOR Mapping - English.pdf"
      ],
      [
        "Delivery Just In Time",
        "DELJIT",
        "",
        "PDF",
        "GLOBAL DELJIT Mapping - English.pdf"
      ],
      [
        "Despatch Advice",
        "DESADV",
        "",
        "PDF",
        "DESADV Mapping - AVIEXP profile - English.pdf"
      ],
      [
        "DESADV Errors",
        "",
        "",
        "PDF",
        "DESADV - Typical errors.pdf"
      ],
      [
        "ET19 and ET19-1 Mapping",
        "",
        "",
        "PDF",
        "ETI9 Labels mappings end specs - English.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "PTI Engineered Plastics Inc.",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Pullman Industries Inc",
    "missing": true
  },
  {
    "id": "PyeongHwa",
    "name": "PyeongHwa Automotive USA",
    "ediDocs": [
      [
        "Release/Planning Schedule",
        "830",
        "08/07/2018",
        "PDF",
        "PyeongHwa Automotive USA_830_1.0.pdf"
      ],
      [
        "Supplier Letter",
        "",
        "08/07/2018",
        "PDF",
        "PHAUSA_Supplier Survey.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "QSS",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Quality Spring TOGO",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Quality Synthetic Rubber Inc",
    "missing": true
  },
  {
    "id": "qualtech",
    "name": "Qualtech Seating Systems",
    "ediDocs": [
      [
        "Application Advice",
        "824",
        "11/25/2003",
        "PDF",
        "824Ver4010.pdf"
      ],
      [
        "Planning Schedule",
        "830",
        "11/25/2003",
        "PDF",
        "830Ver4010.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "11/25/2003",
        "PDF",
        "850Ver4010.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "11/25/2003",
        "PDF",
        "856Ver4010.pdf"
      ],
      [
        "Shipping Schedule",
        "862",
        "11/25/2003",
        "PDF",
        "862Ver4010.pdf"
      ],
      [
        "Text Message",
        "864",
        "11/25/2003",
        "PDF",
        "864Ver4010.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Quarles Supply",
    "missing": true
  },
  {
    "id": "questdiagnostics",
    "name": "Quest Diagnostics Inc",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "08/22/2000",
        "PDF",
        "8104010.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "08/22/2000",
        "PDF",
        "8504010.pdf"
      ],
      [
        "Purchase Order Acknowledgement",
        "855",
        "01/01/2003",
        "PDF",
        "8554010.pdf"
      ],
      [
        "Purchase Order Acknowledgement Data Requirements ",
        "N/A",
        "05/12/2008",
        "PDF",
        "DATAREQ_855_poa.pdf"
      ],
      [
        "ISA and GS Requirements",
        "N/A",
        "05/12/2008",
        "PDF",
        "Quest_ISA _EDIspec.pdf"
      ],
      [
        "Site Codes and Address Information",
        "N/A",
        "05/12/2008",
        "XLS",
        "Site_codes_all.xls"
      ],
      [
        "Testing Scenarios",
        "N/A",
        "05/12/2008",
        "PDF",
        "Testing_scenarios.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "R.R. Donnelley",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Radio Shack",
    "missing": true
  },
  {
    "id": "raufoss",
    "name": "Raufoss",
    "ediDocs": [
      [
        "Delivery Schedule",
        "DELFOR",
        "06/02/2017",
        "PDF",
        "DELFOR_D97A.pdf"
      ],
      [
        "Ship Notice",
        "DESADV",
        "12/23/2015",
        "PDF",
        "DESADV_D97A.pdf"
      ],
      [
        "Additional Information",
        "N/A",
        "12/23/2015",
        "PDF",
        "ASN and supplier label additional information.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Rayloc",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Raymour & Flanigan",
    "missing": true
  },
  {
    "id": "recaro",
    "name": "Recaro",
    "ediDocs": [
      [
        "ANSI ASC X12 (2040)"
      ],
      [
        "Material Release",
        "830",
        "07/26/2013",
        "PDF",
        "x830_RECARO_Automotive.pdf"
      ],
      [
        "Advance Ship Notice",
        "856",
        "07/26/2013",
        "PDF",
        "X856_RECARO_Automotive.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Redi-to-Wear",
    "missing": true
  },
  {
    "id": "missing",
    "name": "REECE GROUP",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Renosol",
    "missing": true
  },
  {
    "id": "RepublicServices",
    "name": "Republic Services",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "03/18/2014",
        "PDF",
        "en_810-Invoice.pdf"
      ]
    ]
  },
  {
    "id": "renault",
    "name": "Renault",
    "ediDocs": [
      [
        "Delivery Schedule (Firm and Forecast)",
        "DELFOR",
        "July 2007",
        "PDF",
        "delford96a-mixt2-entites_en_tcm1098-428614.pdf"
      ],
      [
        "Delivery Schedule (Forecast)",
        "DELFOR",
        "July 2007",
        "PDF",
        "delford96a-prev-entites_en_tcm1098-428615.pdf"
      ],
      [
        "Delivery Just In Time",
        "DELJIT",
        "July 2007",
        "PDF",
        "deljitd98b-entites_en_tcm1098-428617.pdf"
      ],
      [
        "Despatch Advice",
        "DESADV",
        "July 2007",
        "PDF",
        "desadvd96a-entites_en_tcm1098-428624.pdf"
      ]
    ]
  },
  {
    "id": "rescoproducts",
    "name": "Resco Products",
    "ediDocs": [
      [
        "Purchase Order",
        "850",
        "09/07/2017",
        "PDF",
        "P21_850S_Supplier_4010.pdf"
      ],
      [
        "Purchase Order Acknowledgement",
        "855",
        "09/07/2017",
        "PDF",
        "P21_855R_Supplier_4010.pdf"
      ],
      [
        "Invoice",
        "810",
        "09/07/2017",
        "PDF",
        "P21_810R_Supplier_4010.pdf"
      ],
      [
        "Advance Shipment Notice",
        "856",
        "09/07/2017",
        "PDF",
        "P21_856R_Supplier_4010.pdf"
      ]
    ]
  },
  {
    "id": "ReverePlastic",
    "name": "Revere Plastics Systems",
    "ediDocs": [
      [
        "Material Release",
        "830",
        "01/22/2025",
        "PDF",
        "Vendor_830_Specifications_v4010.pdf"
      ],
      [
        "Advance Shipment Notice",
        "856",
        "01/22/2025",
        "PDF",
        "Vendor_856_Specifications_v04010.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Ring Screw",
    "missing": true
  },
  {
    "id": "riteaid",
    "name": "Rite Aid Corporation",
    "ediDocs": [
      [
        "Rite Aid"
      ],
      [
        "Ship Status",
        "214",
        "07/01/2007",
        "PDF",
        "http://www.riteaidediservices.com/B2B/4010214.pdf"
      ],
      [
        "Invoice - Distribution Center",
        "810",
        "05/14/2009",
        "PDF",
        "http://www.riteaidediservices.com/B2B/4010810_DC.pdf"
      ],
      [
        "Invoice - Direct Store Delivery",
        "810",
        "03/01/2008",
        "PDF",
        "http://www.riteaidediservices.com/B2B/4010810_DSD.pdf"
      ],
      [
        "Payment Order/ Remittance Advice",
        "820",
        "11/16/1998",
        "PDF",
        "http://www.riteaidediservices.com/B2B/4010820.pdf"
      ],
      [
        "Planning Schedule With Release Capability",
        "830",
        "05/04/2007",
        "PDF",
        "http://www.riteaidediservices.com/B2B/4010830.pdf"
      ],
      [
        "Price/Sales Catalog",
        "832",
        "02/01/2008",
        "PDF",
        "http://www.riteaidediservices.com/B2B/4010832.pdf"
      ],
      [
        "Purchase Order - Distribution Center",
        "850",
        "05/13/2009",
        "PDF",
        "http://www.riteaidediservices.com/B2B/4010850_DC.pdf"
      ],
      [
        "Purchase Order - Direct Store Delivery",
        "850",
        "04/20/1999",
        "PDF",
        "http://www.riteaidediservices.com/B2B/4010850_DSD.pdf"
      ],
      [
        "Product Activity Data",
        "852",
        "05/10/2007",
        "PDF",
        "http://www.riteaidediservices.com/B2B/4010852.pdf"
      ],
      [
        "Advance Shipment Notice",
        "856",
        "05/14/2009",
        "PDF",
        "http://www.riteaidediservices.com/B2B/4010856_DC.pdf"
      ],
      [
        "Functional Acknowledgement",
        "997",
        "04/24/2008",
        "PDF",
        "http://www.riteaidediservices.com/B2B/4010997.pdf"
      ]
    ]
  },
  {
    "id": "Rivian",
    "name": "Rivian",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "10/21/2020",
        "PDF",
        "Rivian-EDI-810.pdf"
      ],
      [
        "Planning Schedule With Release Capability",
        "830",
        "09/15/2020",
        "PDF",
        "Rivian-EDI-830.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "05/14/2020",
        "PDF",
        "Rivian-EDI-850.pdf"
      ],
      [
        "Purchase Order Acknowledgement",
        "855",
        "10/21/2020",
        "PDF",
        "Rivian-EDI-855.pdf"
      ],
      [
        "Advance Shipment Notice",
        "856",
        "04/08/2022",
        "PDF",
        "Rivian_EDI_856_2022.pdf"
      ],
      [
        "Purchase Order Change Request",
        "860",
        "10/16/2020",
        "PDF",
        "Rivian-EDI-860.pdf"
      ],
      [
        "Shipping Schedule",
        "862",
        "01/04/2021",
        "PDF",
        "Rivian-EDI-862.pdf"
      ],
      [
        "Onboarding Form",
        "",
        "",
        "PDF",
        "Rivian-TPEDIOnboardingForm.pdf"
      ]
    ]
  },
  {
    "id": "rjreynolds",
    "name": "RJ Reynolds",
    "imgFileName": "rjreynolds.gif",
    "ediDocs": [
      [
        "All",
        "N/A",
        "N/A",
        "Website",
        "http://rjrtedi.com/"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Robin Ind",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Robinsons (MAY DEPT STORES)",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Rochester Gear, Inc.",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Rockford Spring Company",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Rockwell International",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Rohm Corporation",
    "missing": true
  },
  {
    "id": "rona",
    "name": "Rona",
    "ediDocs": [
      [
        "Implementation Guide",
        "810 and 850",
        "01/12/2010",
        "PDF",
        "Rona_EDI_Implementation_Guide_2010-01-12.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "RPM/Pronto Buying Group",
    "missing": true
  },
  {
    "id": "rps",
    "name": "RPS",
    "ediDocs": [
      [
        "All Trasactions",
        "All",
        "08/14/2000",
        "PDF",
        "RPS_EDI_Specs.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "RR Spring",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Rubber Industries",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Ruckers Candy Company",
    "missing": true
  },
  {
    "id": "rxo",
    "name": "RXO",
    "imgFileName": "rxo.png",
    "ediDocs": [
      [
        "Load Tender Response",
        "990",
        "03/27/2024",
        "PDF",
        "RXO-Carrier 990v4010v3_2024.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Ryder Logistics",
    "missing": true
  },
  {
    "id": "missing",
    "name": "S & A Industries, Corporation",
    "missing": true
  },
  {
    "id": "saautomotive",
    "name": "SA Automotive",
    "customMessage": true,
    "ediDocs": [
      [
        "Release",
        "830",
        "04/23/2013",
        "PDF",
        "Sgroup_830 Planning Forecast_v4010.pdf"
      ],
      [
        "Advanced Ship Notice",
        "856",
        "06/11/2013",
        "PDF",
        "SGroup_856 Advanced Ship Notice_v4010.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "S.S.I.",
    "missing": true
  },
  {
    "id": "saab",
    "name": "Saab",
    "ediDocs": [
      [
        "MGO"
      ],
      [
        "Delivery Schedule",
        "DELFOR",
        "07/18/2000",
        "PDF",
        "MGO_SAAB_NA_DELFOR.pdf"
      ],
      [
        "Despatch Advice",
        "DESADV",
        "05/09/2000",
        "PDF",
        "MGO_SAAB_NA_DESADV.pdf"
      ],
      [
        "SPO"
      ],
      [
        "Delivery Schedule",
        "DELFOR",
        "04/01/2005",
        "PDF",
        "SPO_SAAB_NA_DELFOR_APRIL_2005.pdf"
      ],
      [
        "Application Error and Ack",
        "APERAK",
        "10/29/1998",
        "PDF",
        "SPO_SAAB_NA_APERAK_APRIL_2005.pdf"
      ],
      [
        "Despatch Advice",
        "DESADV",
        "04/01/2005",
        "PDF",
        "SPO_SAAB_NA_DESADV_APRIL_2005.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Safetynet",
    "missing": true
  },
  {
    "id": "safeway",
    "name": "Safeway",
    "imgFileName": "safeway.bmp",
    "ediDocs": [
      [
        "VICS Specifications"
      ],
      [
        "Application Advice (824)",
        "4010",
        "03/11/2004",
        "PDF",
        "http://suppliers.safeway.com/usa/pdf/824VICS004010.pdf"
      ],
      [
        "Application Advice (824)",
        "4030",
        "03/11/2004",
        "PDF",
        "http://suppliers.safeway.com/usa/pdf/824VICS004030.pdf"
      ],
      [
        "Invoice (810)",
        "4010",
        "10/01/2008",
        "PDF",
        "http://suppliers.safeway.com/usa/pdf/pdf_us/VICS_810_004010_US.pdf"
      ],
      [
        "Invoice (810)",
        "4030",
        "10/01/2008",
        "PDF",
        "http://suppliers.safeway.com/usa/pdf/pdf_us/VICS_810_004030_US.pdf"
      ],
      [
        "Payment Order/Remittance Advice Whse (820)",
        "4010",
        "05/09/2009",
        "PDF",
        "http://suppliers.safeway.com/usa/pdf/VICS_820_004010.pdf"
      ],
      [
        "Payment Order/Remittance Advice Whse (820)",
        "4030",
        "05/09/2009",
        "PDF",
        "http://suppliers.safeway.com/usa/pdf/VICS_820_004030.pdf"
      ],
      [
        "Payment Order/Remittance Advice DSD (820)",
        "4010",
        "06/17/2009",
        "PDF",
        "http://suppliers.safeway.com/usa/pdf/VICS_820_004010_DSD.pdf"
      ],
      [
        "Payment Order/Remittance Advice DSD (820)",
        "4030",
        "06/17/2009",
        "PDF",
        "http://suppliers.safeway.com/usa/pdf/VICS_820_004030_DSD.pdf"
      ],
      [
        "Product Activity SBT (852)",
        "4010",
        "01/05/2009",
        "PDF",
        "http://suppliers.safeway.com/usa/pdf/VICS_852_SBT_004010.pdf"
      ],
      [
        "Purchase Order (850)",
        "4010",
        "04/16/2007",
        "PDF",
        "http://suppliers.safeway.com/usa/pdf/VICS_850_004010.pdf"
      ],
      [
        "Purchase Order (850)",
        "4030",
        "04/16/2007",
        "PDF",
        "http://suppliers.safeway.com/usa/pdf/VICS_850_004030.pdf"
      ],
      [
        "ANSI x.12 Specifications"
      ],
      [
        "Application Advice (824)",
        "4010",
        "03/11/2004",
        "PDF",
        "http://suppliers.safeway.com/usa/pdf/824%20X12%20004010.pdf"
      ],
      [
        "Application Advice (824)",
        "4030",
        "03/11/2004",
        "PDF",
        "http://suppliers.safeway.com/usa/pdf/824%20X12%20004030.pdf"
      ],
      [
        "Application Control Totals (831)",
        "4010",
        "09/28/2004",
        "PDF",
        "http://suppliers.safeway.com/usa/pdf/X12_831_004010.pdf"
      ],
      [
        "Invoice (810)",
        "4010",
        "03/22/2012",
        "PDF",
        "http://suppliers.safeway.com/usa/pdf/pdf_us/X12_810_004010_US.pdf"
      ],
      [
        "Invoice (810)",
        "4030",
        "01/11/2010",
        "PDF",
        "http://suppliers.safeway.com/usa/pdf/pdf_us/X12_810_004030_US.pdf"
      ],
      [
        "Payment Order/Remittance Advice Whse (820)",
        "4010",
        "05/09/2009",
        "PDF",
        "http://suppliers.safeway.com/usa/pdf/X12_820_004010.pdf"
      ],
      [
        "Payment Order/Remittance Advice Whse (820)",
        "4030",
        "05/09/2009",
        "PDF",
        "http://suppliers.safeway.com/usa/pdf/X12_820_004030.pdf"
      ],
      [
        "Payment Order/Remittance Advice DSD (820)",
        "4010",
        "06/17/2009",
        "PDF",
        "http://suppliers.safeway.com/usa/pdf/X12_820_004010_DSD.pdf"
      ],
      [
        "Payment Order/Remittance Advice DSD (820)",
        "4030",
        "06/17/2009",
        "PDF",
        "http://suppliers.safeway.com/usa/pdf/X12_820_004030_DSD.pdf"
      ],
      [
        "Product Activity SBT (852)",
        "4010",
        "06/08/2012",
        "PDF",
        "http://suppliers.safeway.com/usa/pdf/X12_852_SBT_004010.pdf"
      ],
      [
        "Product Activity SBT (852)",
        "4030",
        "01/05/2009",
        "PDF",
        "http://suppliers.safeway.com/usa/pdf/X12_852_SBT_004030.pdf"
      ],
      [
        "Purchase Order (850)",
        "4010",
        "04/16/2007",
        "PDF",
        "http://suppliers.safeway.com/usa/pdf/X12_850_004010.pdf"
      ],
      [
        "Purchase Order (850)",
        "4030",
        "04/16/2007",
        "PDF",
        "http://suppliers.safeway.com/usa/pdf/X12_850_004030.pdf"
      ],
      [
        "UCS Specifications"
      ],
      [
        "Application Advice (824)",
        "4010",
        "03/11/2004",
        "PDF",
        "http://suppliers.safeway.com/usa/pdf/824UCS004010.pdf"
      ],
      [
        "Application Advice (824)",
        "4010",
        "03/11/2004",
        "PDF",
        "http://suppliers.safeway.com/usa/pdf/824_UCS_004030.pdf"
      ],
      [
        "DSD Delivery Record - NEX (894)",
        "4010",
        "03/20/2009",
        "PDF",
        "http://suppliers.safeway.com/usa/pdf/824UCS004010.pdf"
      ],
      [
        "DSD Delivery Record - DEX (894)",
        "4010",
        "08/17/2007",
        "PDF",
        "http://suppliers.safeway.com/usa/pdf/UCS_894dex_004010.pdf"
      ],
      [
        "DSD Delivery Record - NEX (895)",
        "4010",
        "04/13/2009",
        "PDF",
        "http://suppliers.safeway.com/usa/pdf/UCS_NEX_895_004010.pdf"
      ],
      [
        "DSD Delivery Record - DEX (895)",
        "4010",
        "08/17/2007",
        "PDF",
        "http://suppliers.safeway.com/usa/pdf/UCS_895dex_004010.pdf"
      ],
      [
        "Functional Acknowledgment (997)",
        "4010",
        "09/28/2004",
        "PDF",
        "http://suppliers.safeway.com/usa/pdf/UCS_997_004010.pdf"
      ],
      [
        "Invoice (880)",
        "4010",
        "01/11/2010",
        "PDF",
        "http://suppliers.safeway.com/usa/pdf/UCS_880_004010_US.pdf"
      ],
      [
        "Invoice (880)",
        "4030",
        "01/11/2010",
        "PDF",
        "http://suppliers.safeway.com/usa/pdf/UCS_880_004030_US.pdf"
      ],
      [
        "Payment Order/Remittance Advice Whse (820)",
        "4010",
        "05/09/2009",
        "PDF",
        "http://suppliers.safeway.com/usa/pdf/UCS_820_004010.pdf"
      ],
      [
        "Payment Order/Remittance Advice Whse (820)",
        "4030",
        "05/09/2009",
        "PDF",
        "http://suppliers.safeway.com/usa/pdf/UCS_820_004030.pdf"
      ],
      [
        "Payment Order/Remittance Advice DSD (820)",
        "4010",
        "06/01/2016",
        "PDF",
        "http://suppliers.safeway.com/usa/pdf/UCS_820_004010_DSD.pdf"
      ],
      [
        "Payment Order/Remittance Advice DSD (820)",
        "4030",
        "06/17/2009",
        "PDF",
        "http://suppliers.safeway.com/usa/pdf/824UCS004010.pdf"
      ],
      [
        "Planning and Forecast (830)",
        "4010",
        "08/26/2004",
        "PDF",
        "http://suppliers.safeway.com/usa/pdf/UCS_830_004010.pdf"
      ],
      [
        "Product Activity CRP (852)",
        "4010",
        "01/04/2008",
        "PDF",
        "http://suppliers.safeway.com/usa/pdf/UCS852CRP004010.pdf"
      ],
      [
        "Product Activity CRP (852)",
        "4030",
        "01/04/2008",
        "PDF",
        "http://suppliers.safeway.com/usa/pdf/UCS852CRP004030.pdf"
      ],
      [
        "Product Activity SBT (852)",
        "4010",
        "01/05/2009",
        "PDF",
        "http://suppliers.safeway.com/usa/pdf/UCS_852_SBT_004010.pdf"
      ],
      [
        "Product Activity SBT (852)",
        "4030",
        "01/05/2009",
        "PDF",
        "http://suppliers.safeway.com/usa/pdf/UCS_852_SBT_004030.pdf"
      ],
      [
        "Purchase Order Ack CRP (855)",
        "4010",
        "08/01/2007",
        "PDF",
        "http://suppliers.safeway.com/usa/pdf/UCS855CRP004010.pdf"
      ],
      [
        "Purchase Order Ack CRP (855)",
        "4030",
        "08/01/2007",
        "PDF",
        "http://suppliers.safeway.com/usa/pdf/UCS855CRP004030.pdf"
      ],
      [
        "Purchase Order (875)",
        "4010",
        "04/7/2004",
        "PDF",
        "http://suppliers.safeway.com/usa/pdf/UCS875004010.pdf"
      ],
      [
        "Purchase Order (875)",
        "4030",
        "04/7/2004",
        "PDF",
        "http://suppliers.safeway.com/usa/pdf/UCS875004030.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Saia Motor Freight, Inc.",
    "missing": true
  },
  {
    "id": "saicusa",
    "name": "SAIC USA",
    "ediDocs": [
      [
        "Release",
        "DELFOR",
        "02/04/2004",
        "PDF",
        "Vendor_EDIFACT_DELFOR_Specs_02-04-04_Release.pdf"
      ],
      [
        "Ship Notice",
        "DESADV",
        "04/08/2009",
        "PDF",
        "Vendor-EDIFACT-DESADV-Specs-20090408.pdf"
      ],
      [
        "Barcode Specifications",
        "N/A",
        "06/24/2004",
        "DOC",
        "EDI_Survey_for_SACI_supplier.doc"
      ]
    ]
  },
  {
    "id": "sallybeauty",
    "name": "Sally Beauty Holdings",
    "ediDocs": [
      [
        "Purchase Order",
        "850",
        "06/27/2023",
        "PDF",
        "Sally Beauty Holdings, Inc 850 Purchase Order v5010.pdf"
      ],
      [
        "Purchase Order Change Request",
        "860",
        "08/17/2023",
        "PDF",
        "Sally Beauty Holdings, Inc 860 Purchase Order Change v5010.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "06/27/2023",
        "PDF",
        "Sally Beauty Holdings, Inc 856 ASN v5010.pdf"
      ],
      [
        "Invoice",
        "810",
        "06/27/2023",
        "PDF",
        "Sally Beauty Holdings, Inc 810 Invoice v5010.pdf"
      ],
      [
        "Barcode Specifications",
        "N/A",
        "06/27/2023",
        "XLSX",
        "Sally Beauty Holdings, Inc GS1-128_ShippingLabel.xlsx"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Samuel, Son & Co.",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Sanlo, Inc.",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Sanmina SCI",
    "missing": true
  },
  {
    "id": "saturn",
    "name": "Saturn",
    "ediDocs": [
      [
        "Delivery Schedule",
        "DELFOR",
        "03/16/1999",
        "PDF",
        "Saturn_delfor_97a.pdf"
      ],
      [
        "Delivery Just In Time",
        "DELJIT",
        "03/16/199",
        "PDF",
        "Saturn_deljit_97a.pdf"
      ],
      [
        "Despatch Advice",
        "DESADV",
        "07/01/1998",
        "PDF",
        "Saturn_DESADV_Guidelines_FINAL.pdf"
      ],
      [
        "Genral",
        "GENRAL",
        "03/16/1999",
        "PDF",
        "Saturn_genral_97a.pdf"
      ],
      [
        "Interchange Control",
        "",
        "03/16/1999",
        "PDF",
        "Saturn_INTCHG.pdf"
      ],
      [
        "B-10 Label",
        "",
        "03/16/1999",
        "PDF",
        "B-10_Introduction.pdf"
      ]
    ]
  },
  {
    "id": "savemart",
    "name": "Save Mart",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "05/22/2014",
        "PDF",
        "Save_Mart_810_Specifications.pdf.pdf"
      ],
      [
        "Payment Order/Remittance Advice",
        "820",
        "02/21/2014",
        "PDF",
        "Save_Mart_820_Specifications.pdf.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "05/22/2014",
        "PDF",
        "Save_Mart_850_Specifications.pdf.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "SBC Global/Border",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Schaeffler Group USA",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Schenker Logistics",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Schurka",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Sealing Devices Inc.",
    "missing": true
  },
  {
    "id": "sears",
    "name": "Sears",
    "ediDocs": [
      [
        "Purchase Order",
        "850",
        "August 2010",
        "PDF",
        "SEARS BOSS 850.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "September 2010",
        "PDF",
        "SEARS BOSS 856.pdf"
      ],
      [
        "Purchase Order Change Request",
        "860",
        "July 2014",
        "PDF",
        "SEARS BOSS 860.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Seaway Bolts",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Security Plastics Inc",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Select",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Sepco",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Seymour Tubing",
    "missing": true
  },
  {
    "id": "shape",
    "name": "Shape",
    "ediDocs": [
      [
        "Release",
        "830",
        "11/18/2009",
        "PDF",
        "Plex_830_v04010_Fillable.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "11/08/2013",
        "PDF",
        "Plex_856_v4010_20131108_Fillable.pdf"
      ],
      [
        "Labeling Guideliness",
        "",
        "08/13/2014",
        "PDF",
        "Supplier_EDI__Labeling_Guidelines_v1.8.pdf"
      ]
    ]
  },
  {
    "id": "sherwinwilliams",
    "name": "Sherwin-Williams Stores",
    "imgFileName": "sherwinwilliams.gif",
    "ediDocs": [
      [
        "Napa Balkamp"
      ],
      [
        "Invoice",
        "810",
        "07/30/2009",
        "DOC",
        "https://www.sherprocure.com/SuppColl/FileServlet?fileName=810.doc"
      ],
      [
        "Application Advice",
        "824",
        "07/30/2009",
        "XLS",
        "https://www.sherprocure.com/SuppColl/FileServlet?fileName=824.xls"
      ],
      [
        "Purchase Order",
        "850",
        "07/30/2009",
        "XLS",
        "https://www.sherprocure.com/SuppColl/FileServlet?fileName=850.xls"
      ],
      [
        "Purchase Order Confirmation",
        "855",
        "07/30/2009",
        "XLS",
        "https://www.sherprocure.com/SuppColl/FileServlet?fileName=855.xls"
      ],
      [
        "Ship Notice/Manifest",
        "856",
        "07/30/2009",
        "XLS",
        "https://www.sherprocure.com/SuppColl/FileServlet?fileName=856.xls"
      ],
      [
        "Purchase Order Change",
        "860",
        "07/30/2009",
        "XLS",
        "https://www.sherprocure.com/SuppColl/FileServlet?fileName=860.xls"
      ],
      [
        "Purchase Order Change Confirmation",
        "865",
        "07/30/2009",
        "XLS",
        "https://www.sherprocure.com/SuppColl/FileServlet?fileName=865.xls"
      ],
      [
        "Location Codes",
        "N/A",
        "12/23/2003",
        "XLS",
        "https://www.sherprocure.com/SuppColl/FileServlet?fileName=PlantCodes.xls"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Shiloh Automotive",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Shopko",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Shoppers Drug Mart",
    "missing": true
  },
  {
    "id": "missing",
    "name": "SIA",
    "missing": true
  },
  {
    "id": "siegalrobert",
    "name": "Siegel-Robert, Inc",
    "ediDocs": [
      [
        "Release",
        "830",
        "05/07/2008",
        "PDF",
        "Siegel-Robert_Planning_Schedule_830_Specifications.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "05/07/2008",
        "PDF",
        "Siegel-Robert_ASN_Specifications.pdf"
      ]
    ]
  },
  {
    "id": "siemens",
    "name": "Siemens",
    "ediDocs": [
      [
        "VDO"
      ],
      [
        "Release",
        "830",
        "10/19/2006",
        "PDF",
        "Siemens_VDO_Automotive_830_3040.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "01/31/2007",
        "PDF",
        "Siemens_VDO_Automotive_856_4010.pdf"
      ],
      [
        "Functional Acknowledgement",
        "997",
        "08/16/2006",
        "PDF",
        "Siemens_VDO_Automotive_997_4010.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Sintering Technologies",
    "missing": true
  },
  {
    "id": "missing",
    "name": "SKF Sealing Solutions",
    "missing": true
  },
  {
    "id": "missing",
    "name": "SKF USA Inc.",
    "missing": true
  },
  {
    "id": "sleepys",
    "name": "Sleepys",
    "ediDocs": [
      [
        "All Transactions",
        "All",
        "03/20/2013",
        "PDF",
        "SLEEPYS EDI IMPLEMENTATION GUIDE.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Slidematic Products",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Small Tube Products",
    "missing": true
  },
  {
    "id": "smart",
    "name": "Smart & Final Stores",
    "ediDocs": [
      [
        "Grocery Products Purchase Order",
        "875",
        "06/30/2015",
        "PDF",
        "Smart_Final_Whse_875_4030_06_30_2015.docx.pdf"
      ],
      [
        "Grocery Products Invoice",
        "880",
        "",
        "PDF",
        "SMART_and_FINAL_880_GUIDELINES.doc.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "SMC Powder Metallurgy",
    "missing": true
  },
  {
    "id": "missing",
    "name": "SOBEYS CANADA",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Sobeys Quebec",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Sofanou Inc.",
    "missing": true
  },
  {
    "id": "sogefi",
    "name": "Sogefi",
    "imgFileName": "sogefi.png",
    "ediDocs": [
      [
        "830",
        "Release",
        "04/04/2017",
        "PDF",
        "Sogefi_830_v1.2.pdf"
      ],
      [
        "856",
        "Ship Notice",
        "06/02/2015",
        "PDF",
        "Sogefi_856_v1.1_New.pdf"
      ]
    ]
  },
  {
    "id": "solectron",
    "name": "Solectron",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "08/17/2006",
        "PDF",
        "P2P_810_Inbound_4010.pdf"
      ],
      [
        "Application Advice",
        "824",
        "08/17/2006",
        "PDF",
        "P2P_824_Outbound_4010.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "08/17/2006",
        "PDF",
        "P2P_850_Outbound_4010.pdf"
      ],
      [
        "Purchase Order Change Request",
        "860",
        "08/17/2006",
        "PDF",
        "P2P_860_Outbound_4010.pdf"
      ],
      [
        "Functional Acknowledgement",
        "997",
        "08/16/2006",
        "PDF",
        "P2P_997_4010.pdf"
      ],
      [
        "Welcome",
        "",
        "09/01/2006",
        "PDF",
        "Solectron_Welcome_Supplier_Package.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "SOLVAY",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Sonopress USA",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Southern Warehouse",
    "missing": true
  },
  {
    "id": "spaninternational",
    "name": "Span Ltd.",
    "ediDocs": [
      [
        "All Transactions",
        "830 and 856",
        "02/15/2008",
        "XLS",
        "Span_International_EDI_Specs_ver3.5.xls"
      ]
    ]
  },
  {
    "id": "spartanlmp",
    "name": "Spartan Light Metal Products, Inc.",
    "ediDocs": [
      [
        "Release",
        "830",
        "02/27/2007",
        "PDF",
        "Spartan_Light_Metal_830_Documentation.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Spears Manufacturing Co.",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Specialty Screw",
    "missing": true
  },
  {
    "id": "spectrapremium",
    "name": "Spectra Premium Industries",
    "ediDocs": [
      [
        "Inbound Advance Shipment Notice (4010)",
        "856",
        "2/10/2011",
        "PDF",
        "856_004010_Inbound.pdf"
      ],
      [
        "Outbound Material Release (4010)",
        "830",
        "2/10/2011",
        "PDF",
        "830_004010_Outbound.pdf"
      ],
      [
        "EDI Information",
        "N/A",
        "N/A",
        "PDF",
        "SpectraPremium_Industries_Inc_EDI_Information.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "SPI, LLC",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Spring Design and Mfg.",
    "missing": true
  },
  {
    "id": "spxcorp",
    "name": "SPX Corp",
    "imgFileName": "spxcorp.bmp",
    "ediDocs": [
      [
        "SPX Corporation"
      ],
      [
        "EDI Trading Partner Questionnaire",
        "NA",
        "NA",
        "DOC",
        "SPX EDI Trading Partner Questionnaire.doc"
      ],
      [
        "Invoice Specifications (4010)",
        "810",
        "02/26/2003",
        "PDF",
        "EDI_Invoice_Specs.pdf"
      ],
      [
        "Purchase Order (4010)",
        "850",
        "02/26/2003",
        "PDF",
        "EDI_Order_Specs.pdf"
      ],
      [
        "SPX Filtran"
      ],
      [
        "Implementation Guide",
        "830, 856 & 862",
        "10/14/2009",
        "PDF",
        "EDI_Implementation_Guide_Second_Edition_V3-4.pdf"
      ],
      [
        "Implementation Guide Changes",
        "830, 856 & 862",
        "10/14/2009",
        "PDF",
        "EDI_Implementation_Guide_Second_Edition_V3-4_Changes.pdf"
      ]
    ]
  },
  {
    "id": "SportsAuthority",
    "name": "Sports Authority",
    "imgFileName": "sportsauthority.jpg",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "04/14/2009",
        "PDF",
        "New TSA 810-4010.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "04/14/2009",
        "PDF",
        "New TSA 850-4010.pdf"
      ],
      [
        "Advance Ship Notice",
        "856",
        "04/14/2009",
        "PDF",
        "TSA 856-4010VICS-062408.pdf"
      ],
      [
        "Purchase Order Change Request",
        "860",
        "11/12/2004",
        "PDF",
        "New TSA 860-4010.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "St Clair Plastics Co",
    "missing": true
  },
  {
    "id": "stackpole",
    "name": "Stackpole Limited",
    "imgFileName": "stackpole.bmp",
    "ediDocs": [
      [
        "Delivery Schedule Message(D.97A)",
        "DELFOR",
        "01/16/2014",
        "PDF",
        "VendDELFOR_V4.pdf"
      ],
      [
        "Dispatch Advice(D.97A)",
        "DESADV",
        "01/31/2014",
        "PDF",
        "VendDESADV_V4.pdf"
      ],
      [
        "Receiving Advice(D.97A)",
        "RECADV",
        "04/08/2011",
        "PDF",
        "VendRECADV.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Stage Stores",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Stahlschmidt Limited",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Stanco Products",
    "missing": true
  },
  {
    "id": "stanley",
    "name": "Stanley",
    "ediDocs": [
      [
        "Release",
        "830",
        "09/25/2015",
        "PDF",
        "Stanley Electric 830 Guidelines.pdf"
      ],
      [
        "Advance Ship Notice",
        "856",
        "02/03/2017",
        "PDF",
        "Stanley Electric 856 Guidelines.pdf"
      ]
    ]
  },
  {
    "id": "stant",
    "name": "Stant Manufacturing, Inc.",
    "ediDocs": [
      [
        "Release",
        "830",
        "05/10/2002",
        "PDF",
        "Stant_830_4010.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "05/10/2002",
        "PDF",
        "Stant_850_4010.pdf"
      ],
      [
        "PO Acknowledgement",
        "855",
        "05/10/2002",
        "PDF",
        "Stant_855_4010.pdf"
      ],
      [
        "Ship Notice/Manifest",
        "856",
        "09/08/2011",
        "PDF",
        "Stant_856_4010.pdf"
      ],
      [
        "Purchase Order Change",
        "860",
        "05/10/2002",
        "PDF",
        "Stant_860_4010.pdf"
      ],
      [
        "PO Change Acknowledgement",
        "865",
        "05/10/2002",
        "PDF",
        "Stant_865_4010.pdf"
      ],
      [
        "Functional Acknowledgement",
        "997",
        "05/10/2002",
        "PDF",
        "Stant_997_4010.pdf"
      ]
    ]
  },
  {
    "id": "staples",
    "name": "Staples",
    "ediDocs": [
      [
        "Specs",
        "All Transactions",
        "",
        "PDF",
        "Staples EDI Guide 06-2010.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Star Furniture",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Starboard Industries",
    "missing": true
  },
  {
    "id": "steelparts",
    "name": "Steel Parts Manufacturing",
    "ediDocs": [
      [
        "Planning Schedule",
        "830",
        "02/01/2012",
        "PDF",
        "SteelParts_830_v1.0.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "02/01/2012",
        "PDF",
        "SteelParts_856_v1.0.pdf"
      ]
    ]
  },
  {
    "id": "steelcase",
    "name": "Steelcase",
    "imgFileName": "steelcase.bmp",
    "ediDocs": [
      [
        "Invoice   (3040)",
        "810",
        "3/28/2007",
        "PDF",
        "STEELi81034ANY_IG_v1.0.pdf"
      ],
      [
        "Purchase Order  (3050)",
        "850",
        "3/28/2007",
        "PDF",
        "STEELo85035ANY_IG_v0.5.pdf"
      ],
      [
        "Purchase Order Acknowledgement (3050)",
        "855",
        "3/28/2007",
        "PDF",
        "STEELi85535ANY_IG_v0.1[1].pdf"
      ],
      [
        "Shipment and Billing Notice (3050)",
        "857",
        "8/24/2007",
        "PDF",
        "STEELi85735ANY_IG_v2.pdf"
      ],
      [
        "Purchase Order Change Request-Buyer Initiated  (3050)",
        "860",
        "2/19/2007",
        "PDF",
        "STEELo86035ANY_IG_v0.2.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Stein Mart",
    "missing": true
  },
  {
    "id": "stoneridge",
    "name": "Stoneridge/Mothersson MSSL",
    "ediDocs": [
      [
        "Release",
        "830",
        "12/15/2008",
        "PDF",
        "SPEC_MSSL_AL830v4010otbd_2.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "01/03/2007",
        "PDF",
        "SPEC_MSSL_AL850v4010otbd_2.pdf"
      ],
      [
        "Plant Codes",
        "",
        "",
        "PDF",
        "MSSL EDI Setup Form V2.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Strategic Business Systems Inc.",
    "missing": true
  },
  {
    "id": "strattec",
    "name": "Strattec Security Corporation",
    "customMessage": true,
    "ediDocs": [
      [
        "Delivery Schedule Message",
        "DELFOR",
        "03/26/2009",
        "PDF",
        "Strattec_DELFOR_D97A.pdf"
      ],
      [
        "Release",
        "830",
        "03/01/1999",
        "PDF",
        "830_Version_4010.pdf"
      ],
      [
        "Shipping Notice",
        "856",
        "03/01/1999",
        "PDF",
        "856_Version_4010.pdf"
      ],
      [
        "Shipping Schedule",
        "862",
        "03/01/1999",
        "PDF",
        "862_Version_4010.pdf"
      ],
      [
        "Text Message",
        "864",
        "11/13/2008",
        "PDF",
        "iConnect_864_Text Message.pdf"
      ],
      [
        "Functional Acknowledgment",
        "997",
        "03/01/1999",
        "PDF",
        "997_Version_4010.pdf"
      ]
    ]
  },
  {
    "id": "stryker",
    "name": "Stryker Medical Portage Michigan",
    "customMessage": true,
    "imgFileName": "stryker.bmp",
    "ediDocs": [
      [
        "Remittance Advice",
        "820",
        "07/17/2006",
        "PDF",
        "SYK820spec.pdf"
      ],
      [
        "Application Advice",
        "824",
        "11/12/2008",
        "PDF",
        "SYK824spec.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "06/29/2026",
        "PDF",
        "Stryker_Medical_850_V4_Finalized.pdf"
      ],
      [
        "Purchase Order Acknowledgement",
        "855",
        "04/30/2026",
        "PDF",
        "Stryker_Medical_855_V4_Finalized.pdf"
      ],
      [
        "Advance Ship Notice",
        "856",
        "04/30/2026",
        "PDF",
        "Stryker_Medical_856_V4_Finalized.pdf"
      ],
      [
        "Purchase Order Change",
        "860",
        "08/05/2026",
        "PDF",
        "Stryker_Medical_860_V4_Finalized.pdf"
      ],
      [
        "Text Message",
        "864",
        "11/13/2008",
        "PDF",
        "SYK864spec.pdf"
      ],
      [
        "Purchase Order Change Acknowledgement",
        "865",
        "04/30/2026",
        "PDF",
        "Stryker_Medical_865_V4_Finalized.pdf"
      ],
      [
        "Functional Acknowledgement*",
        "997",
        "N/A",
        "",
        null
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Sturgis Molded Products",
    "missing": true
  },
  {
    "id": "subaru",
    "name": "Subaru",
    "imgFileName": "subaru.png",
    "ediDocs": [
      [
        "Subaru of America"
      ],
      [
        "Invoice",
        "810",
        "11/22/2013",
        "PDF",
        "Subaru X4010 810 Specifications v3.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "11/22/2013",
        "PDF",
        "Subaru X4010 856 Specifications v3.pdf"
      ],
      [
        "Subaru of Indiana"
      ],
      [
        "Invoice",
        "810",
        "",
        "PDF",
        "V4010-810-specs.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Sudan Corp",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Sumitomo",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Sumitomo Electric Wiring System",
    "missing": true
  },
  {
    "id": "summitpolymers",
    "name": "Summit Polymers",
    "ediDocs": [
      [
        "All Transactions",
        "DELFOR, DELJIT, DESADV, CONTRL",
        "04/01/2009",
        "PDF",
        "http://www.summitpolymers.com/files/SPI_EDI_Guidelines_CUMBASED.pdf"
      ]
    ]
  },
  {
    "id": "SuperStoreIndustries",
    "name": "Super Store Industries",
    "ediDocs": [
      [
        "Grocery Products Purchase Order",
        "875",
        "03/08/2010",
        "PDF",
        "SSI_Raleys_875_Purchase_Order_004010_UCS_Outbound.pdf.pdf"
      ],
      [
        "Grocery Products Invoice",
        "880",
        "07/06/2016",
        "PDF",
        "SSI_Raleys 880_Invoice_Inbound_004010_UCS.pdf"
      ]
    ]
  },
  {
    "id": "Superior",
    "name": "Superior Industries",
    "customMessage": true,
    "ediDocs": [
      [
        "Release",
        "830",
        "March 2023",
        "PDF",
        "Superior Industries_830 Planning Forecast_v4010_March 2023.pdf"
      ],
      [
        "Advance Ship Notice",
        "856",
        "March 2023",
        "PDF",
        "Superior Industries_856 Advanced Ship Notice_v4010_March 2023.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Supervalu, Inc.",
    "missing": true
  },
  {
    "id": "SupplyTechnologies",
    "name": "Supply Technologies",
    "imgFileName": "SupplyTechnologies.png",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "",
        "PDF",
        "EDI 810 Invoice Spec NEW Final 08082014.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "",
        "PDF",
        "856 Advance Ship Notice Specifications NEW FINAL 09022014.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Sur La Table",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Suspa, Inc.",
    "missing": true
  },
  {
    "id": "suzuki",
    "name": "Suzuki",
    "ediDocs": [
      [
        "Delivery Forecast & Despatch Advice",
        "DELFOR & DESADV",
        "05/07/2007",
        "PDF",
        "EDIFACT-GUIDErev2_1 200708.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "T & L Automatics, Inc.",
    "missing": true
  },
  {
    "id": "teamsystems",
    "name": "T.E.A.M. Systems",
    "ediDocs": [
      [
        "Release",
        "830",
        "04/11/2007",
        "PDF",
        "830_Specifications_4010.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "11/19/2007",
        "PDF",
        "856_Specifications_4010.pdf"
      ],
      [
        "Label Specifications",
        "N/A",
        "03/03/2008",
        "PDF",
        "TEAM_Systems-Supplier_Per_Part_Internal_Labeling_Specifications.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "TA America Corporation",
    "missing": true
  },
  {
    "id": "tacle",
    "name": "Tacle Seating",
    "customMessage": true,
    "ediDocs": [
      [
        "N/A",
        "EDI Info Form",
        "09/11/2007",
        "PDF",
        "TACLE_EDI_INFORMATION_FORM.pdf"
      ],
      [
        "830",
        "Release",
        "02/01/2007",
        "PDF",
        "B2_Supply_Chain_830_v4010.pdf"
      ],
      [
        "856",
        "Ship Notice",
        "01/14/2008",
        "PDF",
        "B2_Supply_Chain_856_v4010.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "TAF",
    "missing": true
  },
  {
    "id": "TALLERES",
    "name": "TALLERES MECANICOS MONTSERRAT",
    "customMessage": true,
    "imgFileName": "TALLERES.png",
    "ediDocs": [
      [
        "830",
        "Release",
        "10/01/2024",
        "PDF",
        "TALLERES MECANICOS MONTSERRAT_830_V1.pdf"
      ],
      [
        "856",
        "Ship Notice",
        "10/01/2024",
        "PDF",
        "TALLERES MECANICOS MONTSERRAT_856_V1.pdf"
      ]
    ]
  },
  {
    "id": "targetcanada",
    "name": "Target Canada",
    "ediDocs": [
      [
        "Domestic Spec's"
      ],
      [
        "Invoice",
        "810",
        "02/27/2013",
        "PDF",
        "GXS_TargetCanada_810_Domestic_v1.4.pdf"
      ],
      [
        "Remittance Advice",
        "820",
        "04/19/2012",
        "PDF",
        "GXS_TargetCanada_820_Domestic_v1.3.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "01/28/2013",
        "PDF",
        "GXS_TargetCanada_850_Domestic_v1.7.pdf"
      ],
      [
        "Purchase Order Change Request - Buyer Initiated",
        "860",
        "01/28/2013",
        "PDF",
        "GXS_TargetCanada_860_Domestic_v1.8.pdf"
      ],
      [
        "International Spec's"
      ],
      [
        "Invoice",
        "810",
        "02/27/2013",
        "PDF",
        "GXS_TargetCanada_810_International_v1.6.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "02/27/2013",
        "PDF",
        "GXS_TargetCanada_850_International_v1.7.pdf"
      ],
      [
        "Purchase Order Change Request - Buyer Initiated",
        "860",
        "02/27/2013",
        "PDF",
        "gxs_targetcanada_860_international_v1.8.pdf"
      ],
      [
        "Ship Notice's"
      ],
      [
        "International Ship Notice",
        "856",
        "01/23/2012",
        "PDF",
        "GXS_TargetCanada_856_International_v1.1.pdf"
      ],
      [
        "Distribution/Fulfillment Centers Ship Notice",
        "856",
        "01/27/2012",
        "PDF",
        "GXS_TargetCanada_856_Post_Distro_v1.2.pdf"
      ],
      [
        "Domestic Pre Distro Ship Notice",
        "856",
        "02/01/2012",
        "PDF",
        "GXS_TargetCanada_856_Pre_Distro_v1.3.pdf"
      ],
      [
        "Direct Store Delivery Ship Notice",
        "856",
        "01/31/2012",
        "PDF",
        "GXS_TargetCanada_856_Store_v1.2.pdf"
      ],
      [
        " General Spec's"
      ],
      [
        "Product Activity Data",
        "852",
        "02/02/2012",
        "PDF",
        "GXS_TargetCanada_852_v1.2.pdf"
      ],
      [
        "Text Message",
        "864",
        "02/28/2012",
        "PDF",
        "GXS_TargetCanada_864_Domestic_and_International_v1.2.pdf"
      ],
      [
        "Order Status Report",
        "870",
        "02/27/2013",
        "PDF",
        "GXS_TargetCanada_870_v1.2.pdf"
      ],
      [
        "Functional Acknowledgement",
        "997",
        "06/26/2012",
        "PDF",
        "TargetCanada 997 Domestic and International 1.1.pdf"
      ]
    ]
  },
  {
    "id": "target",
    "name": "Target Corporation",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Task Performance Group",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Taylor Steel",
    "missing": true
  },
  {
    "id": "missing",
    "name": "TBA - TMI",
    "missing": true
  },
  {
    "id": "TECUtility",
    "name": "TEC Utility Supply & Services",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "09/07/2017",
        "PDF",
        "TEC Utility Supply 810R Supplier 4010.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "09/07/2017",
        "PDF",
        "TEC Utility Supply 850S Supplier 4010.pdf"
      ],
      [
        "Purchase Order Acknowledgment",
        "855",
        "09/07/2017",
        "PDF",
        "TEC Utility Supply 855R Supplier 4010.pdf"
      ],
      [
        "Advanced Shipping Notice",
        "856",
        "09/07/2017",
        "PDF",
        "TEC Utility Supply 856R Supplier 4010.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Techform",
    "missing": true
  },
  {
    "id": "tedrive",
    "name": "Tedrive",
    "ediDocs": [
      [
        "Release",
        "VDA4905",
        "11/01/2007",
        "PDF",
        "VDA4905.pdf"
      ],
      [
        "Advance Shipping Note",
        "VDA4913",
        "11/01/2007",
        "PDF",
        "VDA4913.pdf"
      ],
      [
        "Daily Call-In",
        "VDA4915",
        "11/01/2007",
        "PDF",
        "VDA4915_V2.pdf"
      ]
    ]
  },
  {
    "id": "teleflex",
    "name": "Teleflex Automotive",
    "ediDocs": [
      [
        "Delivery Forecast",
        "EDLFOR",
        "05/08/2008",
        "PDF",
        "Teleflex_DELFOR_97A.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Temco USA",
    "missing": true
  },
  {
    "id": "tenneco",
    "name": "Tenneco",
    "ediDocs": [
      [
        "EDIFACT Transactions"
      ],
      [
        "Despatch Advice",
        "DESADV",
        "03/22/2012",
        "PDF",
        "NA_EDIFACT_DESADV_Specifications.pdf"
      ],
      [
        "Delivery Forecast",
        "DELFOR",
        "10/30/2015",
        "PDF",
        "TANA_EDIFACT_DELFOR_Specifications v1.1.pdf"
      ],
      [
        "ANSI 4010 Transactions"
      ],
      [
        "Release",
        "830",
        "",
        "PDF",
        "TANA830v9.1.pdf"
      ],
      [
        "Advanced Shipping Notice",
        "856",
        "",
        "PDF",
        "TANA856v5.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Termex Corporation",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Tesa Tape Inc",
    "missing": true
  },
  {
    "id": "teslamotors",
    "name": "Tesla Motors",
    "imgFileName": "teslamotors.bmp",
    "ediDocs": [
      [
        "EDI Information Guide and Sample Data",
        "N/A",
        "02/22/2012",
        "PDF",
        "Tesla_Motors_EDI_Information_Guidelines_and_Sample_Data_20120222.pdf"
      ],
      [
        "Invoice",
        "810",
        "02/20/2012",
        "PDF",
        "Tesla_810_Implementation_Guideline(New).pdf"
      ],
      [
        "Planning Schedule with Release",
        "830",
        "10/03/2011",
        "PDF",
        "Tesla_Motors_830_Imp_Guide_20111004.pdf"
      ],
      [
        "Ship Notice/Manifest",
        "856",
        "07/12/2013",
        "PDF",
        "Tesla_O_856_4010X_specification7_15.pdf"
      ],
      [
        "Shipping Schedule",
        "862",
        "10/02/2011",
        "PDF",
        "Tesla_Motors_862_Imp_Guide_20111004.pdf"
      ],
      [
        "Shipping Label Specification",
        "NA",
        "11/08/2011",
        "PDF",
        "Tesla_Shipping_Label_Specification_Rev3.pdf"
      ],
      [
        "ASN Looping Structure",
        "856",
        "",
        "PDF",
        "HL_Loops.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Texas Instruments",
    "missing": true
  },
  {
    "id": "textron",
    "name": "Textron Financial Services",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "03/23/2005",
        "PDF",
        "textron_810_4010.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "TF Warehousing",
    "missing": true
  },
  {
    "id": "missing",
    "name": "TFB & Associates",
    "missing": true
  },
  {
    "id": "missing",
    "name": "TG Automotive",
    "missing": true
  },
  {
    "id": "missing",
    "name": "The Bargain Shop",
    "missing": true
  },
  {
    "id": "TheOakwoodGroup",
    "name": "The Oakwood Group",
    "ediDocs": [
      [
        "Planning Schedule With Release Capability",
        "830",
        "06/03/2023",
        "PDF",
        "Oakwood EDI 830 Specifications v1.00.01.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "09/07/2023",
        "PDF",
        "Oakwood EDI 856 Specifications v2.00.05.pdf"
      ],
      [
        "Shipping Label Specification",
        "NA",
        "09/13/2024",
        "PDF",
        "Oakwood Carton Label Guideline 1.0.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Thermal Dynamics Inc.",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Thermotech C/O Menasha",
    "missing": true
  },
  {
    "id": "thyssenkrupp",
    "name": "Thyssen-Krupp",
    "ediDocs": [
      [
        "Supplier Survey",
        "N/A",
        "10/07/2010",
        "DOC",
        "Supplier EDI Questionnaire.doc"
      ],
      [
        "Guidelines for 830 Planning Schedule",
        "830",
        "02/05/2010",
        "PDF",
        "Supplier 830 EDI Implementation Guideline.pdf"
      ],
      [
        "Message Guideline ",
        "Delivery Forecast",
        "05/08/2010",
        "PDF",
        "TKAS_DELFOR_D97A_10.pdf"
      ],
      [
        "Message Guideline ",
        "Despatch Advice",
        "05/08/2010",
        "PDF",
        "TKAS_DESADV_D97A_10.pdf"
      ],
      [
        "Message Guideline ",
        "Invoice",
        "05/08/2010",
        "PDF",
        "TKAS_INVOIC_D97A_10.pdf"
      ],
      [
        "Delfor EDI Example ",
        "N/A",
        "N/A",
        "PDF",
        "delfor.pdf"
      ],
      [
        "INVOIC EDI Example",
        "N/A",
        "N/A",
        "PDF",
        "invoic.pdf"
      ]
    ]
  },
  {
    "id": "tiautomotive",
    "name": "TI Automotive",
    "ediDocs": [
      [
        "EDIFACT Transactions"
      ],
      [
        "Despatch Advice",
        "DESADV",
        "01/03/2012",
        "PDF",
        "DESADV D96A_TI Automotive.pdf"
      ],
      [
        "Delivery Forecast",
        "DELFOR",
        "01/11/2008",
        "PDF",
        "DELFOR D96A_TI Automotive_US.pdf"
      ],
      [
        "ANSI 4010 Transactions"
      ],
      [
        "Release",
        "830",
        "",
        "PDF",
        "TI_Automotive_830_v101.pdf"
      ],
      [
        "Advanced Shipping Notice",
        "856",
        "",
        "PDF",
        "TI_Automotive_x12_856.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "TI Group - Cartersville GA",
    "missing": true
  },
  {
    "id": "timcollc",
    "name": "Timco",
    "ediDocs": [
      [
        "Production Release Transaction Set (3010)",
        "830",
        "12/08/1995",
        "PDF",
        "830-3010.pdf"
      ],
      [
        "Advance Ship Notice (3010)",
        "856",
        "12/07/1995",
        "PDF",
        "856-3010.pdf"
      ],
      [
        "EDI Setup Request Form",
        "N/A",
        "09/24/2010",
        "DOC",
        "MTO EDI Request Form.doc"
      ],
      [
        "Schedule Print Form",
        "N/A",
        "N/A",
        "DOC",
        "5_5_3_8_Schedule_Print.doc"
      ]
    ]
  },
  {
    "id": "timken",
    "name": "Timken Company",
    "ediDocs": [
      [
        "Shipping Notice",
        "856",
        "07/17/2012",
        "PDF",
        "Specs856X12-V4010_Supplier.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "TISA",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Titeflex Corporation",
    "missing": true
  },
  {
    "id": "TJMAXX",
    "name": "TJ MAXX",
    "ediDocs": [
      [
        "Purchase Order",
        "850",
        "05/29/2008",
        "PDF",
        "TJMAXX_850_guideline.pdf.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "12/17/2004",
        "PDF",
        "TJMAXX_856_guideline.pdf.pdf"
      ],
      [
        "Purchase Order Change",
        "860",
        "12/02/2004",
        "PDF",
        "TJMAXX_860_guideline.pdf.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "TK Holdings",
    "missing": true
  },
  {
    "id": "tognum",
    "name": "Tognum",
    "imgFileName": "tognum.png",
    "ediDocs": [
      [
        "Application Advice",
        "824",
        "02/08/2013",
        "PDF",
        "Tognum America 824 Specifications (V06) 20130208.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "02/08/2013",
        "PDF",
        "Tognum America 856 Specifications (V07) 20130208.pdf"
      ],
      [
        "Shipping Schedule",
        "862",
        "02/08/2013",
        "PDF",
        "Tognum America 862 Specifications (V06) 20130208.pdf"
      ],
      [
        "Functional Acknowledgement",
        "997",
        "02/08/2013",
        "PDF",
        "Tognum America 997 Specifications (V04) 20130208.pdf"
      ]
    ]
  },
  {
    "id": "tokico",
    "name": "Tokico",
    "ediDocs": [
      [
        "Planning Schedule With Release Capability",
        "830",
        "03/01/1999",
        "PDF",
        "Tokico830.pdf"
      ],
      [
        "Ship Notice/Manifest",
        "856",
        "03/01/1999",
        "PDF",
        "Tokico856.pdf"
      ],
      [
        "Shipping Schedule",
        "862",
        "03/01/1999",
        "PDF",
        "Tokico862.pdf"
      ],
      [
        "Text Message",
        "864",
        "03/01/1999",
        "PDF",
        "Tokico864.pdf"
      ],
      [
        "Functional Acknowledgement",
        "997",
        "03/01/1999",
        "PDF",
        "Tokico997.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Tokico Inc.",
    "missing": true
  },
  {
    "id": "toledomoldingdie",
    "name": "Toledo Molding & Die",
    "ediDocs": [
      [
        "Release with Planning Capability",
        "830",
        "02/11/2010",
        "PDF",
        "TMD_830.pdf"
      ],
      [
        "Ship Notice/Manifest",
        "856",
        "02/11/2010",
        "PDF",
        "TMD_856.pdf"
      ],
      [
        "Shipping Schedule",
        "862",
        "02/11/2010",
        "PDF",
        "TMD_862.pdf"
      ]
    ]
  },
  {
    "id": "topco",
    "name": "Topco",
    "ediDocs": [
      [
        "Grocery Products Purchase Order",
        "875",
        "",
        "PDF",
        "TOPCO_OrderMapping.pdf.pdf"
      ],
      [
        "Grocery Products Invoice",
        "880",
        "",
        "PDF",
        "TOPCO_InvoiceMapping.pdf.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Topcraft Precision Molders Inc",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Toro Company",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Total Interior Systems - America",
    "missing": true
  },
  {
    "id": "towerautomotive",
    "name": "Tower Automotive",
    "ediDocs": [
      [
        "Ship Notice",
        "856",
        "03/01/2007",
        "PDF",
        "Tower_Automotive_856_V4010.pdf"
      ]
    ]
  },
  {
    "id": "toyoseatusa",
    "name": "Toyo Seat USA Corporation",
    "ediDocs": [
      [
        "Release",
        "830",
        "02/01/1998",
        "PDF",
        "AIAG_830.pdf"
      ]
    ]
  },
  {
    "id": "toyoda",
    "name": "Toyoda Gosei North America Corporation",
    "customMessage": true,
    "ediDocs": [
      [
        "Barcode Specs",
        "N/A",
        "07/01/2007",
        "PDF",
        "TGASK_Label_Requirements.pdf"
      ],
      [
        "Release",
        "830",
        "02/05/2008",
        "PDF",
        "Toyoda_830_4010_v1.1.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "01/25/2008",
        "PDF",
        "Toyoda_856_4010_v1.1.pdf"
      ],
      [
        "Shipping Schedule",
        "862",
        "01/25/2008",
        "PDF",
        "Toyoda_862_4010_v1.1.pdf"
      ]
    ]
  },
  {
    "id": "toyota",
    "name": "Toyota",
    "ediDocs": [
      [
        "Motor Manufacturing (TMM)"
      ],
      [
        "Invoice",
        "810",
        "07/26/2007",
        "PDF",
        "tmm/810.pdf"
      ],
      [
        "Remittance Advice",
        "820",
        "07/26/2007",
        "PDF",
        "tmm/820.pdf"
      ],
      [
        "Application Advice",
        "824",
        "07/26/2007",
        "PDF",
        "tmm/824.pdf"
      ],
      [
        "Release",
        "830",
        "07/26/2007",
        "PDF",
        "tmm/830.pdf"
      ],
      [
        "Shipping Notice",
        "856",
        "07/26/2007",
        "PDF",
        "tmm/856.pdf"
      ],
      [
        "Acceptance Certificate",
        "861",
        "07/26/2007",
        "PDF",
        "tmm/861.pdf"
      ],
      [
        "Shipping Schedule",
        "862",
        "07/26/2007",
        "PDF",
        "tmm/862.pdf"
      ],
      [
        "Functional Acknowledgement",
        "997",
        "07/26/2007",
        "PDF",
        "tmm/997.pdf"
      ],
      [
        "Motor Manufacturing Canada (TMMC)"
      ],
      [
        "Invoice",
        "810",
        "01/19/2010",
        "XLS",
        "tmmc/EDI_810_Invoice_Segment_layout.xls"
      ],
      [
        "Motor Sales (TMS)"
      ],
      [
        "Guide and Specs",
        "ALL",
        "11/01/2003",
        "PDF",
        "tms/TMS_EDI_Guidelines_1103.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "03/27/2007",
        "PDF",
        "tms/TMS_EDI_Guidelines-856_Advanced_Shipment_Notice _ASN_.pdf"
      ]
    ]
  },
  {
    "id": "toyotaboshoku",
    "name": "Toyota Boshoku",
    "ediDocs": [
      [
        "Multiple",
        "830, 856, 862, 997",
        "01/28/2015",
        "PDF",
        "TBA_EDI_Master_Supplier_Implementation_Manual_Ver_4.3.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Toyota Tshusho",
    "missing": true
  },
  {
    "id": "toyotetsu",
    "name": "Toyotetsu",
    "ediDocs": [
      [
        "Release",
        "830",
        "06/12/2002",
        "PDF",
        "Toyotetsu 830.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "06/12/2003",
        "PDF",
        "Toyotetsu 856.pdf"
      ],
      [
        "Shipping Schedule",
        "862",
        "06/12/2003",
        "PDF",
        "Toyotetsu 862.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "TOYS R US",
    "missing": true
  },
  {
    "id": "tractorsupply",
    "name": "Tractor Supply",
    "imgFileName": "tractorsupply.bmp",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "04/24/2013",
        "PDF",
        "TSC DSV 810V1R1.pdf"
      ],
      [
        "Inventory Inquiry/Advice",
        "846",
        "10/20/2014",
        "PDF",
        "TSC DSV 846V1R7.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "11/21/2014",
        "PDF",
        "TSC DSV 850V1R7.pdf"
      ],
      [
        "Purchase Order Acknowledgment",
        "855",
        "02/20/2014",
        "PDF",
        "TSC DSV 855V1R7.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "02/20/2014",
        "PDF",
        "TSC DSV 856V1R8.pdf"
      ],
      [
        "Purchase Order Change Request",
        "860",
        "07/16/2014",
        "PDF",
        "TSC DSV 860V1R1.pdf"
      ],
      [
        "Drop Ship FAQs",
        "N/A",
        "",
        "PDF",
        "TSC DSV FAQV1R4.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "TransNet Corporation",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Tri-Coastal Design/Loop Design",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Triangle",
    "missing": true
  },
  {
    "id": "tribar",
    "name": "Tribar",
    "ediDocs": [
      [
        "Advance Shipping Notice",
        "856",
        "05/06/2014",
        "PDF",
        "Tribar_EDI 856_Specifications_05-06-2014_Full_Details.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Trim Masters",
    "missing": true
  },
  {
    "id": "trimega",
    "name": "TriMega Purchasing Association",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "05/08/2008",
        "PDF",
        "tpa_member_810.pdf"
      ]
    ]
  },
  {
    "id": "trivium",
    "name": "Trivium",
    "ediDocs": [
      [
        "Warehouse Stock Transfer Receipt Advice",
        "944",
        "",
        "PDF",
        "944.pdf"
      ],
      [
        "Warehouse Shipping Advise ",
        "945",
        "",
        "PDF",
        "945.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Trostel Seg, Inc.",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Tru Serv Ca",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Tru-Form",
    "missing": true
  },
  {
    "id": "truserv",
    "name": "True Value Corporation",
    "ediDocs": [
      [
        "Introduction Manual",
        "",
        "03/20/2001",
        "PDF",
        "ntroman.pdf"
      ],
      [
        "Invoice",
        "810",
        "01/6/2012",
        "PDF",
        "810-new.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "12/14/2010",
        "PDF",
        "850O-4010_VNDR.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "02/25/2011",
        "PDF",
        "856I-4010_VNDR.pdf"
      ],
      [
        "TruServ"
      ],
      [
        "Invoice",
        "810",
        "01/08/2003",
        "PDF",
        "TruServ_810_v4010.pdf"
      ]
    ]
  },
  {
    "id": "trwautomotive",
    "name": "TRW Automotive",
    "ediDocs": [
      [
        "Despatch Advice",
        "DESADV",
        "10/28/2002",
        "PDF",
        "TRW_DESADV_Spec.pdf"
      ],
      [
        "Label Specification",
        "N/A",
        "03/01/2003",
        "PDF",
        "TRW_North_American_Label_Spec_2003-03-1_JC_Rev.pdf"
      ],
      [
        "Linkage and Suspension Division"
      ],
      [
        "Application Advice, Release, Ship Notice",
        "824, 830, 856",
        "04/07/2006",
        "PDF",
        "TRW_LS_Supplier_Specs.pdf"
      ],
      [
        "Chassis Division"
      ],
      [
        "Release",
        "830",
        "01/27/2000",
        "PDF",
        "TRW_830-3040.pdf"
      ],
      [
        "Functional Acknowledgement",
        "997",
        "01/27/2000",
        "PDF",
        "TRW_997-3040.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "TS Tech",
    "missing": true
  },
  {
    "id": "tsmcorp",
    "name": "TSM Corporation",
    "customMessage": true,
    "ediDocs": [
      [
        "Release",
        "830",
        "09/17/2014",
        "PDF",
        "TSM_Corporation_830_Implementation_Guide_Version_004010.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "02/04/2014",
        "PDF",
        "TSM_856_Specification.pdf"
      ],
      [
        "Label Specifications",
        "N/A",
        "03/04/2014",
        "PDF",
        "TSM_Label_Specifications.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "TTI Inc.",
    "missing": true
  },
  {
    "id": "missing",
    "name": "TW Metals",
    "missing": true
  },
  {
    "id": "tycoelectronics",
    "name": "Tyco Electronics",
    "ediDocs": [
      [
        "Purchase Order",
        "850",
        "06/20/2008",
        "PDF",
        "OUTbound-850_V-4010.pdf"
      ],
      [
        "Purchase Order Acknowledgement",
        "855",
        "06/20/2008",
        "PDF",
        "INBound-855_V-4010.pdf"
      ],
      [
        "Purchase Order Change Request",
        "860",
        "06/20/2008",
        "PDF",
        "OUTbound-860_V-4010.pdf"
      ],
      [
        "Purchase Order Change Acknowledgement",
        "865",
        "06/20/2008",
        "PDF",
        "INBound-865_V-4010.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "UAP",
    "missing": true
  },
  {
    "id": "ultramanufacturing",
    "name": "Ultra Manufacturing",
    "ediDocs": [
      [
        "Delivery Forecast",
        "DELFOR",
        "03/01/2016",
        "PDF",
        "Delivery Forecast - DELFOR SPEC (2).pdf"
      ],
      [
        "Ship Schedule",
        "DELJIT",
        "03/01/2016",
        "PDF",
        "Ship Schedule - DELJIT SPEC.pdf"
      ],
      [
        "Despatch Advice",
        "DESADV",
        "11/25/2016",
        "PDF",
        "UMMP Despatch Advice - DESADV SPEC.pdf"
      ],
      [
        "Container Label Requirements",
        "",
        "11/13/2015",
        "PDF",
        "STD-006 Container_Label_Standard_v1.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Uni Boring Co. Inc.",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Uni Select",
    "missing": true
  },
  {
    "id": "unilever",
    "name": "Unilever",
    "ediDocs": [
      [
        "Inventory Advice",
        "846",
        "07/17/2015",
        "PDF",
        "Unilever 846 v1.pdf"
      ],
      [
        "Advance Ship Notice",
        "856",
        "07/22/2015",
        "PDF",
        "Unilever Inbound 856 v1.pdf"
      ],
      [
        "Item Maintenance",
        "888",
        "07/28/2014",
        "PDF",
        "Unilever 888 v1.pdf"
      ],
      [
        "Warehouse Shipping Order",
        "940",
        "07/23/2015",
        "PDF",
        "Unilever 940 v1.pdf"
      ],
      [
        "Warehouse Shipping Advice",
        "945",
        "07/17/2015",
        "PDF",
        "Unilever 945 v1.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Unipart Group",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Unique Fabricating",
    "missing": true
  },
  {
    "id": "unisia",
    "name": "Unisia of Georgia Corporation",
    "customMessage": true,
    "imgFileName": "unisia.gif",
    "ediDocs": [
      [
        "Release",
        "830",
        "03/05/2004",
        "PDF",
        "Unisia 830.pdf"
      ]
    ]
  },
  {
    "id": "unisource",
    "name": "Unisource",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "05/27/2008",
        "PDF",
        "Unisource_810_Requirements.pdf"
      ],
      [
        "Purchase Order Ack",
        "855",
        "08/12/2008",
        "PDF",
        "Unisource_855_Requirements.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "03/01/2008",
        "PDF",
        "Unisource 856-ASN Requirements-May_2008.pdf"
      ],
      [
        "Plant Locations",
        "N/A",
        "01/20/2004",
        "PDF",
        "ECOM_EDIDUNS.pdf"
      ],
      [
        "IMPLEMENTATION GUIDE",
        "N/A",
        "06/25/2008",
        "PDF",
        "EDI_StartUp_VENDORS_ENG.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "United Hardware",
    "missing": true
  },
  {
    "id": "missing",
    "name": "United Lighting",
    "missing": true
  },
  {
    "id": "missing",
    "name": "United Stationers Supply",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Universal Bearings, Inc.",
    "missing": true
  },
  {
    "id": "universallighting",
    "name": "Universal Lighting",
    "customMessage": true,
    "imgFileName": "universallighting.bmp",
    "ediDocs": [
      [
        "Application Advice",
        "824",
        "01/25/2012",
        "PDF",
        "Universal_Lighting_Technologies_824.pdf"
      ],
      [
        "Planning Schedule",
        "830",
        "01/09/2019",
        "PDF",
        "Universal_Lighting_Technologies_830_oracle.pdf"
      ],
      [
        "Inventory Advice",
        "846",
        "04/16/2013",
        "PDF",
        "Universal_Lighting_Technologies_846.pdf"
      ],
      [
        "Purchase Order ",
        "850",
        "02/07/2017",
        "PDF",
        "Universal_Lighting_Technologies_850_V2_1.pdf"
      ],
      [
        "Purchase Order Acknowledgement",
        "855",
        "09/27/2010",
        "PDF",
        "Universal_Lighting_Technologies_855.pdf"
      ],
      [
        "Advance Ship Notice",
        "856",
        "06/22/2012",
        "PDF",
        "Universal_Lighting_Technologies_856.pdf"
      ],
      [
        "Purchase Order Change",
        "860",
        "08/27/2014",
        "PDF",
        "Universal_Lighting_Technologies_860_Oracle.pdf"
      ],
      [
        "Shipping Schedule",
        "862",
        "04/16/2013",
        "PDF",
        "Universal_Lighting_Technologies_862_V1.2.pdf"
      ],
      [
        "Purchase Order Change Acknowledgement",
        "865",
        "09/27/2010",
        "PDF",
        "Universal_Lighting_Technologies_865.pdf"
      ],
      [
        "Warehouse Stock Transfer Receipt Advice",
        "944",
        "04/16/2013",
        "PDF",
        "Universal_Lighting_Technologies_944_V1.1.pdf"
      ],
      [
        "Warehouse Shipping Advice",
        "945",
        "04/16/2013",
        "PDF",
        "Universal_Lighting_Technologies_945_V1.1.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Universal Supply Group",
    "missing": true
  },
  {
    "id": "uhhs",
    "name": "University Hospital Health System",
    "ediDocs": [
      [
        "ISA Guidelines",
        "",
        "01/08/2000",
        "PDF",
        "UHHS Map Guide ISA.pdf"
      ],
      [
        "Invoice",
        "810",
        "05/08/2008",
        "PDF",
        "UHHS 810 Requirements.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "07/26/2000",
        "PDF",
        "UHHS Map Guide 850.pdf"
      ],
      [
        "Purchase Order Acknowledgment",
        "855",
        "06/08/2000",
        "PDF",
        "UHHS Map Guide 855.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "University of Michigan",
    "missing": true
  },
  {
    "id": "missing",
    "name": "University of Pennsylvania",
    "missing": true
  },
  {
    "id": "missing",
    "name": "UPG",
    "missing": true
  },
  {
    "id": "upsfreight",
    "name": "UPS Freight",
    "ediDocs": [
      [
        "Motor Carrier Bill Of Lading",
        "211",
        "07/16/2007",
        "PDF",
        "UPSFreight_211_4010.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "US Bearings and Drives",
    "missing": true
  },
  {
    "id": "missing",
    "name": "US Farathane",
    "missing": true
  },
  {
    "id": "missing",
    "name": "US Steel",
    "missing": true
  },
  {
    "id": "uss",
    "name": "United States Steel Corporation",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "04/19/2016",
        "PDF",
        "810_Invoice.pdf"
      ],
      [
        "Payment Order/Remittance Advice",
        "820",
        "04/19/2016",
        "PDF",
        "820_Payment_order_remittance_advice.pdf"
      ],
      [
        "Application Advice",
        "824",
        "04/15/2016",
        "PDF",
        "824_Application_Advice.pdf"
      ],
      [
        "Release",
        "830",
        "04/19/2016",
        "PDF",
        "830_Planning_Schedule_with_Release_Capability.pdf"
      ],
      [
        "Customer Purchase Order",
        "850",
        "09/15/2016",
        "PDF",
        "850_Customer_Purchase_Order.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "04/19/2016",
        "PDF",
        "850_Purchase_Order.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "04/15/2016",
        "PDF",
        "856_Ship_Notice_Manifest.pdf"
      ],
      [
        "Purchase Order Change Request",
        "860",
        "04/19/2016",
        "PDF",
        "860_Purchase_Order_Change_Request-Buyer Initiated.pdf"
      ],
      [
        "Receiving Advice",
        "861",
        "04/19/2016",
        "PDF",
        "861_Receiving_Advice.pdf"
      ],
      [
        "Shipping Schedule",
        "862",
        "04/19/2016",
        "PDF",
        "862_Shipping_Schedule.pdf"
      ],
      [
        "Report of Test Results",
        "863",
        "04/19/2016",
        "PDF",
        "863_Report_of_Test_Results.pdf"
      ],
      [
        "Order Status Report",
        "870",
        "08/18/2016",
        "PDF",
        "870_Order_Status_Report.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "USSC",
    "missing": true
  },
  {
    "id": "valeo",
    "name": "Valeo",
    "ediDocs": [
      [
        "All Transactions",
        "N/A",
        "12/11/2004",
        "WebSite",
        "http://www.esupply.valeo.com/processes.html"
      ],
      [
        "Delivery Schedule Message",
        "DELFOR",
        "12/11/2004",
        "PDF",
        "VALEO_NA_DELFOR_D96A_V3.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "12/11/2004",
        "PDF",
        "VALEO_NA_856_002040_ansix12.pdf"
      ]
    ]
  },
  {
    "id": "valmetautomotive",
    "name": "Valmet Automotive",
    "imgFileName": "valmetautomotive.bmp",
    "ediDocs": [
      [
        "Despatch Advice",
        "AVIEXP (v3)",
        "02/18/2010",
        "PDF",
        "Valmet Fisker Karma Aviexp3_040.pdf"
      ],
      [
        "Delivery Instruction",
        "DELINS (v3)",
        "02/12/2010",
        "PDF",
        "Valmet Fisker Karma Delins3_040.pdf"
      ]
    ]
  },
  {
    "id": "vanrob",
    "name": "Van-Rob",
    "imgFileName": "vanrob.bmp",
    "ediDocs": [
      [
        "Combined X12 (Release 4010) Specifications",
        "All",
        "01/01/2010",
        "PDF",
        "http://supplier.van-rob.com/supplyWeb/pdf/SupplyWEB_X12_Files.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Vantage Custom Classics",
    "missing": true
  },
  {
    "id": "vascorlogistics",
    "name": "VASCOR Logistics",
    "ediDocs": [
      [
        "Release",
        "830",
        "07/13/2011",
        "PDF",
        "VASCOR Logistics 830 Spec.pdf"
      ],
      [
        "Advanced Ship Notice",
        "856",
        "11/22/2011",
        "PDF",
        "VASCOR Logistics 856 Spec.pdf"
      ],
      [
        "Shipping Schedule",
        "862",
        "11/07/2011",
        "PDF",
        "VASCOR Logistics 862 Spec.pdf"
      ],
      [
        "Functional Acknowledgement",
        "997",
        "07/13/2011",
        "PDF",
        "VASCOR Logistics 997 Spec.pdf"
      ],
      [
        "EDI Implementation Guide",
        "",
        "11/04/2011",
        "PDF",
        "EDI Implementation Guide for Hino Truck plants.pdf"
      ]
    ]
  },
  {
    "id": "vdlnedcar",
    "name": "VDL Nedcar",
    "ediDocs": [
      [
        "Release",
        "DELFOR",
        "July 2014",
        "PDF",
        "NEDCAR 2 VDL Nedcar Specification DELFOR D96A july 2014.pdf"
      ],
      [
        "Advanced Ship Notice",
        "DESADV",
        "July 2014",
        "PDF",
        "NEDCAR 3 VDL Nedcar Specification DESADV-WH D96A july 2014.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Venchurs",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Venest Industries",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Ventra Belivdere",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Ventramex, S.A. de C.V.",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Venture Steel",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Verizon Wireless",
    "missing": true
  },
  {
    "id": "missing",
    "name": "VF Outlet",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Victor Reinz",
    "missing": true
  },
  {
    "id": "vipar",
    "name": "VIPAR",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "12/13/2002",
        "PDF",
        "Vipar_810_v3030.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "12/13/2002",
        "PDF",
        "Vipar_850_v3030.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Visiting Nurses Services",
    "missing": true
  },
  {
    "id": "visteon",
    "name": "Visteon Corporation",
    "ediDocs": [
      [
        "Supplier Documentation",
        "N/A",
        "11/13/2002",
        "PDF",
        "External Supplier EDI Documentation.pdf"
      ],
      [
        "Planning Schedule",
        "830",
        "09/11/2000",
        "PDF",
        "vist830ver4010pub.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "03/26/2008",
        "PDF",
        "CMMS_850_EDI_Guilelines_3060.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "09/21/2000",
        "PDF",
        "vist856ver4010pub.pdf"
      ],
      [
        "Functional Acknowledgment",
        "997",
        "10/16/2000",
        "PDF",
        "vist997ver4010pub.pdf"
      ],
      [
        "Delivery Forecast Message",
        "DELFOR",
        "07/29/2008",
        "PDF",
        "VQ_DELFOR_V2.1_20080729.pdf"
      ],
      [
        "Delivery Just in Time Message",
        "DELJIT",
        "10/07/2008",
        "PDF",
        "VQ_DELJIT_V2.1.2_20081007.pdf"
      ],
      [
        "Despatch Advice Message",
        "DESADV",
        "07/29/2008",
        "PDF",
        "VQ_DESADV_V2.0_20080729.pdf"
      ],
      [
        "Syntax and Service Report Message",
        "CONTRL",
        "01/07/2008",
        "PDF",
        "VQ_CONTR MESSAGEL_V1.0_20080107.pdf"
      ],
      [
        "Interchange Enveloping Instructions",
        "CTLSET",
        "06/25/2008",
        "PDF",
        "VQ_CTLSET_V1.1_20080625.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Visual Marking Systems",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Voestalpine Plynorm",
    "missing": true
  },
  {
    "id": "volkswagen",
    "name": "Volkswagen",
    "ediDocs": [
      [
        "VDA Specifications"
      ],
      [
        "Delivery Instruction",
        "4905",
        "07/01/1996",
        "PDF",
        "Delivery_Instruction_VDA_4905.PDF"
      ],
      [
        "Delivery Pre-advice NLK",
        "4905",
        "07/10/2009",
        "PDF",
        "Delivery_pre-advice_NLK_VDA_4905.pdf"
      ],
      [
        "Advanced Shipping Note",
        "4913",
        "11/06/2006",
        "PDF",
        "Advanced_Shipping_Note_ASN_VDA_4913.pdf"
      ],
      [
        "Packaging Structures In VW",
        "4913",
        "07/09/2009",
        "PDF",
        "Packaging_structures_in_VW_VDA_4913.pdf"
      ],
      [
        "Packaging Container Data at the Volkswagen BehÃ¤lter Management",
        "4927",
        "06/18/2008",
        "PDF",
        "Packaging_data_VDA_4927.pdf"
      ],
      [
        "Transport and Shipment Documents",
        "4939",
        "04/11/2005",
        "PDF",
        "Transport_and_Shipment_Documents_VDA_4939.pdf"
      ],
      [
        "Pick Up Sheet (PUS)",
        "4939",
        "04/15/2010",
        "PDF",
        "pick_up_sheet.pdf"
      ],
      [
        "EDIFACT Specifications"
      ],
      [
        "Global Transport Label (GTL)",
        "N/A",
        "08/27/2010",
        "PDF",
        "Global_Transport_Label_GTL.pdf"
      ],
      [
        "Delivery Schedule Message (FAB)",
        "DELFOR",
        "01/04/2006",
        "PDF",
        "Daily_call-off_FAB_EDIFACT_DELFOR.pdf"
      ],
      [
        "Delivery Schedule Message (LAB)",
        "DELFOR",
        "10/05/2010",
        "PDF",
        "Forecast_delivery_schedule_LAB_EDIFACT_DELFOR.pdf"
      ],
      [
        "Delivery Pre-advice (NLK)",
        "DELFOR",
        "07/10/2009",
        "PDF",
        "Delivery_pre-advice_NLK_EDIFACT_DELFOR.pdf"
      ],
      [
        "Delivery Just In Time (Instruction)",
        "DELJIT",
        "11/30/2007",
        "PDF",
        "OT-Direct_delivery_instruction_EDIFACT_DELJIT.pdf"
      ],
      [
        "Delivery Just In Time (Kanban Message)",
        "DELJIT",
        "08/09/2001",
        "PDF",
        "Kanban-message_EDIFACT_DELJIT.pdf"
      ],
      [
        "Delivery Just In Time (VAB)",
        "DELJIT",
        "04/04/2003",
        "PDF",
        "AMES-T_dispatch_call-off_VAB_EDIFACT_DELJIT.pdf"
      ],
      [
        "Just In Time Call-off Data (Ver 2)",
        "DELJIT",
        "03/23/2001",
        "PDF",
        "JiT-Abrufdaten_EDIFACT_DELJIT_SYNCRO.pdf"
      ],
      [
        "Just In Time Call-off Data (Ver 3)",
        "DELJIT",
        "01/23/2009",
        "PDF",
        "JiT-call-off_data_EDIFACT_DELJIT_SYNCRO_V3.pdf"
      ],
      [
        "Just In Time Call-off Data (Ver 4)",
        "DELJIT",
        "03/25/2010",
        "PDF",
        "JiT-call-off_data_EDIFACT_DELJIT_SYNCRO_V4.pdf"
      ],
      [
        "Just In Time Call-off (NLK Global)",
        "DELJIT",
        "09/23/2010",
        "PDF",
        "Dispatch_call-off_NLK_GLOBAL_DELJIT.pdf"
      ],
      [
        "Dispatch and Transport Data",
        "DESADV",
        "12/01/2010",
        "PDF",
        "Dispatch_and_transport_data_ASN_EDIFACT_DESADV.pdf"
      ],
      [
        "Package Structures In VW",
        "DESADV",
        "08/04/2009",
        "PDF",
        "Package_structures_in_VW_EDIFACT_DESADV.pdf"
      ],
      [
        "Pearl Chain Monitoring",
        "DESADV",
        "03/03/2010",
        "PDF",
        "Pearl_chain_monitoring_EDIFACT_DESADV.pdf"
      ],
      [
        "Daily Delivery Note TSL",
        "RECADV",
        "04/09/2010",
        "PDF",
        "Daily_delivery_note_TSL_EDIFACT_RECADV.pdf"
      ],
      [
        "VW Group",
        "DESADV",
        "28/03/2025",
        "PDF",
        "VDA4987_T2_Lieferavis_VWGroup_EN.pdf"
      ],
      [
        "Group of America"
      ],
      [
        "Application Error and Acknowledgement Message",
        "APERAK",
        "10/07/2010",
        "PDF",
        "EDI Specification APERAK.pdf"
      ],
      [
        "Syntax and Service Report Message",
        "CONTRL",
        "10/07/2010",
        "PDF",
        "EDI Specification CONTRL.pdf"
      ],
      [
        "Delivery Schedule Message",
        "DELFOR",
        "10/07/2010",
        "PDF",
        "EDI Specification DELFOR.pdf"
      ],
      [
        "Dispatch and Transport Data",
        "DESADV",
        "10/07/2010",
        "PDF",
        "EDI Specification DESADV.pdf"
      ],
      [
        "Invoice Message",
        "INVOIC",
        "10/07/2010",
        "PDF",
        "EDI Specification INVOIC.pdf"
      ],
      [
        "Purchase Order Message",
        "ORDERS",
        "10/07/2010",
        "PDF",
        "EDI Specification ORDERS.pdf"
      ],
      [
        "Samples"
      ],
      [
        "VW Group",
        "DESADV",
        "",
        "PDF",
        "DESADV_Review_sample.pdf"
      ]
    ]
  },
  {
    "id": "volvo",
    "name": "Volvo",
    "ediDocs": [
      [
        "Volvo Group Specifications"
      ],
      [
        "Invoice",
        "810",
        "08/16/2010",
        "PDF",
        "VolvoGroup/Volvo Group_810-AP.pdf"
      ],
      [
        "Invoice NAP",
        "810",
        "08/16/2010",
        "PDF",
        "VolvoGroup/Volvo Group_810-NAP.pdf"
      ],
      [
        "Remittance Advice",
        "820",
        "04/05/2020",
        "PDF",
        "VolvoGroup/Volvo Group_820.pdf"
      ],
      [
        "Application Advice",
        "824",
        "01/23/2020",
        "PDF",
        "VolvoGroup/VolvoGroup/Volvo Group_824.pdf"
      ],
      [
        "Maerial Release",
        "830",
        "08/16/2010",
        "PDF",
        "VolvoGroup/Volvo Group_830.pdf"
      ],
      [
        "Advance Ship Notice",
        "856",
        "04/23/2012",
        "PDF",
        "VolvoGroup/Volvo Group_856.pdf"
      ],
      [
        "Production Sequence",
        "866",
        "08/16/2010",
        "PDF",
        "VolvoGroup/Volvo Group_866.pdf"
      ],
      [
        "Mack Truck Specifications"
      ],
      [
        "Invoice",
        "810",
        "09/21/2004",
        "PDF",
        "MackTruck/Volvo MackTruck_810.pdf"
      ],
      [
        "Purchase Order (Blanket)",
        "850",
        "09/21/2004",
        "PDF",
        "http://www.volvoit.com/SiteCollectionDocuments/Volvo%20IT/edi/north_america/documents/TS850.pdf"
      ],
      [
        "Purchase Order (Stand-Alone)",
        "850",
        "09/21/2004",
        "PDF",
        "http://www.volvoit.com/SiteCollectionDocuments/Volvo%20IT/edi/north_america/documents/TS850standalone.pdf"
      ],
      [
        "Advance Ship Notice",
        "856",
        "03/26/2012",
        "PDF",
        "856-V200803-21 - MACK-VOLVO.pdf"
      ],
      [
        "Transport Label",
        "",
        "",
        "PDF",
        "Label SPECS MACK-VOLVO.pdf"
      ],
      [
        "Volvo Dealer Specifications"
      ],
      [
        "Invoice",
        "810",
        "08/15/2005",
        "PDF",
        "VolvoDealer/Volvo Dealer_810.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "08/15/2005",
        "PDF",
        "VolvoDealer/Volvo Dealer_850.pdf"
      ],
      [
        "Purchase Order Acknowledgment",
        "855",
        "02/09/2018",
        "PDF",
        "VolvoDealer/Volvo Dealer_855.pdf"
      ],
      [
        "Advance Ship Notice",
        "856",
        "08/15/2005",
        "PDF",
        "VolvoDealer/Volvo Dealer_856.pdf"
      ],
      [
        "Volvo Motor Grader Specifications"
      ],
      [
        "Purchase Order",
        "850",
        "04/05/2005",
        "PDF",
        "VolvoMotorGrader/Volvo Motor Grader_850.pdf"
      ],
      [
        "Volvo Group Asia Specifications"
      ],
      [
        "Delivery Forecast",
        "DELFOR",
        "11/02/2022",
        "PDF",
        "VolvoGroupAsia/Volvo Group Asia_DELFOR.pdf"
      ],
      [
        "Delivery Just In Time Message",
        "DELJIT",
        "07/01/2015",
        "PDF",
        "VolvoGroupAsia/Volvo Group Asia_DELJIT.pdf"
      ],
      [
        "Purchase Order Message",
        "ORDERS",
        "10/02/2018",
        "PDF",
        "VolvoGroupAsia/Volvo Group Asia_ORDERS.pdf"
      ],
      [
        "Purchase Order Change Request Message",
        "ORDCHG",
        "10/02/2018",
        "PDF",
        "VolvoGroupAsia/Volvo Group Asia_ORDCHG.pdf"
      ],
      [
        "Purchase Order Response Message",
        "ORDRSP",
        "10/02/2018",
        "PDF",
        "VolvoGroupAsia/Volvo Group Asia_ORDRSP.pdf"
      ],
      [
        "Despatch Advice",
        "DESADV",
        "04/12/2019",
        "PDF",
        "VolvoGroupAsia/Volvo Group Asia_DESADV.pdf"
      ],
      [
        "Invoice",
        "INVOIC",
        "08/15/2019",
        "PDF",
        "VolvoGroupAsia/Volvo Group Asia_INVOIC.pdf"
      ],
      [
        "Inventory Report Message",
        "INVRPT",
        "06/07/2021",
        "PDF",
        "VolvoGroupAsia/Volvo Group Asia_INVRPT.pdf"
      ],
      [
        "Application Error and Acknowledgement",
        "APERAK",
        "01/23/2020",
        "PDF",
        "VolvoGroupAsia/Volvo Group Asia_APERAK.pdf"
      ],
      [
        "Remittance Advise",
        "REMADV",
        "02/01/2021",
        "DOC",
        "VolvoGroupAsia/Volvo Group Asia_REMADV.doc"
      ],
      [
        "Transport Label",
        "",
        "12/15/2020",
        "PDF",
        "VolvoGroupAsia/Volvo Group Asia_TransortLabel.pdf"
      ],
      [
        "Volvo Cars (Europe) Specifications"
      ],
      [
        "Delivery Forecast",
        "DELFOR",
        "11/24/2015",
        "PDF",
        "Volvo Cars_DELFOR_D96A.pdf"
      ],
      [
        "Despatch Advice (D07A)",
        "DESADV",
        "10/17/2017",
        "PDF",
        "Volvo Cars_DESADV_D07A.pdf"
      ],
      [
        "Despatch Advice (D96A)",
        "DESADV",
        "05/01/2023",
        "PDF",
        "Volvo Cars_DESADV_D96A.pdf"
      ],
      [
        "Invoice",
        "INVOIC",
        "12/12/2015",
        "PDF",
        "Volvo Cars_INVOIC and SELFBILLED INVOIC.pdf"
      ],
      [
        "Delivery Instructions",
        "DELINS",
        "12/04/2015",
        "PDF",
        "Volvo Cars_DELINS.pdf"
      ],
      [
        "Additional Information",
        "AVIEXP",
        "05/01/2023",
        "PDF",
        "Volvo Cars_AVIEXP.pdf"
      ],
      [
        "Inventory Report Message",
        "INVRPT",
        "01/30/2018",
        "PDF",
        "Volvo Cars_INVRPT.pdf"
      ],
      [
        "Purchase Order Change Request Message",
        "ORDCHG",
        "12/13/2017",
        "PDF",
        "Volvo Cars_ORDCHG.pdf"
      ],
      [
        "Purchase Order Message",
        "ORDERS",
        "09/15/2020",
        "PDF",
        "Volvo Cars_ORDERS.pdf"
      ],
      [
        "Purchase Order Response Message",
        "ORDRSP",
        "12/13/2017",
        "PDF",
        "Volvo Cars_ORDRSP.pdf"
      ],
      [
        "Barcode",
        "",
        "07/01/2021",
        "PDF",
        "Volvo Cars_Barcode.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Vulcan Metal Stampings",
    "missing": true
  },
  {
    "id": "missing",
    "name": "VW",
    "missing": true
  },
  {
    "id": "wetautomotivesystems",
    "name": "W.E.T. Automotive Systems",
    "ediDocs": [
      [
        "Release",
        "830",
        "10/01/1999",
        "PDF",
        "4010_WET_830_Supplier_Standard.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "10/01/1999",
        "PDF",
        "4010_856_W.E.T._Specifications.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "W.W Grainger",
    "missing": true
  },
  {
    "id": "missing",
    "name": "WA Thomas",
    "missing": true
  },
  {
    "id": "missing",
    "name": "WAC South Carolina, Inc.",
    "missing": true
  },
  {
    "id": "wachovia",
    "name": "Wachovia Bank",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "01/01/2001",
        "PDF",
        "Wachovia 810 EDI specs.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "01/01/2001",
        "PDF",
        "Wachovia 850 EDI specs.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Wagon Automotive",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Wahler Automotive Systems",
    "missing": true
  },
  {
    "id": "wakeforest",
    "name": "Wake Forest University Baptist MC",
    "ediDocs": [
      [
        "Invoice",
        "810",
        "03/15/2002",
        "PDF",
        "WF_810_v4010_Imp_Guide.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "07/28/2003",
        "PDF",
        "WF_850_v4010_Imp_Guide.pdf"
      ],
      [
        "Purchase Order Acknowledgement",
        "855",
        "03/18/2002",
        "PDF",
        "WF_855_v4010_Imp_Guide.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Wakefern Foods",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Warren",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Waterville TG Inc.",
    "missing": true
  },
  {
    "id": "WBTL",
    "name": "WBTL-Bethel Automotive",
    "ediDocs": [
      [
        "Ship Notice",
        "856",
        "06/07/2024",
        "PDF",
        "WBTL_856_v1.0_06072024.pdf"
      ],
      [
        "Release",
        "830",
        "06/07/2024",
        "PDF",
        "WBTL_830_4010_06072024.pdf"
      ],
      [
        "WBTL_ Supplier_EDI Setup",
        "",
        "",
        "PDF",
        "WBTL_ Supplier_EDI Setup.pdf"
      ]
    ]
  },
  {
    "id": "webasto",
    "name": "Webasto Roof Systems, Inc., North America",
    "ediDocs": [
      [
        "EDIFACT Versions"
      ],
      [
        "Application Error and Acknowledgement",
        "APERAK",
        "02/21/2012",
        "PDF",
        "Webasto_Supplier_APERAK_Application_Error_and_Ack_Ver_1-3-20120221.pdf"
      ],
      [
        "Control Message",
        "CONTR",
        "02/21/2012",
        "PDF",
        "Webasto_Supplier_EDIFACT_CONTRL_Version_1-1_20120221.pdf"
      ],
      [
        "Despatch Advice Message",
        "DESADV",
        "11/18/2013",
        "PDF",
        "Webasto Supplier EDIFACT DESADV Version 1-6 20131118.pdf"
      ],
      [
        "Delivery Schedule Message",
        "DELFOR",
        "02/21/2012",
        "PDF",
        "Webasto_Supplier_EDIFACT_DELFOR_Version_1-1_20120221.pdf"
      ],
      [
        "Delivery Just In Time Message",
        "DELJIT",
        "02/21/2012",
        "PDF",
        "Webasto_Supplier_EDIFACT_DELJIT_Version_1-1_20120221.pdf"
      ],
      [
        "4010 Versions"
      ],
      [
        "Payment Remittance Message",
        "820",
        "02/21/2012",
        "PDF",
        "Webasto_Supplier_X12_820_Payment_Remittance_Version_1-2_20120221.pdf"
      ],
      [
        "Additional Information"
      ],
      [
        "Supplier EDIFACT Implementation Guidelines",
        "N/A",
        "02/21/2012",
        "PDF",
        "Webasto Supplier EDIFACT Implementation Guidelines Version 1-1 20120221.pdf"
      ]
    ]
  },
  {
    "id": "wegman",
    "name": "Wegman",
    "ediDocs": [
      [
        "Grocery Products Purchase Order",
        "875",
        "11/18/2010",
        "PDF",
        "WGMAN_UCS_875v4010_v1.2.pdf.pdf"
      ],
      [
        "Grocery Products Invoice",
        "880",
        "11/30/2010",
        "PDF",
        "WGMAN_UCS_880v4010_v1.2.pdf.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Wells Fargo",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Wescast United Machine",
    "missing": true
  },
  {
    "id": "missing",
    "name": "West Irvin Die Casting",
    "missing": true
  },
  {
    "id": "missing",
    "name": "West Kei",
    "missing": true
  },
  {
    "id": "westerndiversifiedplastics",
    "name": "Western Diversified Plastics",
    "ediDocs": [
      [
        "Release",
        "830",
        "02/10/2014",
        "PDF",
        "WesternDiversifiedPlastics_830_v1.0.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "02/10/2014",
        "PDF",
        "WesternDiversifiedPlastics_856_v1.0.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Western Grocer",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Westpoint Stevens",
    "missing": true
  },
  {
    "id": "wheeltime",
    "name": "Wheeltime",
    "ediDocs": [
      [
        "Purchase Order",
        "850",
        "01/02/2000",
        "PDF",
        "EDIPro850.pdf"
      ]
    ]
  },
  {
    "id": "whirlpool",
    "name": "Whirlpool",
    "ediDocs": [
      [
        "Application Advice",
        "824",
        "07/29/2002",
        "PDF",
        "Whirlpool_824_v4010.pdf"
      ],
      [
        "Planning Schedule with Release Capability",
        "830",
        "03/19/1998",
        "PDF",
        "Whirlpool830v3010.pdf"
      ],
      [
        "Ship Notice",
        "856",
        "03/14/2000",
        "PDF",
        "Whirlpool_856_v3010.pdf"
      ],
      [
        "Receiving Advice",
        "861",
        "12/10/1998",
        "PDF",
        "Whirlpool_861_v3010.pdf"
      ],
      [
        "Text Message",
        "864",
        "02/07/1997",
        "PDF",
        "Whirlpool_864_v3010.pdf"
      ],
      [
        "Guide",
        "",
        "01/09/2003",
        "PDF",
        "Whirlpool_Supplier_Guide.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Wickes",
    "missing": true
  },
  {
    "id": "missing",
    "name": "WinCo Foods LLC",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Windsor Machine",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Windsor Mold Group",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Winn-Dixie",
    "missing": true
  },
  {
    "id": "missing",
    "name": "WinRepSoftware",
    "missing": true
  },
  {
    "id": "missing",
    "name": "WITTE-Velbert GmbH & Co. KG",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Wolverine Coil Spring",
    "missing": true
  },
  {
    "id": "woodbridgefoam",
    "name": "Woodbridge Foam",
    "ediDocs": [
      [
        "Ship Notice",
        "856",
        "04/24/2001",
        "PDF",
        "WoodbridgeFoam_856.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Woodbridge Group",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Woodbridge-St. Pete",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Woodstock Stamping",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Worthington Steel",
    "missing": true
  },
  {
    "id": "missing",
    "name": "WP & RS Mars",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Wrico Stamping Co.",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Wright Tool",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Wynaldo Litho",
    "missing": true
  },
  {
    "id": "yazaki",
    "name": "Yazaki",
    "imgFileName": "yazaki.gif",
    "ediDocs": [
      [
        "Request to Become an EDI Trading Partner",
        "",
        "05/27/2003",
        "PDF",
        "Yazaki EDI TP Request Form.pdf"
      ],
      [
        "Interchange Control Structures",
        "ICS (4010)",
        "07/01/2001",
        "PDF",
        "Yazaki Interchange Control Structures.pdf"
      ],
      [
        "Interchange Control Structures",
        "ICS (5050)",
        "02/20/2009",
        "PDF",
        "YNA_x12_v5050_ICS_r03_m20090220.pdf"
      ],
      [
        "All v2040 Trasactions",
        "All (2040)",
        "12/01/2001",
        "PDF",
        "RPED1.pdf"
      ],
      [
        "Release",
        "830 (4010)",
        "07/01/2001",
        "PDF",
        "Yazaki 004010 830.pdf"
      ],
      [
        "Release",
        "830 (5050)",
        "08/16/2010",
        "PDF",
        "YNA_x12_v5050_830_r03_m20100816.pdf"
      ],
      [
        "Ship Notice",
        "856 (4010)",
        "03/01/2002",
        "PDF",
        "Yazaki 004010 856.pdf"
      ],
      [
        "Ship Notice",
        "856 (5050)",
        "06/11/2009",
        "PDF",
        "YNA_x12_v5050_856_r03_m20090611.pdf"
      ],
      [
        "Functional Acknowledgement",
        "997 (5050)",
        "02/20/2009",
        "PDF",
        "YNA_x12_v5050_997_r03_m20090220.pdf"
      ],
      [
        "V5050 Document Revisions",
        "N/A (5050)",
        "06/11/2009",
        "PDF",
        "YNA_x12_v5050_EDI Documents Revisions List - 20090611.pdf"
      ]
    ]
  },
  {
    "id": "yokohama",
    "name": "Yokohama",
    "ediDocs": [
      [
        "824",
        "Application Advice",
        "10/13/2014",
        "PDF",
        "Yokohama Industries Americas 824.pdf"
      ],
      [
        "830",
        "Release",
        "10/13/2014",
        "PDF",
        "Yokohama Industries Americas 830.pdf"
      ],
      [
        "856",
        "Ship Notice",
        "10/13/2014",
        "PDF",
        "Yokohama Industries Americas 856.pdf"
      ],
      [
        "862",
        "Shipping Schedule",
        "10/13/2014",
        "PDF",
        "Yokohama Industries Americas 862.pdf"
      ],
      [
        "Yokohama Industries Americas, Inc"
      ],
      [
        "N/A",
        "Supplier Information",
        "08/25/2010",
        "DOC",
        "YHAmerica/Supplier_Information.doc"
      ],
      [
        "824",
        "Application Advice",
        "09/01/2010",
        "PDF",
        "YHAmerica/YHAmerica_824.pdf"
      ],
      [
        "830",
        "Planning Schedule with Release Capability",
        "01/07/2011",
        "PDF",
        "YHAmerica/YHAmerica_830-3.pdf"
      ],
      [
        "856",
        "Ship Notice/Manifest",
        "06/28/2024",
        "PDF",
        "YHAmerica/Yokohama Industries Americas 856 V2.1.pdf"
      ],
      [
        "862",
        "Shipping Schedule",
        "01/07/2011",
        "PDF",
        "YHAmerica/YHAmerica_862-3.pdf"
      ],
      [
        "N/A",
        "Supplier Letter",
        "06/07/2010",
        "PDF",
        "YHAmerica/YH_supplierletter.pdf"
      ],
      [
        "SCAC Code List",
        "",
        "06/28/2024",
        "PDF",
        "YHAmerica/Yokohama_Approved_SCAC_Code_List.pdf"
      ]
    ]
  },
  {
    "id": "yokowo",
    "name": "Yokowo",
    "ediDocs": [
      [
        "830",
        "Release",
        "12/17/2007",
        "PDF",
        "LEXON-830-4010.pdf"
      ],
      [
        "856",
        "Ship Notice",
        "12/17/2007",
        "PDF",
        "LEXON-856-4010.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Zanini Tennessee, Inc.",
    "missing": true
  },
  {
    "id": "missing",
    "name": "Zatkoff Seals & Packings",
    "missing": true
  },
  {
    "id": "zeledyne",
    "name": "Zeledyne",
    "ediDocs": [
      [
        "830",
        "Release",
        "10/22/2014",
        "PDF",
        "Zeledyne_830_002001FORD.pdf"
      ],
      [
        "850",
        "Purchase Order",
        "10/22/2014",
        "PDF",
        "Zeledyne_850_004010.pdf"
      ],
      [
        "856",
        "Ship Notice",
        "10/22/2014",
        "PDF",
        "Zeledyne_856_002002FORD.pdf"
      ]
    ]
  },
  {
    "id": "missing",
    "name": "Zellers",
    "missing": true
  },
  {
    "id": "missing",
    "name": "ZF Batavia",
    "missing": true
  },
  {
    "id": "zfgroup",
    "name": "ZF Group",
    "vendorLink": "http://www.zf.com/corporate/en_de/company/company_profile_zf/divisions_business_units/purchasing_logistics/ebusiness/edi/guidelines_edi/guidelines_edi.html",
    "ediDocs": [
      [
        "Plant Codes",
        "N/A",
        "11/2015",
        "PDF",
        "ZF_Werke.pdf"
      ],
      [
        "Purchase Order Message",
        "ORDERS",
        "09/29/2009",
        "PDF",
        "ZF_ORDERSD97A_11.pdf"
      ],
      [
        "Delivery Schedule",
        "DELFOR",
        "10/07/2010",
        "PDF",
        "ZF_DELFOR_D97A17.pdf"
      ],
      [
        "Despatch Advice",
        "DESADV",
        "09/14/2009",
        "PDF",
        "ZF_DESADVD97A_13.pdf"
      ],
      [
        "Invoice Message",
        "INVOIC",
        "01/09/2013",
        "PDF",
        "ZF_VDA4938_GLOBAL_INVOIC_35_EN.pdf"
      ],
      [
        "Inventory Report Message",
        "INVRPT",
        "08/13/2013",
        "PDF",
        "ZF_INVRPTD97A_13.pdf"
      ],
      [
        "Delivery Just in Time Message",
        "DELJIT",
        "01/24/2008",
        "PDF",
        "ZF_DELJIT_D97A21.pdf"
      ]
    ]
  },
  {
    "id": "3m",
    "name": "3M",
    "ediDocs": [
      [
        "Canada"
      ],
      [
        "Invoice, Purchase Order and Text Message",
        "810, 850, 864",
        "08/01/2008",
        "PDF",
        "3M_Canada_EDI_User_Guide_March09.pdf"
      ],
      [
        "United States"
      ],
      [
        "ALL Specs",
        "All",
        "08/07/2007",
        "Web Site",
        "http://www.3m.com/us/about3m/ec/edi_guidelines.html"
      ],
      [
        "Invoice",
        "810",
        "10/29/1999",
        "PDF",
        "http://www.3m.com/us/about3m/ec/guidelines/810.pdf"
      ],
      [
        "Remittance Advice",
        "820",
        "10/19/1999",
        "PDF",
        "http://www.3m.com/us/about3m/ec/guidelines/820.pdf"
      ],
      [
        "Purchase Order",
        "850",
        "10/12/1999",
        "PDF",
        "http://www.3m.com/us/about3m/ec/guidelines/850.pdf"
      ],
      [
        "Purchase Order Acknowledgment",
        "855",
        "10/22/1999",
        "PDF",
        "http://www.3m.com/us/about3m/ec/guidelines/855.pdf"
      ],
      [
        "Ship Notice/Manifest",
        "856",
        "10/15/1999",
        "PDF",
        "http://www.3m.com/us/about3m/ec/guidelines/856.pdf"
      ]
    ]
  }
];
